
  (function(){
    if(window.ssCopy)return;
    var FLASH=1500;
    function host(btn){return (btn&&btn.closest('dialog[open]'))||document.body}
    function legacyCopy(text,btn){
      var ta=document.createElement("textarea"),active=document.activeElement;
      var selection=window.getSelection(),ranges=[];
      if(selection)for(var i=0;i<selection.rangeCount;i++)ranges.push(selection.getRangeAt(i));
      try{
        ta.value=text;ta.setAttribute("readonly","");
        ta.style.cssText="position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px";
        host(btn).appendChild(ta);ta.focus();ta.select();ta.setSelectionRange(0,text.length);
        return document.execCommand("copy");
      }catch(_){return false}
      finally{
        ta.remove();
        if(active&&active.focus)active.focus({preventScroll:true});
        if(selection){selection.removeAllRanges();ranges.forEach(function(r){selection.addRange(r)})}
      }
    }
    function manualCopy(text,btn){
      var previous=document.getElementById("ss-copy-manual");if(previous)previous.remove();
      var panel=document.createElement("div"),label=document.createElement("label");
      var field=document.createElement("textarea"),close=document.createElement("button");
      panel.id="ss-copy-manual";panel.setAttribute("role","region");panel.setAttribute("aria-label","Select and copy");
      panel.style.cssText="position:fixed;z-index:2147483647;bottom:16px;left:16px;width:calc(100% - 32px);max-width:560px;box-sizing:border-box;padding:16px;background:var(--ss-surface,#fff);color:var(--ss-text,#222);border:1px solid var(--ss-border-strong,#888);border-radius:10px;box-shadow:0 4px 24px #0004";
      label.textContent="Select and copy";field.value=text;field.readOnly=true;
      field.setAttribute("aria-label","Text to copy");field.style.cssText="display:block;box-sizing:border-box;width:100%;height:100px;margin:8px 0;font:16px monospace";
      close.type="button";close.textContent="Close";
      close.style.cssText="min-height:44px;padding:8px 16px;font:inherit;cursor:pointer";
      function dismiss(){panel.remove();if(btn&&btn.isConnected)btn.focus()}
      close.addEventListener("click",dismiss);
      panel.addEventListener("keydown",function(e){if(e.key==="Escape"){e.stopPropagation();dismiss()}});
      label.appendChild(field);panel.appendChild(label);panel.appendChild(close);host(btn).appendChild(panel);
      field.focus();field.select();field.setSelectionRange(0,text.length);
    }
    function flash(btn,ok,message){
      if(!btn)return;
      var live=btn.querySelector(".ss-copy-live"),lab=btn.querySelector(".ss-copy-label");
      var msg=message||(ok?(btn.getAttribute("data-copied-label")||"Copied"):"Select and copy");
      if(!btn.__ssCopyState){
        if(lab)btn.__ssCopyState={label:lab,text:lab.textContent};
        // An icon-only copy button confirms with its own check glyph and live region.
        else if(btn.querySelector(".ss-copy-ic"))btn.__ssCopyState={};
        else{
          var nodes=Array.from(btn.childNodes);nodes.forEach(function(n){n.remove()});
          lab=document.createElement("span");lab.setAttribute("role","status");btn.appendChild(lab);
          btn.__ssCopyState={label:lab,nodes:nodes};
        }
      }
      if(btn.__ssCopyState.label)btn.__ssCopyState.label.textContent=msg;
      if(live)live.textContent=msg;
      btn.classList.remove("is-copied","is-failed");btn.classList.add(ok?"is-copied":"is-failed");
      clearTimeout(btn.__ssCopyTimer);
      btn.__ssCopyTimer=setTimeout(function(){
        var state=btn.__ssCopyState;
        if(state.nodes){state.label.remove();state.nodes.forEach(function(n){btn.appendChild(n)})}
        else if(state.label)state.label.textContent=state.text;
        btn.__ssCopyState=null;btn.classList.remove("is-copied","is-failed");
        if(live)live.textContent="";
      },FLASH);
    }
    // Invoke in the click task. Promise text uses ClipboardItem immediately so
    // Safari can retain activation while a frame export or link request resolves.
    window.ssCopy=function(text,btn){
      function finish(ok){flash(btn,ok);return ok}
      function fallback(value){
        var ok=legacyCopy(value,btn);finish(ok);
        if(!ok)manualCopy(value,btn);
        return ok;
      }
      if(text&&typeof text.then==="function"){
        var ready=Promise.resolve(text).then(function(value){
          value=String(value==null?"":value);if(!value)throw new Error("empty");return value;
        });
        function failed(){return ready.then(fallback,function(){flash(btn,false,"Could not prepare text");return false})}
        if(navigator.clipboard&&navigator.clipboard.write&&window.ClipboardItem){
          var blob=ready.then(function(value){return new Blob([value],{type:"text/plain"})});blob.catch(function(){});
          try{return Promise.resolve(navigator.clipboard.write([new ClipboardItem({"text/plain":blob})])).then(function(){return finish(true)},failed)}
          catch(_){return failed()}
        }
        return failed();
      }
      text=String(text==null?"":text);
      if(!text){flash(btn,false,"Nothing to copy");return Promise.resolve(false)}
      try{
        if(navigator.clipboard&&typeof navigator.clipboard.writeText==="function")
          return Promise.resolve(navigator.clipboard.writeText(text)).then(function(){return finish(true)},function(){return fallback(text)});
      }catch(_){}
      return Promise.resolve(fallback(text));
    };
    document.addEventListener("click",function(e){
      var btn=e.target&&e.target.closest?e.target.closest(".ss-copy"):null;
      if(!btn||btn.disabled)return;
      var sel=btn.getAttribute("data-copy-target");
      var text=btn.getAttribute("data-copy");
      // Neither attribute means the host wires this button itself — leave it alone
      // rather than flashing a failure over its own handler.
      if(sel==null&&text==null)return;
      if(sel!=null){
        var el=document.querySelector(sel);
        var field=el&&(el.tagName==="INPUT"||el.tagName==="TEXTAREA");
        text=el?(field?el.value:el.textContent):"";
      }
      window.ssCopy(text,btn);
    });
  })();
  
    // "Used up · back at 6:30 PM" for a plan model whose window ran out, in the
    // reader's own clock; tomorrow or later names the day.
    window.ssPillSpentNote = function(spent) {
      var at = spent && spent.frees_at;
      if (!at) return spent && spent.window === "month" ? "Used up for this month" : "Used up for now";
      var d = new Date(at), now = new Date();
      var t = d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
      if (d.toDateString() === now.toDateString()) return "Used up · back at " + t;
      var tm = new Date(now.getTime() + 864e5);
      if (d.toDateString() === tm.toDateString()) return "Used up · back tomorrow at " + t;
      return "Used up · back " + d.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });
    };
    // The same moment in a few words, for the right side of a model row ("back 4:10 PM").
    window.ssPillBackAt = function(spent) {
      var at = spent && spent.frees_at;
      if (!at) return spent && spent.window === "month" ? "out this month" : "used up";
      var d = new Date(at), now = new Date();
      var t = d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
      if (d.toDateString() === now.toDateString()) return "back " + t;
      var tm = new Date(now.getTime() + 864e5);
      if (d.toDateString() === tm.toDateString()) return "tmrw " + t;
      return "back " + d.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });
    };
    // One provider's rows in a model picker, from the server's providers list: its
    // models (a used-up one greyed, with when it's back on the same line), then any
    // borrowed key whose day is used up, tagged with whose key it is.
    window.ssPillModelItems = function(p, valueOf) {
      var models = (p.models && p.models.length) ? p.models : ((p.borrowed && p.borrowed.length) ? [] : [p.default_model]);
      var items = models.filter(Boolean).map(function(m) {
        var sp = p.spent || (p.spent_models && p.spent_models[m]);
        return sp ? { value: valueOf(p.id, m), label: m, disabled: true, aside: window.ssPillBackAt(sp), note: window.ssPillSpentNote(sp) } : { value: valueOf(p.id, m), label: m };
      });
      (p.borrowed || []).forEach(function(b, i) {
        var sp = { window: "day", frees_at: b.frees_at };
        items.push({ value: "borrowed:" + p.id + ":" + i, label: b.model, disabled: true, tag: b.group, aside: window.ssPillBackAt(sp), note: b.group + " · " + window.ssPillSpentNote(sp) });
      });
      return items;
    };
    // The meter at the top of a model picker for the picked value: the allowance that
    // model draws on (Auto: the default model's), how full it is or when it's back.
    // Null when it draws on none (a key of their own) — the menu then has no meter.
    window.ssPillMeterHead = function(allowance, providers, value) {
      if (!allowance || !allowance.meters) return null;
      var id = null;
      if (!value || value === "auto") id = allowance.auto;
      else {
        var i = value.indexOf(":"), pid = value.slice(0, i), m = value.slice(i + 1);
        (providers || []).forEach(function(p) { if (p && p.id === pid && p.meters && p.meters[m]) id = p.meters[m]; });
      }
      var mt = id && allowance.meters[id];
      if (!mt) return null;
      var when = { hour: "this hour", day: "today", month: "in 30 days" }[mt.window] || "";
      return { label: mt.label, text: mt.spent ? "Used up · " + window.ssPillBackAt(mt.spent) : mt.pct + "% used " + when, pct: mt.spent ? 100 : mt.pct, out: !!mt.spent, href: "/settings/ai-assistant" };
    };
    window.mountPillSelect = function(opts) {
      var root = typeof opts.root === "string" ? document.getElementById(opts.root) : opts.root;
      if (!root) return null;
      var trigger = root.querySelector(".ss-pill-select-trigger");
      var labelEl = root.querySelector(".ss-pill-select-label");
      var menu = root.querySelector(".ss-pill-select-menu");
      var setup = root.querySelector(".ss-pill-select-setup");
      if (!trigger || !labelEl || !menu) return null;
      var groups = opts.groups || [];
      var head = null;
      var baseTitle = trigger.getAttribute("title") || "";
      var footer = null;
      var value = opts.value || "";
      var active = -1;
      var flat = [];
      var loaded = false;

      function esc(s) {
        var d = document.createElement("div");
        d.textContent = s == null ? "" : String(s);
        return d.innerHTML;
      }
      function escA(s) { return esc(s).replace(/"/g, "&quot;"); }
      function findItem(v) {
        for (var g = 0; g < groups.length; g++) {
          var items = groups[g].items || [];
          for (var i = 0; i < items.length; i++) if (items[i].value === v && !items[i].disabled) return items[i];
        }
        return null;
      }
      function firstItem() {
        for (var g = 0; g < groups.length; g++) {
          var items = groups[g].items || [];
          for (var i = 0; i < items.length; i++) if (!items[i].disabled) return items[i];
        }
        return null;
      }
      function syncLabel() {
        var it = findItem(value) || firstItem();
        if (it) {
          value = it.value;
          labelEl.textContent = it.short != null ? it.short : it.label;
          trigger.setAttribute("aria-label", baseTitle + ": " + it.label);
        } else if (!loaded) {
          labelEl.textContent = "Loading…";
        } else {
          labelEl.textContent = "—";
        }
        if (window.requestAnimationFrame) requestAnimationFrame(titleTrigger); else titleTrigger();
      }
      // Text cut off with an ellipsis gets its whole self as a title, on hover: the
      // closed pill's label ("Au…") and, in the open menu, a row's model id or tag.
      function cut(el) { return !!el && el.scrollWidth > el.clientWidth + 1; }
      function titleTrigger() {
        var it = findItem(value);
        trigger.setAttribute("title", it && cut(labelEl) ? baseTitle + ": " + it.label : baseTitle);
      }
      function titleRows() {
        var rows = menu.querySelectorAll(".ss-pill-row");
        for (var i = 0; i < rows.length; i++) {
          var it = flat[parseInt(rows[i].getAttribute("data-i"), 10)];
          if (!it) continue;
          var parts = rows[i].querySelectorAll(".ss-pill-label, .ss-pill-tag"), over = false;
          for (var j = 0; j < parts.length; j++) if (cut(parts[j])) over = true;
          if (over) rows[i].setAttribute("title", [it.label, it.tag && !(it.note && it.note.indexOf(it.tag) >= 0) ? it.tag : "", it.locked && it.badge ? it.badge + " plan" : "", it.note || it.aside].filter(Boolean).join(" · "));
          else rows[i].removeAttribute("title");
        }
        var hb = menu.querySelector(".ss-pill-head-line b");
        if (hb && head) { if (cut(hb)) hb.setAttribute("title", head.label); else hb.removeAttribute("title"); }
      }
      function syncState() {
        var has = groups.some(function(g) { return (g.items || []).some(function(it) { return !it.disabled; }); });
        root.classList.toggle("is-loading", !loaded);
        root.classList.toggle("is-ready", loaded && has);
        root.classList.toggle("is-empty", loaded && !has);
        menu.hidden = true;
        menu.classList.remove("open");
        root.classList.remove("open");
        trigger.setAttribute("aria-expanded", "false");
        return has;
      }
      function rebuildFlat() {
        flat = [];
        groups.forEach(function(g) { (g.items || []).forEach(function(it) { flat.push(it); }); });
      }
      function render() {
        rebuildFlat();
        if (!flat.length) {
          menu.innerHTML = '<div class="ss-pill-empty">No options</div>';
          active = -1;
          return;
        }
        if (active < 0) {
          for (var i = 0; i < flat.length; i++) if (flat[i].value === value) { active = i; break; }
          if (active < 0) active = 0;
        }
        var html = "";
        var idx = 0;
        // The meter (setHead): whose allowance the picked model draws on and how full
        // it is. Not a row: arrows and clicks pass it by.
        if (head) {
          html += '<div class="ss-pill-head' + (head.out ? " is-out" : "") + '"><div class="ss-pill-head-line"><b>' + esc(head.label) + '</b><span>' + esc(head.text) + '</span>'
            + (head.href ? '<a href="' + escA(head.href) + '" target="_blank" rel="noopener">Details</a>' : "")
            + '</div><div class="ss-pill-head-bar" role="meter" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + head.pct + '" aria-label="' + escA(head.label + ": " + head.text) + '"><i style="width:' + Math.max(0, Math.min(100, head.pct)) + '%"></i></div></div>';
        }
        groups.forEach(function(g) {
          if (!g.items || !g.items.length) return;
          html += g.divider ? '<div class="ss-pill-group is-divided">' : '<div class="ss-pill-group"><div class="ss-pill-group-hdr">' + esc(g.label) + '</div>';
          g.items.forEach(function(it) {
            var sel = it.value === value ? ' aria-selected="true"' : ' aria-selected="false"';
            var act = idx === active ? " active" : "";
            // A row that can't be picked right now (a used-up model) still shows,
            // greyed, with why under it — a missing row reads as "not on my plan".
            var off = it.disabled ? ' aria-disabled="true"' : "";
            var note = it.note ? '<span class="ss-pill-note">' + esc(it.note) + '</span>' : "";
            // A higher plan's model: its name, the plan, a lock. Nothing else.
            // A row with an aside or a tag stays one line: the label, whose key it is,
            // and on the right when it's back; the full note is read out instead.
            var split = !it.locked && (it.aside || it.tag);
            var body = it.locked
              ? '<span class="ss-pill-label">' + esc(it.label) + '</span>' + (it.badge ? '<span class="ss-pill-badge">' + esc(it.badge) + '</span>' : "") + '<span class="ss-pill-lock" aria-hidden="true">' + "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M16 12H17.4C17.7314 12 18 12.2686 18 12.6V19.4C18 19.7314 17.7314 20 17.4 20H6.6C6.26863 20 6 19.7314 6 19.4V12.6C6 12.2686 6.26863 12 6.6 12H8M16 12V8C16 6.66667 15.2 4 12 4C8.8 4 8 6.66667 8 8V12M16 12H8\"/></svg>" + '</span>'
              : split
                ? '<span class="ss-pill-label">' + esc(it.label) + '</span>' + (it.tag ? '<span class="ss-pill-tag">' + esc(it.tag) + '</span>' : "") + (it.aside ? '<span class="ss-pill-aside">' + esc(it.aside) + '</span>' : "")
                : esc(it.label) + note;
            var aria = it.locked && it.badge ? ' aria-label="' + esc(it.label + ", " + it.badge + " plan") + '"'
              : split ? ' aria-label="' + escA(it.label + ", " + (it.note || [it.tag, it.aside].filter(Boolean).join(", "))) + '"' : "";
            var row = '<button type="button" class="ss-pill-row' + act + (it.locked ? " is-locked" : "") + (split ? " is-split" : "") + '" role="option" data-i="' + idx + '"' + sel + off + aria + '>' + body + '</button>';
            // The pencil is a link beside the row, never inside it: a button can't hold one.
            html += it.editHref
              ? '<div class="ss-pill-line">' + row + '<a class="ss-pill-edit" href="' + escA(it.editHref) + '" target="_blank" rel="noopener" title="Edit ' + escA(it.label) + '" aria-label="Edit ' + escA(it.label) + '">' + "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M14.3632 5.65156L15.8431 4.17157C16.6242 3.39052 17.8905 3.39052 18.6716 4.17157L20.0858 5.58579C20.8668 6.36683 20.8668 7.63316 20.0858 8.41421L18.6058 9.8942M14.3632 5.65156L4.74749 15.2672C4.41542 15.5993 4.21079 16.0376 4.16947 16.5054L3.92738 19.2459C3.87261 19.8659 4.39148 20.3848 5.0115 20.33L7.75191 20.0879C8.21972 20.0466 8.65806 19.8419 8.99013 19.5099L18.6058 9.8942M14.3632 5.65156L18.6058 9.8942\"/></svg>" + '</a></div>'
              : row;
            idx++;
          });
          html += '</div>';
        });
        if (footer) html += '<a class="ss-pill-foot" href="' + escA(footer.href) + '" target="_blank" rel="noopener">' + "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M6 12H12M18 12H12M12 12V6M12 12V18\"/></svg>" + '<span>' + esc(footer.label) + '</span></a>';
        menu.innerHTML = html;
        menu.classList.toggle("has-head", !!head);
        if (isOpen()) fit();
      }
      function hl() {
        var rows = menu.querySelectorAll(".ss-pill-row");
        for (var i = 0; i < rows.length; i++) rows[i].classList.toggle("active", i === active);
        if (active >= 0 && rows[active] && rows[active].scrollIntoView) rows[active].scrollIntoView({ block: "nearest" });
      }
      function isOpen() { return menu.classList.contains("open"); }
      // Keep an open menu inside the viewport: never wider than it, and slid back in
      // when its anchor would put an edge past the screen's (a narrow drawer, a phone).
      // The edges that would cut it off: the viewport's, narrowed to the nearest box
      // around the picker that clips (Shepherd's drawer is a clip mask).
      function bounds() {
        var lo = 0, hi = document.documentElement.clientWidth || window.innerWidth;
        for (var el = root.parentElement; el && el !== document.body; el = el.parentElement) {
          var ov = getComputedStyle(el).overflowX;
          if (ov === "visible") continue;
          var b = el.getBoundingClientRect();
          lo = Math.max(lo, b.left); hi = Math.min(hi, b.right);
          break;
        }
        return { lo: lo, hi: hi };
      }
      // Keep an open menu inside those edges: never wider than the room between them,
      // and slid back in when its anchor would put an edge past one (a narrow drawer, a phone).
      function fit() {
        menu.style.transform = "";
        menu.style.maxWidth = "";
        menu.style.minWidth = "";
        var e = bounds(), pad = 8, room = e.hi - e.lo - 2 * pad;
        if (menu.getBoundingClientRect().width > room) { menu.style.maxWidth = room + "px"; menu.style.minWidth = "0"; }
        var r = menu.getBoundingClientRect(), dx = 0;
        if (r.left < e.lo + pad) dx = e.lo + pad - r.left;
        else if (r.right > e.hi - pad) dx = e.hi - pad - r.right;
        if (dx) menu.style.transform = "translateX(" + Math.round(dx) + "px)";
        titleRows();
      }
      function open() {
        if (!loaded) return;
        rebuildFlat();
        if (!flat.length) return;
        render();
        // One pill menu open at a time: opening this one closes whichever was open.
        if (window.__ssPillClose && window.__ssPillClose !== close) window.__ssPillClose();
        window.__ssPillClose = close;
        menu.hidden = false;
        menu.classList.add("open");
        root.classList.add("open");
        trigger.setAttribute("aria-expanded", "true");
        fit();
      }
      function close() {
        if (window.__ssPillClose === close) window.__ssPillClose = null;
        menu.classList.remove("open");
        menu.hidden = true;
        root.classList.remove("open");
        trigger.setAttribute("aria-expanded", "false");
        active = -1;
      }
      function toggle() { if (isOpen()) close(); else open(); }
      function pick(i) {
        var it = flat[i];
        if (it && it.locked && opts.onLocked) opts.onLocked(it);
        if (!it || it.disabled) return;
        value = it.value;
        syncLabel();
        if (opts.storageKey) { try { localStorage.setItem(opts.storageKey, value); } catch (e) {} }
        close();
        if (opts.onChange) opts.onChange(it);
      }
      function setGroups(next, preferred, foot) {
        loaded = true;
        groups = next || [];
        footer = foot && foot.href ? foot : null;
        if (preferred && findItem(preferred)) value = preferred;
        else if (opts.storageKey) {
          try {
            var saved = localStorage.getItem(opts.storageKey);
            if (saved && findItem(saved)) value = saved;
          } catch (e) {}
        }
        if (!findItem(value)) {
          var f = firstItem();
          value = f ? f.value : "";
        }
        syncState();
        syncLabel();
        if (isOpen()) render();
      }

      trigger.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggle();
      });
      trigger.addEventListener("keydown", function(e) {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
          e.preventDefault();
          if (!isOpen()) open();
          else if (e.key === "ArrowDown") { active = (active + 1) % Math.max(flat.length, 1); hl(); }
          else { active = (active - 1 + flat.length) % Math.max(flat.length, 1); hl(); }
        } else if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (!isOpen()) open();
          else if (active >= 0) pick(active);
        } else if (e.key === "Escape" && isOpen()) { e.preventDefault(); close(); }
      });
      menu.addEventListener("click", function(e) {
        if (e.target && e.target.closest && e.target.closest(".ss-pill-edit, .ss-pill-head a")) { close(); return; }
        if (e.target && e.target.closest && e.target.closest(".ss-pill-foot")) {
          var f = footer;
          if (f && f.track && window.mixpanel) window.mixpanel.track(f.track, f.props || {});
          close();
          if (f && f.onClick) { e.preventDefault(); f.onClick(); }
          return;
        }
        var row = e.target && e.target.closest ? e.target.closest(".ss-pill-row") : null;
        if (!row) return;
        e.preventDefault();
        e.stopPropagation();
        pick(parseInt(row.getAttribute("data-i"), 10));
      });
      document.addEventListener("click", function(e) {
        if (!isOpen()) return;
        if (root.contains(e.target)) return;
        close();
      });
      document.addEventListener("keydown", function(e) {
        if (e.key === "Escape" && isOpen()) close();
      });
      window.addEventListener("resize", function() { titleTrigger(); if (isOpen()) fit(); });

      // Stay in loading state until the page calls setGroups with real options.
      syncState();
      syncLabel();
      return {
        getValue: function() { return value; },
        setValue: function(v) { if (findItem(v)) { value = v; syncLabel(); } },
        setGroups: setGroups,
        setHead: function(h) { head = h || null; if (isOpen()) render(); },
        close: close,
        open: open,
      };
    };
  
  window.ssNewDesign = window.ssNewDesign || (function () {
    var loading = null;
    function load() {
      if (window.ssDesignCreate) return Promise.resolve();
      if (!loading) loading = new Promise(function (res, rej) {
        var s = document.createElement("script"); s.src = "/_s/design-create.2002598nust.js";
        s.onload = function () { window.ssDesignCreate ? res() : rej(new Error("design-create")); };
        s.onerror = function () { loading = null; rej(new Error("design-create")); };
        document.head.appendChild(s);
      });
      return loading;
    }
    return function (o) { return load().then(function () { return window.ssDesignCreate(o); }); };
  })();
  
    window.connectMoreLabel = function(open, n) {
      return open ? "Show fewer" : "+ Connect more (" + n + ")";
    };
    window.wireConnectMore = function(container, count) {
      if (!container) return;
      container.classList.remove("more-open");
      var btn = container.querySelector(".chip-more");
      if (!btn || !count) return;
      btn.textContent = window.connectMoreLabel(false, count);
      btn.setAttribute("aria-expanded", "false");
      btn.addEventListener("click", function() {
        var open = container.classList.toggle("more-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        btn.textContent = window.connectMoreLabel(open, count);
      });
    };
  
  (function(){
  if (window.ssLightbox) return;
  var box = null, img = null, closeBtn = null, lastFocused = null;
  var filePanel, fileTitle, download, content, pending = null, blobUrl = null, generation = 0;
  // Built once, on the first open. Before that a page carries no overlay DOM at all.
  function build(){
    if (box) return;
    box = document.createElement('div');
    box.className = 'ss-lb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Image preview');
    box.hidden = true;
    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'ss-lb-close';
    closeBtn.setAttribute('aria-label', 'Close image preview');
    closeBtn.textContent = '\u00d7';
    img = document.createElement('img');
    img.alt = '';
    box.appendChild(closeBtn);
    box.appendChild(img);
    filePanel = document.createElement('section');
    filePanel.className = 'ss-lb-file'; filePanel.hidden = true;
    var toolbar = document.createElement('div'); toolbar.className = 'ss-lb-toolbar';
    fileTitle = document.createElement('span'); fileTitle.className = 'ss-lb-title';
    download = document.createElement('a'); download.className = 'ss-lb-download';
    download.textContent = 'Download'; download.setAttribute('download', '');
    toolbar.appendChild(fileTitle); toolbar.appendChild(download);
    content = document.createElement('div'); content.className = 'ss-lb-content';
    filePanel.appendChild(toolbar); filePanel.appendChild(content); box.appendChild(filePanel);
    // The backdrop is the dismiss target; a click that lands on the picture itself
    // must not close it, which is what the cursor (zoom-out vs default) promises.
    box.addEventListener('click', function(e){ if (e.target === box) close(); });
    closeBtn.addEventListener('click', close);
    document.body.appendChild(box);
  }
  function open(src, alt){
    if (!src) return;
    build();
    resetFile();
    lastFocused = document.activeElement;
    img.hidden = false; filePanel.hidden = true;
    box.setAttribute('aria-label', 'Image preview');
    closeBtn.setAttribute('aria-label', 'Close image preview');
    img.setAttribute('src', src);
    img.setAttribute('alt', alt || 'Image preview');
    box.hidden = false;
    document.body.classList.add('ss-lb-open');
    closeBtn.focus();
    if (window.mixpanel) window.mixpanel.track('Attachment Preview Opened', {media_type: 'image', surface: 'lightbox'});
  }
  function resetFile(){
    generation++;
    if (pending) pending.abort();
    pending = null;
    if (content) content.replaceChildren();
    if (blobUrl) URL.revokeObjectURL(blobUrl);
    blobUrl = null;
  }
  function openFile(src, type, name){
    var url;
    try { url = new URL(src, location.href); } catch (_) { return; }
    if (url.origin !== location.origin || ['text/plain','text/markdown','application/pdf'].indexOf(type) < 0) return;
    build();
    resetFile();
    var current = generation;
    lastFocused = document.activeElement;
    img.hidden = true; img.removeAttribute('src'); filePanel.hidden = false;
    fileTitle.textContent = name || 'Document';
    download.href = url.href;
    box.setAttribute('aria-label', name || 'Document preview');
    closeBtn.setAttribute('aria-label', 'Close document preview');
    box.hidden = false; document.body.classList.add('ss-lb-open'); closeBtn.focus();
    var status = document.createElement('div'); status.className = 'ss-lb-status';
    status.setAttribute('role', 'status'); status.textContent = 'Loading document…'; content.appendChild(status);
    pending = new AbortController();
    fetch(url.href, {signal: pending.signal}).then(function(r){
      if (!r.ok) throw new Error('Unable to load this document.');
      return r.blob();
    }).then(function(blob){
      if (current !== generation) return;
      if (type === 'application/pdf'){
        blobUrl = URL.createObjectURL(new Blob([blob], {type: 'application/pdf'}));
        var frame = document.createElement('iframe');
        frame.title = name || 'PDF preview';
        frame.src = blobUrl;
        content.replaceChildren(frame);
        // The download stays available on browsers without an embedded PDF reader.
      } else {
        // A bounded source preview keeps large logs responsive; Download keeps the full file.
        return blob.slice(0, 1024 * 1024).text().then(function(text){
          if (current !== generation) return;
          var pre = document.createElement('pre'); pre.tabIndex = 0;
          pre.textContent = text;
          content.replaceChildren(pre);
          if (blob.size > 1024 * 1024){
            status.textContent = 'Showing the first 1 MB. Download to read the full file.';
            content.prepend(status);
          }
        });
      }
    }).catch(function(error){
      if (current !== generation || error.name === 'AbortError') return;
      status.textContent = 'Unable to preview this document. Try downloading it.';
      content.replaceChildren(status);
    });
    if (window.mixpanel) window.mixpanel.track('Attachment Preview Opened', {media_type: type});
  }
  function close(){
    if (!box || box.hidden) return;
    box.hidden = true;
    resetFile();
    document.body.classList.remove('ss-lb-open');
    // Dropped so a closed overlay holds no bytes, and so reopening cannot flash the
    // previous picture while the new one decodes.
    img.removeAttribute('src');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    lastFocused = null;
  }
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && box && !box.hidden) { e.preventDefault(); close(); }
    if (e.key === 'Tab' && box && !box.hidden) {
      var focusable = Array.from(box.querySelectorAll('button,a[href],iframe,[tabindex="0"]')).filter(function(el){ return el.getClientRects().length; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  // Delegated: the trigger may be the picture, or a link wrapping it (the feed's
  // anchors keep an href so the picture is still reachable with no JS — which is
  // exactly why this preventDefault only fires once an image was actually found).
  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var fileTrigger = t.closest('[data-lightbox-file]');
    if (fileTrigger && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey){
      e.preventDefault();
      openFile(fileTrigger.href, fileTrigger.getAttribute('data-lightbox-file'), fileTrigger.textContent);
      return;
    }
    var trigger = t.closest('[data-lightbox]');
    if (!trigger) return;
    var pic = trigger.tagName === 'IMG' ? trigger : trigger.querySelector('img');
    var src = pic && (pic.currentSrc || pic.getAttribute('src'));
    if (!src) return;
    e.preventDefault();
    open(src, pic.getAttribute('alt'));
  });
  window.ssLightbox = { open: open, close: close };
  window.ssLightbox.openFile = openFile;
})();
  (function(){
    var V=JSON.parse((document.currentScript&&document.currentScript.getAttribute("data-v"))||"{}"),spaceId=V.id;
    var chat=document.getElementById("chat"),handle=document.getElementById("chatHandle"),
        msgs=document.getElementById("chatMsgs"),compose=document.getElementById("chatCompose"),
        textEl=document.getElementById("chatText"),sendBtn=document.getElementById("chatSend"),
        toolRow=document.getElementById("chatToolRow"),editRow=document.getElementById("chatEditRow"),
        editToggle=document.getElementById("chatEdit"),closeBtn=document.getElementById("chatClose"),
        skelCompose=document.getElementById("chatComposeSkel"),noModelEl=document.getElementById("chatNoModel"),heldEl=document.getElementById("chatHeld");
    // Co-shepherd isn't rendered for an anonymous viewer (it edits the document on the
    // owner's own LLM key), so bail the way the version-history and notification IIFEs
    // already do rather than throwing on the first missing element.
    if(!chat||!handle||!msgs)return;
    // The thread draws faces now (participants, other people's messages, version
    // lines), and ssAvatar is a per-closure declaration — inline a copy here the
    // way the version-history IIFE does rather than reach across the boundary.
    var SS_AVATAR_COLORS=["#7a7aff","#ff6b6b","#51cf66","#ffd43b","#ff922b","#cc5de8","#22b8cf","#ff6b8a"];
function ssAvatarColor(seed){seed=String(seed==null?'':seed);for(var h=0,i=0;i<seed.length;i++)h+=seed.charCodeAt(i);return SS_AVATAR_COLORS[h%SS_AVATAR_COLORS.length]}
var SS_AVATAR_HOSTS=["spacesheep.dev","spacesheep.app","stagesheep.dev","stagesheep.com","localhost"],SS_AVATAR_PATH=/^\/avatar\/[A-Za-z0-9-]+$/;
function ssAvatarPhoto(url){url=String(url||'');if(url.charAt(0)==='/')return SS_AVATAR_PATH.test(url);if(url.indexOf('https://')!==0)return false;var u;try{u=new URL(url)}catch(e){return false}var h=u.hostname.toLowerCase().replace(/[.]+$/,''),ours=h==='127.0.0.1'||h==='[::1]'||h==='0.0.0.0';for(var i=0;!ours&&i<SS_AVATAR_HOSTS.length;i++){var d=SS_AVATAR_HOSTS[i];ours=h===d||h.slice(-d.length-1)==='.'+d}return !ours||(SS_AVATAR_PATH.test(u.pathname)&&!u.search&&!u.hash&&!u.username&&!u.password)}
function ssAvatarEsc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;')}
function ssAvatarInitial(name,seed){var s=String(name||seed||'?').trim().replace(/^@+ */,'')||'?',c='';try{var g=new Intl.Segmenter().segment(s)[Symbol.iterator]().next().value;c=g?g.segment:''}catch(e){}return (c||Array.from(s)[0]||'?').toUpperCase()}
function ssAvatar(o){o=o||{};
var cls='ss-av ss-av-'+(o.size||'md')+(o.team?' ss-av-team':'')+(o.className?' '+o.className:'');
var photo=ssAvatarPhoto(o.picture);
var inner=photo?'<img src="'+ssAvatarEsc(o.picture)+'" alt="" loading="lazy">':ssAvatarEsc(o.glyph||ssAvatarInitial(o.name,o.seed));
var style=(photo||o.glyph)?'':' style="background:'+ssAvatarColor(o.seed||o.name)+'"';
var id=o.id?' id="'+ssAvatarEsc(o.id)+'"':'';
return o.href?'<a class="'+cls+'"'+id+' href="'+ssAvatarEsc(o.href)+'"'+style+'>'+inner+'</a>':'<span class="'+cls+'"'+id+style+'>'+inner+'</span>'}
    var history=[],cfg=null,loaded=false,busy=false,open=false,savingFirst=false;
    
    function ssSidebarState(spaceId,panel){
      var key="ss-sidebar-"+spaceId+"-"+panel;
      return {
        read:function(){
          try{var value=localStorage.getItem(key);return value==="1"?true:value==="0"?false:null}catch(e){return null}
        },
        changed:function(open,source){
          if(source==="temporary")return;
          if(!source){try{localStorage.setItem(key,open?"1":"0")}catch(e){}}
          if(window.mixpanel)try{mixpanel.track(source==="restore"?"Viewer Sidebar Restored":open?"Viewer Sidebar Opened":"Viewer Sidebar Closed",{space_id:spaceId,panel:panel,open:open,source:source||"interaction"})}catch(e){}
        }
      };
    }

    var sidebarState=ssSidebarState(spaceId,"coshepherd");
    // Files on a message (space-chat-files.ts): each is uploaded the moment it lands
    // — picked, pasted or dropped — and waits in the composer as a chip; the send
    // names the keys and the server claims them for the message.
    var filesEl=document.getElementById("chatFiles"),fileErrEl=document.getElementById("chatFileErr"),
        attachBtn=document.getElementById("chatAttach"),fileInput=document.getElementById("chatFileInput"),
        panelEl=document.getElementById("chatPanel"),dropEl=document.getElementById("chatDrop");
    var MAX_FILES=6,MAX_FILE_BYTES=20971520,MAX_PDF_BYTES=41943040,pending=[],dragDepth=0;
    var TEXT_EXT=/^(txt|md|markdown|csv|tsv|json|html?|xml|ya?ml|log|ics|jsx?|tsx?|py|rb|go|rs|java|c|h|cpp|cs|css|sql|sh|toml|ini|swift|kt|php|r|tex)$/;
    // The type the server reads a file as. A browser names few text files (a .py is
    // often no type at all), so text goes by its extension too.
    function fileTypeOf(f){
      var t=String(f.type||"").toLowerCase(),ext=String(f.name||"").split(".").pop().toLowerCase();
      if(t==="image/jpg")t="image/jpeg";
      if(/^image\/(png|jpeg|webp|gif)$/.test(t))return t;
      // An SVG goes up as a PNG (ssRasterSvg): no model reads an SVG as a picture.
      if(t==="image/svg+xml"||ext==="svg")return "image/svg+xml";
      if(t==="application/pdf"||ext==="pdf")return "application/pdf";
      if(ext==="md"||ext==="markdown")return "text/markdown";
      if(ext==="csv")return "text/csv";
      if(ext==="json")return "application/json";
      if(/^text\//.test(t)||TEXT_EXT.test(ext))return "text/plain";
      return null;
    }
    function kindOf(type){return /^image\//.test(type)?"image":type==="application/pdf"?"pdf":"text"}
    function sizeLabel(n){return n>=1048576?(n/1048576).toFixed(1)+" MB":n>=1024?Math.round(n/1024)+" KB":n+" B"}
    function fileBadge(f){var e=String(f.name||"").split(".").pop();return f.kind==="pdf"?"PDF":(e&&e.length<=4&&e!==f.name?e.toUpperCase():"TXT")}
    // The thread's words for a message that is only files: the server's
    // filesPlaceholder, so a bubble can tell it from words someone wrote.
    function filesPlaceholder(fs){return ("📎 "+fs.map(function(f){return f.name}).join(", ")).slice(0,400)}
    function filesOnly(m){return !!(m.files&&m.files.length&&m.content===filesPlaceholder(m.files))}
    function fileUrl(k){return "/api/space/"+encodeURIComponent(spaceId)+"/ai/files/"+encodeURIComponent(k)}
    function showFileErr(t){if(!fileErrEl)return;fileErrEl.textContent=t||"";fileErrEl.hidden=!t}
    function uploading(){return pending.some(function(p){return !p.key})}
    // Words or a file that is up, and nothing still on its way.
    function canSendNow(){return (!!textEl.value.trim()||pending.some(function(p){return p.key}))&&!uploading()}
    // A send never has to be refused for timing: while one would have to wait, the
    // button queues it instead (see the queue below), and says so.
    function syncSend(){
      var w=mustWait(),other=!!(cfg&&cfg.can_edit&&turnHolder&&turnHolder.seed!==ME);
      sendBtn.disabled=!canSendNow();
      var lbl=w?"Queue":"Send";
      if(sendBtn.getAttribute("aria-label")!==lbl){sendBtn.setAttribute("aria-label",lbl);sendBtn.title=w?"Queue — sends when the current turn finishes":""}
      textEl.placeholder=other?"Queue a message for when "+turnHolder.name+"’s turn finishes":w?"Queue a follow-up…":"Ask about this document...";
    }
    function canAttach(){return !!(cfg&&cfg.available)&&compose.style.display!=="none"}
    function dropPending(it){var i=pending.indexOf(it);if(i>=0)pending.splice(i,1);if(it.url){try{URL.revokeObjectURL(it.url)}catch(e){}}}
    function clearPending(){pending.slice().forEach(dropPending);renderPending()}
    function renderPending(){
      if(!filesEl)return;
      filesEl.innerHTML="";filesEl.hidden=!pending.length;
      pending.forEach(function(it){
        var chip=document.createElement("div");chip.className="chat-fchip"+(it.key?"":" up");chip.title=it.name+(it.size?" · "+sizeLabel(it.size):"");
        var src=it.url||(it.kind==="image"&&it.key?fileUrl(it.key):"");
        if(src){var im=document.createElement("img");im.src=src;im.alt="";chip.appendChild(im)}
        else{var ic=document.createElement("span");ic.className="chat-fic";ic.textContent=fileBadge(it);chip.appendChild(ic)}
        var nm=document.createElement("span");nm.className="chat-fname";nm.textContent=it.name;chip.appendChild(nm);
        if(!it.key){var sp=document.createElement("span");sp.className="chat-fspin";sp.setAttribute("role","status");sp.setAttribute("aria-label","Uploading");chip.appendChild(sp)}
        var x=document.createElement("button");x.type="button";x.className="chat-fx";x.setAttribute("aria-label","Remove "+it.name);x.textContent="×";
        x.onclick=function(){dropPending(it);renderPending();syncSend();textEl.focus()};
        chip.appendChild(x);filesEl.appendChild(chip);
      });
    }
    function stageFiles(list){
      var arr=Array.prototype.slice.call(list||[]);if(!arr.length)return;
      showFileErr("");
      for(var i=0;i<arr.length;i++){
        var f=arr[i],type=fileTypeOf(f),name=f.name||"";
        if(pending.length>=MAX_FILES){showFileErr("Up to "+MAX_FILES+" files on one message.");break}
        if(!type){showFileErr("“"+(name||"That file")+"” isn't something Shepherd can read. Attach images, PDFs or text files.");continue}
        var cap=type==="application/pdf"?MAX_PDF_BYTES:MAX_FILE_BYTES;
        if(f.size>cap){showFileErr("“"+(name||"That file")+"” is too big: the limit is "+Math.round(cap/1048576)+" MB"+(cap===MAX_PDF_BYTES?" for a PDF":"")+".");continue}
        if(!f.size){showFileErr("“"+(name||"That file")+"” is empty.");continue}
        var kind=kindOf(type);
        var it={name:name||(kind==="image"?"image."+type.split("/")[1]:"file"),type:type,kind:kind,size:f.size,url:kind==="image"?URL.createObjectURL(f):null,key:null};
        pending.push(it);uploadFile(it,f);
      }
      renderPending();syncSend();
    }
    function uploadFile(it,f){
      // A picture is shrunk first (the viewer's ssShrinkImage, the comment boxes' own):
      // a phone screenshot is megabytes of PNG that read the same as a JPEG a fraction of
      // the size. JPEG, not WebP: Grok (the Free plan's model) reads JPEG and PNG only.
      var svg=it.type==="image/svg+xml";
      var shrink=svg?(typeof ssRasterSvg==="function"?ssRasterSvg(f):Promise.resolve(null)):it.kind==="image"&&typeof ssShrinkImage==="function"?ssShrinkImage(f,it.type,{jpeg:true}):Promise.resolve(null);
      shrink.then(function(small){
        if(svg&&!small)throw new Error("svg");
        var body=f,type=it.type;
        if(small){body=small.blob;if(small.type!==type){it.name=it.name.replace(/\.(png|jpe?g|webp|svg)$/i,"")+"."+(small.type==="image/webp"?"webp":small.type==="image/png"?"png":"jpg")}type=small.type}
        return fetch("/api/space/"+spaceId+"/ai/files",{method:"POST",headers:{"Content-Type":type,"X-File-Name":encodeURIComponent(it.name)},body:body});
      }).then(function(r){return r.json().catch(function(){return{}}).then(function(d){return{ok:r.ok,d:d}})}).then(function(res){
        if(pending.indexOf(it)<0)return;
        var fl=res.d&&res.d.file;
        if(!res.ok||!fl){dropPending(it);renderPending();syncSend();showFileErr((res.d&&res.d.error)||"That upload failed. Try again.");return}
        it.key=fl.key;it.name=fl.name;it.media_type=fl.media_type;it.kind=fl.kind;it.size=fl.size;
        renderPending();syncSend();
      }).catch(function(e){if(pending.indexOf(it)<0)return;dropPending(it);renderPending();syncSend();showFileErr(e&&e.message==="svg"?"“"+it.name+"” couldn't be read as a picture. Try a PNG of it.":"That upload failed. Try again.")});
    }
    // A message's files in the thread: pictures open in the lightbox, a PDF or a
    // text file in its document preview (assets/components/lightbox.ts).
    function filesBlock(fs){
      var w=document.createElement("div");w.className="chat-att"+(fs.filter(function(f){return f.kind==="image"}).length>1?" many":"");
      fs.forEach(function(f){
        var a=document.createElement("a");a.href=fileUrl(f.key);a.title=f.name+" · "+sizeLabel(f.size||0);
        if(f.kind==="image"){
          a.className="chat-att-img";a.target="_blank";a.rel="noopener";a.setAttribute("data-lightbox","");
          var im=document.createElement("img");im.src=fileUrl(f.key);im.alt=f.name;im.loading="lazy";a.appendChild(im);
        }else{
          // The lightbox previews it in place, so it never navigates: no sheep veil.
          a.className="chat-att-file";a.setAttribute("data-badge",fileBadge(f));a.setAttribute("data-nav-inline","");
          a.setAttribute("data-lightbox-file",f.kind==="pdf"?"application/pdf":(f.media_type==="text/markdown"?"text/markdown":"text/plain"));
          var nm=document.createElement("span");nm.className="nm";nm.textContent=f.name;a.appendChild(nm);
          // A PDF shows its first pages and how far it has been read, so a build
          // that takes minutes over it has something true to show from the start.
          if(f.kind==="pdf"){var box=document.createElement("div");box.className="chat-pdf";box.appendChild(a);box.appendChild(pdfStrip(f));w.appendChild(box);return}
        }
        w.appendChild(a);
      });
      return w;
    }
    // How far each PDF in the thread has been read (GET …/ai/files/:key/pages), asked
    // until its first pages are drawn. One reading per file, shared by every redraw.
    var PDF_VIEWS={};
    function pdfStrip(f){
      var s=document.createElement("div");s.className="chat-pdf-pages";s.setAttribute("data-pdf-key",f.key);
      drawPdfStrip(s,f.key);pollPdf(f.key);return s;
    }
    function pdfCaption(v){
      if(!v)return "Reading the PDF…";
      if(v.state==="failed")return v.error==="locked"?"This PDF is locked, so it couldn’t be read":v.error==="too_big"?"This PDF is too big to read":"This PDF couldn’t be read";
      var n=v.pages?v.pages+" page"+(v.pages===1?"":"s"):"";
      if(v.state==="reading")return "Reading "+(n||"the PDF")+"…";
      if(v.first.length<v.want)return n+" read · drawing the first pages…";
      return n+(v.scanned?" read as pictures":" read");
    }
    function drawPdfStrip(s,k){
      var st=PDF_VIEWS[k],v=st&&st.v,want=v?v.want:3;
      s.innerHTML="";
      var row=document.createElement("div");row.className="chat-pdf-thumbs";
      for(var i=1;i<=want;i++){
        var p=v?v.first.filter(function(x){return x.n===i})[0]:null;
        if(p){
          var a=document.createElement("a");a.className="chat-pdf-thumb";a.href=fileUrl(k)+"/pages/"+i;a.target="_blank";a.rel="noopener";
          a.setAttribute("data-lightbox","");a.setAttribute("data-nav-inline","");a.title="Page "+i;a.style.aspectRatio=p.w+" / "+p.h;
          var im=document.createElement("img");im.src=a.href;im.alt="Page "+i;im.loading="lazy";a.appendChild(im);row.appendChild(a);
        }else if(!v||v.state!=="failed"){var ph=document.createElement("span");ph.className="chat-pdf-thumb wait";ph.setAttribute("aria-hidden","true");row.appendChild(ph)}
      }
      if(row.childNodes.length)s.appendChild(row);
      var cap=document.createElement("div");cap.className="chat-pdf-cap";cap.setAttribute("role","status");cap.textContent=pdfCaption(v);s.appendChild(cap);
    }
    function pollPdf(k){
      var st=PDF_VIEWS[k]||(PDF_VIEWS[k]={v:null,at:Date.now(),busy:false,done:false,asks:0});
      if(st.busy||st.done)return;
      st.busy=true;st.asks++;
      fetch(fileUrl(k)+"/pages",{credentials:"same-origin"}).then(function(r){return r.ok?r.json():null}).then(function(v){
        st.busy=false;
        if(v){
          var had=st.v?st.v.first.length:0;st.v=v;
          if(v.state==="failed"||(v.state==="read"&&v.first.length>=v.want))st.done=true;
          // Only a reading that arrived while someone watched: a PDF read long ago is not news.
          if(!had&&v.first.length&&st.asks>1&&window.mixpanel)mixpanel.track("PDF Pages Shown",{space_id:spaceId,waited_ms:Date.now()-st.at,pages:v.pages,drawn:v.first.length});
        }else st.done=true;
        if(Date.now()-st.at>180000)st.done=true;
        document.querySelectorAll('.chat-pdf-pages[data-pdf-key="'+k+'"]').forEach(function(el){drawPdfStrip(el,k)});
        if(!st.done)setTimeout(function(){pollPdf(k)},2500);
      }).catch(function(){st.busy=false;if(Date.now()-st.at<180000)setTimeout(function(){pollPdf(k)},5000)});
    }
    /* A blank document the owner just made (blankDocFirstRun on the server). The
       page it renders says "open the assistant", and the assistant's launcher is a
       7px sliver — so the panel opens itself instead, once, with something to
       answer. Closing it is the dismissal: kept per space on this device, and
       consulted before every auto-open, so a reload respects the choice. The
       server-side condition expires by itself the moment anything is published or
       asked, which is what stops this from being a permanent greeting. */
    var FIRST_RUN=V.firstRun===true,INTRO_KEY="ss-chat-intro-"+spaceId;
    var INTRO_EGS=[
      "Draft a one-page project brief with goals, scope and a timeline table.",
      "Build a simple landing page for a product I'll describe next.",
      "Set up meeting notes with an agenda, decisions and action items."
    ];
    function introDismissed(){try{return localStorage.getItem(INTRO_KEY)==="1"}catch(e){return false}}
    function introOn(){return FIRST_RUN&&!introDismissed()}
    function dismissIntro(){FIRST_RUN=false;try{localStorage.setItem(INTRO_KEY,"1")}catch(e){}}
    /* The heading asks what to create, so the panel has to be able to create. Edit
       mode is off by default everywhere else and is not remembered between loads,
       which on a blank page would answer "build me a landing page" with a
       paragraph about landing pages. Only ever turned ON here — a viewer who
       switches it off keeps it off. */
    function introBlock(){
      var w=document.createElement("div");w.className="chat-intro";
      var h=document.createElement("h4");h.textContent="What would you like to create?";w.appendChild(h);
      var p=document.createElement("p");
      p.textContent="Describe the page and I'll draft it here. You can keep shaping it in this panel.";
      w.appendChild(p);
      var list=document.createElement("div");list.className="chat-egs";
      INTRO_EGS.forEach(function(x){
        var b=document.createElement("button");b.type="button";b.className="chat-eg";b.textContent=x;
        /* Fills the composer rather than sending: these are starting points to edit,
           and a click that spent a turn on someone else's words would be a trap. */
        b.onclick=function(){textEl.value=x;textEl.dispatchEvent(new Event("input"));textEl.focus()};
        list.appendChild(b);
      });
      w.appendChild(list);
      return w;
    }
    // My seed on the room's wire, learnt from /ai/config: nothing the panel
    // compares or colours by is an address.
    var ME=null;var turnHolder=null;var turnEl=document.getElementById("chatTurn"),facesEl=document.getElementById("chatFaces");
    // Queued messages — ChatGPT's "send while it's thinking". A send that would have
    // to wait (this panel's own turn still going, or, for someone who can edit, the
    // space's turn held by anyone) waits here instead of being refused, and goes out
    // by itself, oldest first, the moment nothing is in the way. Each one is sent as
    // it was pressed: its words, its files, Edit mode and the model picked then.
    // This tab's sessionStorage keeps the line through a reload; closing the tab
    // drops it, like a draft. A turn of mine that fails or is stopped PAUSES the
    // line, since the next ask was probably written against an answer that never
    // came; a turn of mine that finishes un-pauses it.
    var queue=[],queuePaused=false,qReady=false,qHold=0,pumpT=0,turnCheckT=0,QKEY="ss-cosh-queue:"+spaceId,queueEl=document.getElementById("chatQueue");
    var Q_CLOCK="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M12 6V12L16 14\"/><path d=\"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z\"/></svg>";
    try{var qs=JSON.parse(sessionStorage.getItem(QKEY)||"[]");if(Array.isArray(qs))queue=qs.filter(function(q){return q&&(q.text||(q.files&&q.files.length))}).slice(0,20)}catch(e){}
    function saveQueue(){try{if(queue.length)sessionStorage.setItem(QKEY,JSON.stringify(queue));else sessionStorage.removeItem(QKEY)}catch(e){}}
    // A message the model turned away (a plan allowance spent) waits for it here.
    // The box holding it is hidden behind the "out of fuel" card, and the wait can be
    // hours, so it is kept in localStorage for this space: a reload or a closed tab
    // still finds it in the box when Shepherd can run again. Its files ride along
    // only while the server still keeps them staged (a day from upload). Typing in
    // the box keeps it current; emptying the box, or sending it, lets it go.
    var HKEY="ss-cosh-held:"+spaceId,HELD_MS=7*86400000,HELD_FILES_MS=79200000,heldRestored=false;
    function readHeld(){
      try{var h=JSON.parse(localStorage.getItem(HKEY)||"null");if(h&&(h.text||(h.files&&h.files.length))&&Date.now()-(h.at||0)<HELD_MS)return h;localStorage.removeItem(HKEY)}catch(e){}
      return null;
    }
    function dropHeld(){try{localStorage.removeItem(HKEY)}catch(e){}}
    function holdBox(){
      var files=pending.filter(function(p){return p.key}).map(function(f){return{key:f.key,name:f.name,media_type:f.media_type,kind:f.kind,size:f.size}});
      var text=textEl.value.trim();
      if(!text&&!files.length){dropHeld();return}
      var was=readHeld();
      try{localStorage.setItem(HKEY,JSON.stringify({text:text,files:files,at:was?was.at:Date.now()}))}catch(e){}
    }
    // Back into the box once per page, ahead of nothing: a box already holding words
    // (a refusal on this page) is left as it is.
    function restoreHeld(){
      if(heldRestored)return;heldRestored=true;
      var h=readHeld();if(!h||textEl.value.trim())return;
      textEl.value=h.text||"";window.ssAutoGrow(textEl);
      if(Date.now()-h.at<HELD_FILES_MS)(h.files||[]).forEach(function(f){if(f&&f.key&&pending.length<MAX_FILES&&!pending.some(function(p){return p.key===f.key}))pending.push({key:f.key,name:f.name,media_type:f.media_type,kind:f.kind,size:f.size,url:null})});
      renderPending();syncSend();
    }
    function mustWait(){return busy||posting>0||!!(cfg&&cfg.can_edit&&turnHolder)}
    function renderQueue(){
      if(!queueEl)return;
      if(!queue.length){queuePaused=false;queueEl.hidden=true;queueEl.innerHTML="";return}
      var other=turnHolder&&turnHolder.seed!==ME&&cfg&&cfg.can_edit;
      var head=queuePaused
        ?'<span class="chat-q-say">Paused — your last ask didn’t finish.</span><button type="button" class="chat-q-go" data-q-go="1">Send next</button>'
        :'<span class="chat-q-say">'+(mustWait()?"Queued — sends when "+(other?esc(turnHolder.name)+"’s turn":"this turn")+" finishes":"Sending…")+'</span>';
      queueEl.innerHTML='<div class="chat-q-head">'+head+'</div><ol class="chat-q-list">'+queue.map(function(q,i){
        var nf=q.text&&q.files&&q.files.length?'<span class="chat-q-n">+'+q.files.length+(q.files.length>1?" files":" file")+'</span>':"";
        return '<li class="chat-q">'+Q_CLOCK+'<span class="chat-q-txt">'+esc(q.text||filesPlaceholder(q.files||[]))+'</span>'+nf
          +'<button type="button" class="chat-q-b" data-q-edit="'+i+'" title="Back into the box to change it">Edit</button>'
          +'<button type="button" class="chat-q-x" data-q-del="'+i+'" aria-label="Remove from the queue" title="Remove">&times;</button></li>';
      }).join("")+'</ol>';
      queueEl.hidden=false;
    }
    queueEl&&queueEl.addEventListener("click",function(e){
      var b=e.target.closest("button");if(!b)return;e.preventDefault();
      if(b.hasAttribute("data-q-go")){queuePaused=false;renderQueue();pump(true);return}
      var ei=b.getAttribute("data-q-edit"),di=b.getAttribute("data-q-del"),i=parseInt(ei!==null?ei:di,10),q=queue[i];
      if(!q)return;
      queue.splice(i,1);saveQueue();
      if(ei!==null){
        // Back into the composer, ahead of anything already being typed there.
        var cur=textEl.value.trim();textEl.value=(q.text||"")+(q.text&&cur?"\n":"")+cur;window.ssAutoGrow(textEl);
        (q.files||[]).forEach(function(f){if(pending.length<MAX_FILES&&!pending.some(function(p){return p.key===f.key}))pending.push({key:f.key,name:f.name,media_type:f.media_type,kind:f.kind,size:f.size,url:null})});
        renderPending();
        if(cfg&&cfg.can_edit&&editToggle)editToggle.checked=!!q.edit;
      }
      if(window.mixpanel)try{mixpanel.track(ei!==null?"AI Chat Queue Edited":"AI Chat Queue Removed",{space_id:spaceId,left:queue.length})}catch(x){}
      renderQueue();syncSend();textEl.focus();
    });
    function enqueue(item){
      item.at=Date.now();queue.push(item);saveQueue();renderQueue();syncSend();
      if(window.mixpanel)try{mixpanel.track("AI Chat Queued",{space_id:spaceId,waiting_on:busy?"own":turnHolder?(turnHolder.seed===ME?"own_elsewhere":"other"):"line",depth:queue.length,edit:!!item.edit})}catch(x){}
      pump();
    }
    function pauseQueue(){if(queue.length){queuePaused=true;renderQueue()}}
    // Send the next one once nothing is in the way. Deferred and checked again when
    // it fires: a turn's ending can hand straight on to its own screenshot check,
    // and the room hears the turn let go a moment after the reply lands.
    function pump(now){
      clearTimeout(pumpT);
      if(!queue.length||queuePaused||!qReady||!cfg||!cfg.available)return;
      if(mustWait()){if(!busy&&turnHolder)checkTurnSoon();return}
      var wait=Math.max(now?0:400,qHold-Date.now());
      pumpT=setTimeout(function(){
        if(!queue.length||queuePaused||mustWait())return;
        var q=queue.shift();saveQueue();renderQueue();
        if(window.mixpanel)try{mixpanel.track("AI Chat Queue Sent",{space_id:spaceId,waited_s:q.at?Math.round((Date.now()-q.at)/1000):null,left:queue.length})}catch(x){}
        dispatch(q);
      },wait);
    }
    // The room's "turn is free" is the signal; this is the backstop for a release
    // this tab never heard (a socket that dropped and came back, or a holder learnt
    // from a refusal just after the turn ended). Asks the server, never guesses.
    function checkTurnSoon(){
      clearTimeout(turnCheckT);
      turnCheckT=setTimeout(function(){
        if(!queue.length||queuePaused||busy||!turnHolder)return;
        fetch("/api/space/"+spaceId+"/ai/active").then(function(r){return r.ok?r.json():null}).then(function(a){
          if(a&&a.turn===null&&turnHolder&&!busy)setTurn(null);else checkTurnSoon();
        }).catch(function(){checkTurnSoon()});
      },30000);
    }
    var MORE_TIP="The more sources you connect, the richer the context your spaces draw on.";
    var COPY_BTN_REPLY="<button type=\"button\" class=\"ss-copy ss-copy--sm\" data-copied-label=\"Copied\" aria-label=\"Copy reply\" title=\"Copy reply\"><span class=\"ss-copy-ic\" aria-hidden=\"true\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"ss-copy-g ss-copy-g-idle\" aria-hidden=\"true\"><path d=\"M19.4 20H9.6C9.26863 20 9 19.7314 9 19.4V9.6C9 9.26863 9.26863 9 9.6 9H19.4C19.7314 9 20 9.26863 20 9.6V19.4C20 19.7314 19.7314 20 19.4 20Z\"/><path d=\"M15 9V4.6C15 4.26863 14.7314 4 14.4 4H4.6C4.26863 4 4 4.26863 4 4.6V14.4C4 14.7314 4.26863 15 4.6 15H9\"/></svg><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"ss-copy-g ss-copy-g-done\" aria-hidden=\"true\"><path d=\"M5 13L9 17L19 7\"/></svg></span><span class=\"ss-copy-live\" role=\"status\" aria-live=\"polite\"></span></button>";
    var COPY_BTN_MSG="<button type=\"button\" class=\"ss-copy ss-copy--sm\" data-copied-label=\"Copied\" aria-label=\"Copy message\" title=\"Copy message\"><span class=\"ss-copy-ic\" aria-hidden=\"true\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"ss-copy-g ss-copy-g-idle\" aria-hidden=\"true\"><path d=\"M19.4 20H9.6C9.26863 20 9 19.7314 9 19.4V9.6C9 9.26863 9.26863 9 9.6 9H19.4C19.7314 9 20 9.26863 20 9.6V19.4C20 19.7314 19.7314 20 19.4 20Z\"/><path d=\"M15 9V4.6C15 4.26863 14.7314 4 14.4 4H4.6C4.26863 4 4 4.26863 4 4.6V14.4C4 14.7314 4.26863 15 4.6 15H9\"/></svg><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"ss-copy-g ss-copy-g-done\" aria-hidden=\"true\"><path d=\"M5 13L9 17L19 7\"/></svg></span><span class=\"ss-copy-live\" role=\"status\" aria-live=\"polite\"></span></button>";
    var COPY_BTN_LINK="<button type=\"button\" class=\"ss-copy ss-copy--sm\" data-copied-label=\"Copied\" aria-label=\"Copy link\" title=\"Copy link\"><span class=\"ss-copy-ic\" aria-hidden=\"true\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"ss-copy-g ss-copy-g-idle\" aria-hidden=\"true\"><path d=\"M19.4 20H9.6C9.26863 20 9 19.7314 9 19.4V9.6C9 9.26863 9.26863 9 9.6 9H19.4C19.7314 9 20 9.26863 20 9.6V19.4C20 19.7314 19.7314 20 19.4 20Z\"/><path d=\"M15 9V4.6C15 4.26863 14.7314 4 14.4 4H4.6C4.26863 4 4 4.26863 4 4.6V14.4C4 14.7314 4.26863 15 4.6 15H9\"/></svg><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"ss-copy-g ss-copy-g-done\" aria-hidden=\"true\"><path d=\"M5 13L9 17L19 7\"/></svg></span><span class=\"ss-copy-label\">Copy link</span><span class=\"ss-copy-live\" role=\"status\" aria-live=\"polite\"></span></button>";
    var LINK_IC="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M14 11.9976C14 9.5059 11.683 7 8.85714 7C8.52241 7 7.41904 7.00001 7.14286 7.00001C4.30254 7.00001 2 9.23752 2 11.9976C2 14.376 3.70973 16.3664 6 16.8714C6.36756 16.9525 6.75006 16.9952 7.14286 16.9952\"/><path d=\"M10 11.9976C10 14.4893 12.317 16.9952 15.1429 16.9952C15.4776 16.9952 16.581 16.9952 16.8571 16.9952C19.6975 16.9952 22 14.7577 22 11.9976C22 9.6192 20.2903 7.62884 18 7.12383C17.6324 7.04278 17.2499 6.99999 16.8571 6.99999\"/></svg>";
    var CHECK_IC="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11\" height=\"11\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M5 13L9 17L19 7\"/></svg>",CHEV_IC="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M9 6L15 12L9 18\"/></svg>";
    // Custom select rather than a native one: the menu has to open UPWARD (the picker
    // sits at the foot of the panel) and stay inside the 360px drawer.
    // "auto" (the default) sends no model: the server picks by role — the fast
    // model for a question and for the lane's first go at an edit, the builder for
    // the rest. A model the person picks is theirs until they pick Auto again.
    var chatModelPick=window.mountPillSelect?window.mountPillSelect({
      root:"chatModel",
      groups:[],
      storageKey:"ss-chat-llm2",
      onChange:function(it){chatMeter(it&&it.value)},
      onLocked:function(it){if(window.mixpanel)try{mixpanel.track("Locked Model Tapped",{feature:"co_shepherd",model:it.label,plan:it.plan,space_id:spaceId})}catch(x){}}
    }):null;
    // The meter at the top of the model menu follows the picked model: the allowance it
    // draws on (Auto: the default model's), how full, or when it's back.
    var chatAllowance=null,chatProviders=null;
    function chatMeter(v){if(chatModelPick&&chatModelPick.setHead)chatModelPick.setHead(window.ssPillMeterHead(chatAllowance,chatProviders,v))}
    // The space's design system (design-routes.ts): an editor with the gate switches it
    // here. Picking one records it for the space and puts the restyle ask in the box,
    // unsent, so the person decides when the page changes.
    // designStale: the space was built on an older version of the system picked, so
    // picking that same row again moves the space to the version saved since.
    var designNow="none",designStale=false;
    function applyDesign(item){
      if(!item||(item.value===designNow&&!designStale))return;
      designStale=false;
      var prev=designNow;designNow=item.value;
      fetch("/api/space/"+spaceId+"/design",{method:"PUT",credentials:"same-origin",headers:{"Content-Type":"application/json"},body:JSON.stringify({system:item.value==="none"?null:item.value})})
        .then(function(r){if(!r.ok)throw new Error(String(r.status));
          if(item.value!=="none"&&textEl&&!textEl.value.trim()){textEl.value="Restyle this space in "+item.label+".";textEl.dispatchEvent(new Event("input"));textEl.focus()}})
        .catch(function(){designNow=prev;chatDesignPick.setValue(prev)});
    }
    var chatDesignPick=window.mountPillSelect?window.mountPillSelect({
      root:"chatDesign",
      groups:[],
      onChange:applyDesign
    }):null;
    // "Create a design system" (the picker's foot when there is none): the dialog opens
    // here, and the new system comes back applied to this space, as picking it would.
    // If the dialog can't load, Settings opens in a new tab instead.
    function makeDesign(){
      window.ssNewDesign({via:"shepherd"}).then(function(s){
        if(!s)return;
        fetch("/api/space/"+spaceId+"/ai/config",{credentials:"same-origin"}).then(function(r){return r.ok?r.json():null}).then(function(d){
          if(d)designGroups(d);
          chatDesignPick.setValue(s.id);applyDesign({value:s.id,label:s.name});
        }).catch(function(){});
      }).catch(function(){designEdited=true;window.open("/settings/design-systems","_blank","noopener")});
    }
    // The pick's rows: none, then the person's own systems (each with a pencil that
    // opens it in Settings), then the space's system when it is someone else's and not
    // shared with them, then teammates' systems under "From <team>" (default team first).
    function designGroups(d){
      var dsWrap=document.getElementById("chatDesignWrap"),ds=d.design_systems,sh=d.design_shared||[];
      if(dsWrap)dsWrap.hidden=!ds;
      if(!chatDesignPick||!ds)return;
      var curDs=d.design,dItems=[{value:"none",label:"No design system",short:""}];
      function has(list,id){return list.some(function(s){return s.id===id})}
      // The space's system may be another editor's: it shows as itself, by version.
      if(curDs&&!has(ds,curDs.system_id)&&!has(sh,curDs.system_id))dItems.push({value:curDs.system_id,label:curDs.name+" · v"+curDs.version});
      designStale=false;
      // A newer version saved since this space was built: picking the row moves it there.
      function stale(it,s){if(curDs&&curDs.system_id===s.id&&s.version>curDs.version){designStale=true;it.note="This space uses v"+curDs.version+". Pick it for v"+s.version+"."}return it}
      ds.forEach(function(s){dItems.push(stale({value:s.id,label:s.name,editHref:"/settings/design-systems?system="+encodeURIComponent(s.id)},s))});
      var groups=[{label:"Design system",items:dItems}],by={};
      sh.forEach(function(s){
        var t=(s.teams&&s.teams[0])||{id:"",name:"your team"};
        if(!by[t.id]){by[t.id]={label:"From "+t.name,items:[]};groups.push(by[t.id])}
        by[t.id].items.push(stale({value:s.id,label:s.name,note:s.maker+" · v"+s.version},s));
      });
      designNow=curDs?curDs.system_id:"none";
      // Nothing to pick but "No design system": a quiet way to make one (makeDesign).
      var none=dItems.length===1&&!sh.length;
      chatDesignPick.setGroups(groups,designNow,none?{label:"Create a design system",href:"/settings/design-systems",track:"Design System Invite Clicked",props:{surface:"shepherd"},onClick:makeDesign}:null);
    }
    // Back from editing (or making) a system in another tab: read the list again, so a
    // new version, or the new system, shows on its row.
    var designEdited=false;
    document.addEventListener("click",function(e){if(e.target&&e.target.closest&&e.target.closest("#chatDesign .ss-pill-edit"))designEdited=true},true);
    window.addEventListener("focus",function(){
      if(!designEdited)return;designEdited=false;
      fetch("/api/space/"+spaceId+"/ai/config",{credentials:"same-origin"}).then(function(r){return r.ok?r.json():null}).then(function(d){if(d)designGroups(d)}).catch(function(){});
    });
    var CHAT_SKEL="<div class=\"ss-skel-chat\" role=\"status\" aria-busy=\"true\" aria-label=\"Loading conversation\"><div class=\"ss-skel ss-skel-bubble\" aria-hidden=\"true\"><div class=\"ss-skel-avatar\"></div><div class=\"ss-skel-lines\"><div class=\"ss-skel-line\" style=\"width:80%\"></div><div class=\"ss-skel-line\" style=\"width:55%\"></div></div></div><div class=\"ss-skel ss-skel--end ss-skel-bubble\" aria-hidden=\"true\"><div class=\"ss-skel-lines\"><div class=\"ss-skel-line\" style=\"width:45%\"></div></div></div><div class=\"ss-skel ss-skel-bubble\" aria-hidden=\"true\"><div class=\"ss-skel-avatar\"></div><div class=\"ss-skel-lines\"><div class=\"ss-skel-line\" style=\"width:90%\"></div><div class=\"ss-skel-line\" style=\"width:96%\"></div><div class=\"ss-skel-line\" style=\"width:60%\"></div></div></div></div>";
    var receiveSound=new Audio("/sounds/receive.mp3");receiveSound.volume=0.5;
    var sendSound=new Audio("/sounds/send.mp3");sendSound.volume=0.5;

    

    // Minimal, safe Markdown -> HTML. Input is HTML-escaped first, so nothing the
    // model emits can inject markup; only the tags we generate below are inserted.
    // Quotes too: the link rule below drops a URL into an href, and other people's
    // replies render here now.
    function mdEsc(s){return s.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}
    function mdInline(s){
      // One pass: code, link destinations and generated tags never get parsed again.
      return s.replace(/`([^`]+)`|(!?)\[([^\]]*)\]\((https?:\/\/[^)\s]+|\/api\/session-reply-images\/[0-9a-f]{64})\)|\*\*([^*]+)\*\*|__([^_]+)__|\*([^*\n]+)\*|https?:\/\/[^\s<>"']+/g,function(token,code,image,label,url,bold,under,em){
        if(code!==undefined)return '<code>'+code+'</code>';
        if(image==='!')return '<a data-lightbox href="'+url+'" target="_blank" rel="noopener noreferrer" aria-label="Open image: '+label+'"><img src="'+url+'" alt="'+label+'" loading="lazy" decoding="async" referrerpolicy="no-referrer"></a>';
        if(url!==undefined)return '<a href="'+url+'" target="_blank" rel="noopener noreferrer">'+label+'</a>';
        // Inside bold or emphasis the words are parsed again, so "**[title](url)**" —
        // how a model writes a list of pages — is a link, not brackets. The capture is
        // a slice of the already-escaped source and holds no asterisk, so this ends.
        if(bold!==undefined||under!==undefined)return '<strong>'+mdInline(bold===undefined?under:bold)+'</strong>';
        if(em!==undefined)return '<em>'+mdInline(em)+'</em>';
        // Sentence punctuation belongs after a bare link. Keep a URL's own
        // balanced parentheses (e.g. Wikipedia), peeling mixed tails like ").".
        var u=token,tail='',balance=(u.match(/\(/g)||[]).length-(u.match(/\)/g)||[]).length;
        while(u){
          var c=u.slice(-1);
          if(/[.,;:!?]/.test(c)){
            // mdEsc ran first: an entity's semicolon is part of its character.
            if(c===';'&&/&(?:amp|lt|gt|quot|#39);$/.test(u))break;
          }else if(c===')'&&balance<0)balance++;
          else break;
          tail=c+tail;u=u.slice(0,-1);
        }
        return '<a href="'+u+'" target="_blank" rel="noopener noreferrer">'+u+'</a>'+tail;
      });
    }
    // A table is a row with a pipe over a rule row ("|---|:--:|"), then every line
    // with a pipe until one without. Models write them for any comparison, and
    // without this their rows ran together as one paragraph of pipes.
    var MD_RULE=/^\s*\|?\s*:?-+:?\s*(\|\s*:?-+:?\s*)*\|?\s*$/;
    function mdIsTable(lines,i){return /\|/.test(lines[i])&&i+1<lines.length&&/\|/.test(lines[i+1])&&MD_RULE.test(lines[i+1])}
    function mdCells(line){
      // "\|" is a pipe inside a cell; it is held aside while the row is split.
      var s=line.trim().replace(/\\\|/g,"\u0000");
      if(s.charAt(0)==="|")s=s.slice(1);
      if(s.slice(-1)==="|")s=s.slice(0,-1);
      return s.split("|").map(function(c){return c.trim().replace(/\u0000/g,"|")});
    }
    function mdTable(rows){
      var head=mdCells(rows[0]),n=head.length;
      var al=mdCells(rows[1]).map(function(c){var l=c.charAt(0)===":",r=c.slice(-1)===":";return l&&r?' class="md-ac"':r?' class="md-ar"':""});
      function row(cs,tag){var h="<tr>";for(var x=0;x<n;x++)h+="<"+tag+(al[x]||"")+">"+mdInline(cs[x]||"")+"</"+tag+">";return h+"</tr>"}
      var body=rows.slice(2).map(function(r){return row(mdCells(r),"td")}).join("");
      return '<div class="md-table"><table><thead>'+row(head,"th")+"</thead>"+(body?"<tbody>"+body+"</tbody>":"")+"</table></div>";
    }
    // opts.breaks keeps a single newline as a line break, the way a person typing a
    // comment means it; chat and session text join wrapped lines as Markdown does.
    function mdToHtml(src,opts){
      var br=!!(opts&&opts.breaks);
      var lines=mdEsc(src||"").split(/\r?\n/);
      var html="",inCode=false,codeBuf=[],listType=null,listItems=[],paraBuf=[];
      function flushList(){if(listType){html+="<"+listType+">"+listItems.map(function(li){return "<li>"+mdInline(li)+"</li>"}).join("")+"</"+listType+">";listType=null;listItems=[]}}
      function flushPara(){if(paraBuf.length){html+="<p>"+(br?mdInline(paraBuf.join("\n")).replace(/\n/g,"<br>"):mdInline(paraBuf.join(" ")))+"</p>";paraBuf=[]}}
      for(var i=0;i<lines.length;i++){
        var line=lines[i];
        if(/^```/.test(line)){if(inCode){html+="<pre><code>"+codeBuf.join("\n")+"</code></pre>";codeBuf=[];inCode=false}else{flushPara();flushList();inCode=true}continue}
        if(inCode){codeBuf.push(line);continue}
        if(!line.trim()){flushPara();flushList();continue}
        if(mdIsTable(lines,i)){
          flushPara();flushList();
          var j=i+2;while(j<lines.length&&lines[j].trim()&&/\|/.test(lines[j])&&!/^```/.test(lines[j]))j++;
          html+=mdTable(lines.slice(i,j));i=j-1;continue;
        }
        var h=line.match(/^(#{1,6})\s+(.*)$/);
        if(h){flushPara();flushList();html+='<div class="md-h">'+mdInline(h[2])+"</div>";continue}
        var b=line.match(/^\s*[-*+]\s+(.*)$/);
        if(b){flushPara();if(listType&&listType!=="ul")flushList();listType="ul";listItems.push(b[1]);continue}
        var o=line.match(/^\s*\d+[.)]\s+(.*)$/);
        if(o){flushPara();if(listType&&listType!=="ol")flushList();listType="ol";listItems.push(o[1]);continue}
        if(listType)flushList();
        paraBuf.push(line);
      }
      if(inCode){html+="<pre><code>"+codeBuf.join("\n")+"</code></pre>"}
      flushPara();flushList();
      return html;
    }
    // Run fn over the rendered words only: never over a tag, and never inside code,
    // a code block or a link, so a pill can't land in an href or a snippet.
    function mdText(html,fn){
      var skip=0;
      return html.split(/(<[^>]*>)/).map(function(part,i){
        if(i%2){if(/^<(code|pre|a)[\s>]/.test(part))skip++;else if(/^<\/(code|pre|a)>/.test(part))skip--;return part}
        return skip?part:fn(part);
      }).join("");
    }



    // Single gate for the "a turn is running" flag so the tab's spinner can never
    // drift from the panel's state, whichever of the send / retry / verify paths
    // flipped it.
    function setBusy(v){busy=v;chat.classList.toggle("working",busy);syncRun();syncSend();renderQueue();if(!busy){thread.settle();pump();if(window.__ssShDone)window.__ssShDone()}}
    // The Session pane (talk-window.ts) opens this drawer on its own tab.
    window.ssChatOpen=function(){toggle(true)};
    // …and hands Co-shepherd a message the session didn't pick up: the words land
    // in this composer, the person presses send.
    // how "temporary": open without saving it as this page's choice (the edit bar's
    // Ask Assistant, which closes it again when editing ends).
    window.ssChatAsk=function(q,how){toggle(true,how==="temporary"?"temporary":undefined);if(q){textEl.value=q;textEl.dispatchEvent(new Event("input"))}setTimeout(function(){if(textEl.offsetParent)textEl.focus()},260)};
    window.ssChatClose=function(how){if(open)toggle(false,how==="temporary"?"temporary":undefined)};
    // Open with the Shepherd's own pane in front (not the Session tab), and whether
    // a turn is running or waiting to. "ss:chat-drawer" says either may have changed.
    window.ssChatShown=function(){var i=chat.querySelector(".chat-panel-inner");return open&&!(i&&i.classList.contains("on-talk"))};
    window.ssChatBusy=function(){return busy||posting>0||queue.length>0};
    function toggle(o,source){var was=open;open=o!==undefined?o:!open;chat.classList.toggle("open",open);handle.setAttribute("aria-expanded",open?"true":"false");chat.classList.remove("peek");chat.style.removeProperty("--tab-s");if(open&&!loaded)loadConfig();if(open&&!was&&loaded)landThread();if(open&&source!=="restore")setTimeout(function(){if(textEl.offsetParent)textEl.focus()},240);
      if(open!==was||source==="restore")sidebarState.changed(open,source);
      // Collapsing it IS the dismissal — the «, the tab, the phone's strip, Escape, all of them. There is
      // no separate "don't show this again", because there is nothing else in the
      // panel yet to close for another reason.
      if(was&&!open&&source!=="temporary")dismissIntro();
      window.dispatchEvent(new Event("ss:chat-drawer"));
      reportWatch();}
    // Open, and this tab in front. A panel left open in a background tab is not
    // being watched — whoever switched away is exactly who the bell is for — so
    // the page coming back or going away reports itself too.
    function reportWatch(){if(window.__ssWatch)window.__ssWatch(open&&!document.hidden)}
    document.addEventListener("visibilitychange",reportWatch);
    // The phone edge tab can still be dragged up or down to a comfortable spot.
    // The gesture is the natural one: press and move. As soon as the finger travels
    // past a few pixels vertically the tab comes loose, rides the finger, and stays
    // where it is dropped — kept on this device as a share of the viewport height
    // (localStorage) so a rotation keeps the proportion. No timed long-press: a real
    // finger presses and drags in one motion, and demanding it hold still first (an
    // earlier version did) meant the drag never started. A press that lifts without
    // moving is a plain tap and still opens the panel. Desktop keeps the in-flow
    // sliver and none of this applies. touch-action:none on the handle (see CSS)
    // stops the page from claiming the same swipe as a scroll.
    // --tab-y is positioned in PIXELS, not a percentage. A CSS % for top resolves
    // against the layout viewport, which on iOS is not window.innerHeight whenever
    // Safari's toolbar is showing; writing a JS-computed frac% then re-resolved the
    // tab against a different height and it jumped tens of pixels on the first move.
    // Pixels keep the position in the same space getBoundingClientRect reports, so
    // the first drag move writes the exact px the tab already sits at. The fraction
    // is kept only for persistence, so a reload or rotation restores the proportion.
    var TAB_KEY="ss-chat-tab-y",SLOP=6,tabMq=window.matchMedia("(max-width:640px), (hover:none)"),
        dragging=false,swallow=false,ptr=null,startY=0,grabOff=0,tabFrac=.5,lastSave=0;
    function setTabY(px){tabFrac=px/(window.innerHeight||1);chat.style.setProperty("--tab-y",Math.round(px)+"px")}
    function saveTabY(){try{localStorage.setItem(TAB_KEY,String(tabFrac))}catch(x){}}
    try{var savedY=parseFloat(localStorage.getItem(TAB_KEY));if(savedY>0&&savedY<1)setTabY(savedY*(window.innerHeight||0))}catch(e){}
    function tabBounds(){var row=document.querySelector(".main-row"),r=row?row.getBoundingClientRect():{top:0,bottom:window.innerHeight},half=handle.offsetHeight/2+6;return{min:r.top+half,max:r.bottom-half}}
    // Grab from wherever the tab is now (not the finger), so it doesn't jump under
    // the thumb when the drag begins. No setPointerCapture: a touch pointer is
    // implicitly captured by its target for the life of the touch, and calling
    // setPointerCapture on iOS on top of that only makes it drop and re-take the
    // capture mid-drag (lostpointercapture / gotpointercapture), which was ending
    // the drag one move in.
    function beginDrag(){dragging=true;var r=handle.getBoundingClientRect();grabOff=(r.top+r.bottom)/2-startY;handle.classList.add("held")}
    // Release ends the drag and writes the final spot. The position is ALSO saved
    // as the drag goes (throttled, below): the drop is not left to depend on a clean
    // pointerup, which a system gesture can pre-empt and which some engines drop for
    // a captured touch.
    function releaseTab(e){if(ptr===null||(e&&e.pointerId!==ptr))return;ptr=null;if(!dragging)return;dragging=false;handle.classList.remove("held");swallow=true;saveTabY()}
    handle.addEventListener("pointerdown",function(e){if(!tabMq.matches||!e.isPrimary||ptr!==null)return;ptr=e.pointerId;startY=e.clientY;swallow=false});
    handle.addEventListener("pointermove",function(e){if(e.pointerId!==ptr)return;if(!dragging){if(Math.abs(e.clientY-startY)<=SLOP)return;startY=e.clientY;beginDrag()}var b=tabBounds(),y=Math.max(b.min,Math.min(b.max,e.clientY+grabOff));setTabY(y);var t=e.timeStamp||Date.now();if(t-lastSave>120){lastSave=t;saveTabY()}e.preventDefault()});
    handle.addEventListener("pointerup",releaseTab);handle.addEventListener("pointercancel",releaseTab);
    handle.addEventListener("contextmenu",function(e){if(tabMq.matches)e.preventDefault()});
    handle.addEventListener("selectstart",function(e){e.preventDefault()});
    handle.onclick=function(){if(swallow){swallow=false;return}toggle()};
    // A real control, so the keyboard, a screen reader and Speak's screen report
    // all find the way into Co-shepherd.
    handle.addEventListener("keydown",function(e){if(e.target===handle&&(e.key==="Enter"||e.key===" ")){e.preventDefault();toggle()}});
    // The document is in an iframe, which swallows this window's mousemove, so the
    // frame tells us when the cursor is near its left edge (anchor.js -> ss-edge,
    // routed here by the message bridge). Nothing of ours overlays the page, so a
    // reader can still select the text and click the links the tab flies over.
    // The tab is always out on a desktop, at TAB_REST of its size, and grows as the
    // cursor comes within EDGE_ZONE of the edge, reaching full size EDGE_FULL from it
    // (design-explorations/coshepherd-findable.html, variant F). A frame too old to
    // send the distance only says near or not, which reads as full size or resting.
    var TAB_REST=.6,EDGE_ZONE=480,EDGE_FULL=36;
    window.__ssEdge=function(near,x){
      if(open)return;
      var s=near?1:TAB_REST;
      if(typeof x==="number"){var t=Math.min(1,Math.max(0,(EDGE_ZONE-x)/(EDGE_ZONE-EDGE_FULL)));t=t*t*(3-2*t);s=TAB_REST+(1-TAB_REST)*t}
      chat.style.setProperty("--tab-s",s.toFixed(3));
      chat.classList.toggle("peek",s>.999);
    };
    // On a touch screen the tab is an 8px sliver with no hover to name it, so it read
    // as a stray handle. The first time in this browser it slides out with its label
    // for a few seconds, once.
    (function(){
      if(!window.matchMedia||!window.matchMedia("(hover:none)").matches)return;
      var seen=null;try{seen=localStorage.getItem("ss_coach_chat_tab")}catch(e){}
      if(seen)return;
      setTimeout(function(){
        if(open||!handle.offsetWidth)return;
        try{localStorage.setItem("ss_coach_chat_tab","1")}catch(e){}
        chat.classList.add("hello");setTimeout(function(){chat.classList.remove("hello")},4000);
      },1500);
    })();
    closeBtn.onclick=function(){toggle(false)};
    // A phone keeps a strip of the page beside the drawer; a tap there folds it away.
    document.getElementById("chatScrim").onclick=function(){toggle(false)};
    // Escape folds the drawer from anywhere inside it. Registered after the lightbox's
    // own listener, so an open picture (or a pill menu) takes the key first.
    document.addEventListener("keydown",function(e){if(e.key!=="Escape"||e.defaultPrevented||!open||!chat.contains(document.activeElement))return;toggle(false);handle.focus()});
    // Collapse keeps the edge tab available; the menu opens the same drawer.
    var restoreBtn=document.getElementById("chatRestore");
    restoreBtn.onclick=function(){toggle(true)};
    // Create the entry only when the server kept Speak for this signed-in viewer.
    // Its original button remains the sole microphone start/stop path.
    var speakBtn=document.getElementById("ssSpeakBtn");
    if(speakBtn){
      var speakMenu=document.createElement("button");speakMenu.type="button";
      speakMenu.className="cbtn viewer-touch-action";speakMenu.setAttribute("role","menuitem");
      // Icon and label like the rows around it: the mic its own button wears.
      speakMenu.id="viewerSpeak";speakMenu.innerHTML="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M12 15C10.3431 15 9 13.6569 9 12V6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6V12C15 13.6569 13.6569 15 12 15Z\"/><path d=\"M19 12C19 15.866 15.866 19 12 19M12 19C8.13401 19 5 15.866 5 12M12 19V22M12 22H15M12 22H9\"/></svg>"+'<span class="mi-label">Speak</span>';
      speakMenu.onclick=function(){speakBtn.click()};
      restoreBtn.parentNode.insertBefore(speakMenu,restoreBtn.nextSibling);
    }

    // The button in the corner (COSHEPHERD_TAB_MIC), in place of the edge tab, with the
    // comment button's grammar. Tap (or the keyboard): the drawer. Hold, for someone
    // with dictation: say it, and letting go sends it to Shepherd with the drawer still
    // shut; the bubble beside the button shows the words, then the answer's first
    // lines. Drag: anywhere. Nothing promises a hold to someone without dictation.
    var shMic=document.getElementById("shMic"),shBtn=document.getElementById("shMicBtn"),shBub=document.getElementById("shMicBub");
    if(shMic&&shBtn&&shBub){
      var HOLD_MS=320,SLOW_TAP_MS=400,SHTIP="ss_coach_shepherd",shPress=null,shSwallow=0,shTapped=null,shVoice=null,shRun=null,shBubT=null;
      var shEsc=function(t){return String(t==null?"":t).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")};
      var shTrack=function(action,extra){if(!window.mixpanel)return;var p={space_id:spaceId,action:action,phone:window.matchMedia("(max-width:640px)").matches};for(var k in extra||{})p[k]=extra[k];try{mixpanel.track("Shepherd Mic",p)}catch(x){}};
      var shHide=function(){clearTimeout(shBubT);shBub.classList.remove("on");shBubT=setTimeout(function(){shBub.hidden=true},200)};
      // html is ours (escaped by the caller); acts: [{label, go, fn}].
      var shSay=function(html,o){
        o=o||{};clearTimeout(shBubT);shBub.innerHTML=html;
        if(o.acts&&o.acts.length){var row=document.createElement("div");row.className="shmic-acts";o.acts.forEach(function(a){var b=document.createElement("button");b.type="button";b.textContent=a.label;if(a.go)b.className="go";b.onclick=function(){shHide();if(a.fn)a.fn()};row.appendChild(b)});shBub.appendChild(row)}
        shBub.hidden=false;void shBub.offsetWidth;shBub.classList.add("on");
        if(o.ms)shBubT=setTimeout(shHide,o.ms);
      };
      var shOpen=function(how){shHide();toggle(true);shTrack("open",{how:how})};
      // The config the send needs, loaded once (the panel loads it on first open).
      var shWaiters=[];
      window.__ssShCfg=function(){var w=shWaiters;shWaiters=[];w.forEach(function(f){try{f()}catch(x){}})};
      var whenCfg=function(fn){if(cfg)return fn();shWaiters.push(fn);if(!loaded)loadConfig()};
      var shAsk=function(text){
        shSay('<div class="shmic-st">Sending to Shepherd…</div><p class="shmic-say">'+shEsc(text)+"</p>");
        whenCfg(function(){
          // No model, lost access, or files waiting in the composer: the words go in
          // the box and the drawer opens, so nothing is sent that wasn't meant to be.
          if(!cfg||!cfg.available||cfg.lost||pending.length){shHide();window.ssChatAsk((textEl.value.trim()?textEl.value.trim()+" ":"")+text);shTrack("handed",{why:!cfg||cfg.lost?"no_access":!cfg.available?"no_model":"files"});return}
          var draft=textEl.value;
          textEl.value=text;send();
          if(draft){textEl.value=draft;window.ssAutoGrow(textEl);syncSend()}
          shRun={text:text,n:history.length,t0:Date.now()};
          shSay('<div class="shmic-st">Shepherd is on it</div><p class="shmic-say">'+shEsc(text)+"</p>",{acts:[{label:"Open",go:true,fn:function(){shOpen("sent")}}],ms:8000});
          shTrack("sent",{chars:text.length});
        });
      };
      // The turn a hold started has ended: the answer's opening, beside the button.
      // A refusal (no model, the turn held) takes the ask back out of the thread; a
      // failure ends in a ⚠️ line. Either is said as itself, never as "Done".
      window.__ssShDone=function(){setTimeout(function(){
        var r=shRun;if(!r)return;shRun=null;if(open)return;
        var ask=-1,a=null;
        for(var i=Math.max(0,r.n-2);i<history.length;i++){if(history[i].role==="user"&&history[i].content===r.text){ask=i;break}}
        if(ask>=0)for(var j=history.length-1;j>ask;j--){if(history[j].role==="assistant"&&history[j].content){a=history[j];break}}
        var t=a?String(a.content).replace(/<[^>]*>/g," ").replace(/[*_#>\[\]]+/g,"").replace(/\x60/g,"").replace(/\s+/g," ").trim():"";
        var failed=!t||/^⚠/.test(t);
        if(t.length>220)t=t.slice(0,218).replace(/\s+\S*$/,"")+"…";
        if(failed){
          shSay("<span>"+(ask<0?"Shepherd couldn’t take that one.":"Shepherd didn’t answer.")+'</span><p class="shmic-say">'+shEsc(t.replace(/^⚠\S*\s*/,""))+"</p>",{acts:[{label:"Open to see why",go:true,fn:function(){shOpen("failed")}},{label:"Close"}]});
          shTrack("failed",{taken:ask>=0,ms:Date.now()-r.t0});return;
        }
        shSay('<div class="shmic-st">Shepherd</div><p class="shmic-say">'+shEsc(t)+"</p>",{acts:[{label:"Open",go:true,fn:function(){shOpen("answer")}},{label:"Close"}],ms:20000});
        shTrack("answered",{ms:Date.now()-r.t0});
      },0)};
      var canVoice=function(){return typeof window.ssDictate==="function"};
      var holdStart=function(){
        if(shVoice)return;
        try{localStorage.setItem(SHTIP,"1")}catch(x){}
        var lv=window.ssComposeMic&&window.ssComposeMic.live&&window.ssComposeMic.live();if(lv)lv.cancel(false);
        var mine={t0:Date.now(),text:""};shVoice=mine;shMic.classList.add("is-live");
        shSay('<div class="shmic-st"><i></i>Listening — let go to send</div><p class="shmic-say" id="shMicSay"></p>');
        mine.d=window.ssDictate({
          onText:function(fin,int,said){if(shVoice!==mine)return;mine.text=said;var el=document.getElementById("shMicSay");if(el)el.textContent=said},
          // Ended by the page, not the person: the words are kept, never sent by themselves.
          onFail:function(msg){
            if(shVoice!==mine)return;var said=String(mine.text||"").trim();holdEnd(true);
            shSay("<span>"+shEsc(msg)+"</span>"+(said?'<p class="shmic-say">'+shEsc(said)+"</p>":""),said?{acts:[{label:"Send it",go:true,fn:function(){shAsk(said)}},{label:"Discard"}]}:{ms:6000});
            shTrack("fail");
          }
        });
        if(window.ssVoiceMeter&&mine.d&&mine.d.levels)mine.meter=window.ssVoiceMeter(shBtn,function(){return mine.d.levels()});
        shTrack("hold");
      };
      var holdEnd=function(cancelled){
        var v=shVoice;if(!v)return;shVoice=null;if(v.meter)v.meter();shMic.classList.remove("is-live");
        if(cancelled){try{v.d&&v.d.cancel()}catch(x){}return}
        var held=Date.now()-v.t0;
        // A slow tap, not a hold: let go moments after the mic came on, nothing heard.
        if(held<SLOW_TAP_MS&&!String(v.text||"").trim()){try{v.d&&v.d.cancel()}catch(x){}shOpen("slow_tap");return}
        shSay('<div class="shmic-st">Sending to Shepherd…</div><p class="shmic-say">'+shEsc(v.text)+"</p>");
        v.d.stop().then(function(text){
          text=String(text||v.text||"").trim();
          if(!text){shSay("<span>"+(held<900?"Hold the button while you talk.":"Didn’t catch anything.")+"</span>",{ms:4000});shTrack("empty",{ms:held});return}
          shAsk(text);
        });
      };
      // Drag to move, as the comment button does: a press that moves before the hold
      // starts is a drag (6 px with a mouse, 10 with a finger, which wanders while it
      // holds still); one that stays put becomes the hold, and from then on sliding
      // away is what drops the words. The place is kept per browser ("ss-shmic-pos":
      // px from the left and bottom edges, the corner the button lives in), applied
      // inline, and the bubble follows it. A drop back near the corner forgets it.
      var SHPOS="ss-shmic-pos",shPos=null;
      var shClamp=function(p){var w=shBtn.offsetWidth||52,h=shBtn.offsetHeight||52,m=8;return{l:Math.max(m,Math.min(innerWidth-w-m,p.l)),b:Math.max(m,Math.min(innerHeight-h-m,p.b))}};
      var shPlace=function(){
        var bs=shBub.style;bs.left=bs.right=bs.top=bs.bottom="";shBub.style.transformOrigin="";
        if(!shPos){shMic.style.left=shMic.style.bottom="";return}
        var p=shClamp(shPos),w=shBtn.offsetWidth||52,h=shBtn.offsetHeight||52,top=innerHeight-p.b-h;
        shMic.style.left=p.l+"px";shMic.style.bottom=p.b+"px";
        // The bubble opens above the button in the lower half, below it in the upper
        // half, on the side of the screen the button is on.
        var right=p.l+w/2>innerWidth/2;
        if(top>innerHeight/2)bs.bottom=(p.b+h+12)+"px";else{bs.top=(top+h+12)+"px";bs.bottom="auto"}
        if(right){bs.right=Math.max(16,innerWidth-p.l-w)+"px";bs.left="auto"}else bs.left=Math.max(16,p.l)+"px";
        bs.transformOrigin=(right?"right ":"left ")+(top>innerHeight/2?"bottom":"top");
      };
      try{var shp0=JSON.parse(localStorage.getItem(SHPOS)||"null");if(shp0&&typeof shp0.l==="number"&&typeof shp0.b==="number"){shPos=shp0;shPlace()}}catch(x){}
      addEventListener("resize",function(){if(shPos)shPlace()});
      shBtn.addEventListener("pointerdown",function(e){
        if(!e.isPrimary||e.button>0||shPress)return;
        try{shBtn.setPointerCapture(e.pointerId)}catch(x){}
        shMic.classList.add("is-press");
        var r=shMic.getBoundingClientRect();
        shPress={id:e.pointerId,at:Date.now(),held:false,moved:false,x:e.clientX,y:e.clientY,l:r.left,b:innerHeight-r.bottom,slop:e.pointerType==="mouse"?6:10,t:canVoice()?setTimeout(function(){if(shPress&&!shPress.moved){shPress.held=true;holdStart()}},HOLD_MS):0};
      });
      shBtn.addEventListener("pointermove",function(e){
        var p=shPress;if(!p||e.pointerId!==p.id||p.held)return;
        var dx=e.clientX-p.x,dy=e.clientY-p.y;
        if(!p.moved){if(Math.abs(dx)+Math.abs(dy)<p.slop)return;p.moved=true;clearTimeout(p.t);shMic.classList.remove("is-press");shMic.classList.add("is-dragging");if(!shVoice)shHide()}
        shPos=shClamp({l:p.l+dx,b:p.b-dy});shPlace();
      });
      var shUp=function(e,cancel){
        var p=shPress;if(!p||e.pointerId!==p.id)return;shPress=null;clearTimeout(p.t);shMic.classList.remove("is-press","is-dragging");
        if(p.moved){
          shSwallow=Date.now()+600;
          var saved=shPos;shPos=null;shPlace();var home=shMic.getBoundingClientRect();
          if(Math.abs(home.left-saved.l)<32&&Math.abs(innerHeight-home.bottom-saved.b)<32){try{localStorage.removeItem(SHPOS)}catch(x){}}
          else{shPos=saved;shPlace();try{localStorage.setItem(SHPOS,JSON.stringify(shPos))}catch(x){}}
          shTrack("moved",{home:!shPos});return;
        }
        if(p.held){
          shSwallow=Date.now()+600;
          // Let go off the button: dropped, like the composers' mic.
          var r=shBtn.getBoundingClientRect(),away=cancel||e.clientX<r.left-24||e.clientX>r.right+24||e.clientY<r.top-24||e.clientY>r.bottom+24;
          if(away&&shVoice){holdEnd(true);shSay("<span>Dropped — nothing was sent.</span>",{ms:2500});shTrack("cancel");return}
          holdEnd(false);return;
        }
        if(cancel)return;
        // A long press with no dictation behind it: a touch screen sends no click after
        // one, so it opens here. It waited for the release so a slow press can still drag.
        if(Date.now()-p.at>=HOLD_MS){shSwallow=Date.now()+600;shOpen("hold_no_voice")}
      };
      shBtn.addEventListener("pointerup",function(e){shUp(e,false)});
      shBtn.addEventListener("pointercancel",function(e){shUp(e,true)});
      shBtn.addEventListener("contextmenu",function(e){e.preventDefault()});
      // A tap, or the keyboard's Enter or Space (a click with no pointer behind it). On
      // the click, not the pointerup: a phone sends its click after the finger lifts,
      // and with the button already hidden that click would land on the drawer. The
      // click a drag or a hold ends on is not a tap.
      shBtn.addEventListener("click",function(e){if(Date.now()<shSwallow)return;if(e.detail>0)shTapped={at:Date.now(),x:e.clientX,y:e.clientY};shOpen(e.detail===0?"keyboard":"tap")});
      // The button hides as the drawer slides in under the pointer, so the second click
      // of an old double-click habit would land on Attach or the upgrade link. Only a
      // click on that same spot is dropped; the rest of the drawer works at once.
      window.addEventListener("click",function(e){var t=shTapped;if(!t||e.detail<1||e.target===shBtn||Date.now()-t.at>=450||Math.abs(e.clientX-t.x)+Math.abs(e.clientY-t.y)>30||!chat.contains(e.target))return;e.stopImmediatePropagation();e.preventDefault()},true);
      // Dictation rides in Speak's element, so only the page can say who has it: the
      // labels and the ring promise a hold only to them, and they get one tip, once
      // nothing else is talking on the page. Holding before the tip cancels the tip.
      var shShown=function(id){var el=document.getElementById(id);return !!(el&&!el.hidden)};
      var shLabel=function(){if(!canVoice())return;shMic.classList.add("can-talk");shBtn.title="Shepherd · click to chat, hold to talk, drag to move"};
      shLabel();addEventListener("load",shLabel);
      var shTip=function(n){
        if(!canVoice())return;
        try{if(localStorage.getItem(SHTIP))return}catch(x){return}
        if(window.ssShareHintDue&&!window.ssShareHintDone){addEventListener("ss:share-hint-done",function(){setTimeout(function(){shTip(n)},1200)},{once:true});return}
        if(!shBub.hidden||shShown("cfabBub")||shShown("ssSpeakGuide")||shShown("ssSpeakPop")){if(n<8)setTimeout(function(){shTip(n+1)},3000);return}
        if(open||shVoice||shPress||!shBtn.offsetWidth)return;
        try{localStorage.setItem(SHTIP,"1")}catch(x){}
        shSay("<span><b>"+(window.matchMedia("(pointer:coarse)").matches?"Tap":"Click")+" to chat.</b> Hold to talk.</span>",{ms:7000});
        shTrack("tip");
      };
      setTimeout(function(){shTip(0)},2600);
      window.addEventListener("ss:chat-drawer",function(){if(open)shHide()});
    }

    // Restore before considering the blank-document welcome. An explicit closed
    // choice wins over that default; links and composer actions can still open it.
    var savedOpen=sidebarState.read();
    if(savedOpen!==null)toggle(savedOpen,"restore");
    else if(introOn())toggle(true,"default");

    // The frame URL, subpath and reload guards belong to the viewer shell's
    // closure. Calling its private withSub/FRAMEBASE here threw after settlement
    // but before render, leaving the completed turn's working UI frozen.
    function reloadContent(sha){if(window.__ssBumpFrame)window.__ssBumpFrame(sha)}

    // The panel is a room: everyone who can open it sees the same thread, and one
    // turn at a time runs on the space — from here, from Telegram, from a task.
    // "blank" is the dashboard too — it only distinguishes the starter scaffold
    // from a document the dashboard was handed (blankDocFirstRun), and the reader
    // has no use for that distinction in a version line.
    var VIA_LABEL={viewer:"the panel",telegram:"Telegram",web:"Messages",imessage:"iMessage",whatsapp:"WhatsApp",slack:"Slack",task:"a scheduled task",dashboard:"the dashboard",blank:"the dashboard",mcp:"an MCP client"};
    // The turn strip's own escape (csEsc below is the chat bubbles').
    function esc(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")}
    function whenShort(iso){try{return new Date(iso).toLocaleTimeString(undefined,{hour:"numeric",minute:"2-digit"})}catch(e){return ""}}
    // The thread's participants, not who is looking now — the header rail above
    // already has the live viewers.
    function renderFaces(){
      if(!facesEl)return;var seen={},list=[];
      history.forEach(function(m){var e=m.kind==="version"?m.author.seed:m.seed;if(!e||seen[e])return;seen[e]=1;list.push(m.kind==="version"?m.author:{seed:m.seed,name:m.name,picture:m.picture})});
      // A room of one is not a room: my own face alone in the header says nothing.
      if(!list.some(function(p){return p.seed!==ME})){facesEl.innerHTML="";return}
      facesEl.innerHTML=list.slice(0,5).map(function(p){return ssAvatar({seed:p.seed,name:p.name||"?",picture:p.picture,size:"sm"})}).join("");
    }
    function setTurn(holder){
      turnHolder=holder;
      var mine=!!(holder&&holder.seed===ME);
      // Nobody's turn locks the composer any more: a send made while the space is
      // held waits in the queue and goes out when the holder lets go. A reader never
      // waits on the space at all: their ask cannot write the page, and the server
      // takes it beside the running turn — the strip alone tells them an edit is in
      // flight.
      syncSend();renderQueue();pump();
      if(!turnEl)return;
      // My own turn from THIS tab is already a bubble with its own Stop, so the
      // strip would only repeat it. One I started in ANOTHER tab has no bubble
      // here — without the strip nothing on this page says why a send is refused.
      var elsewhere=mine&&!busy&&!watchers[holder.run_id];
      if(!holder||(mine&&!elsewhere)){turnEl.hidden=true;turnEl.innerHTML="";return}
      // Stop belongs to the author and to the space's owner; on my own turn I am
      // the author.
      var canStop=mine||!!(cfg&&cfg.is_owner);
      var body='<span class="txt">'+(mine?'<span class="ask">Your ask is still working…</span>'
        :'<span class="who">'+esc(holder.name)+"'s "+(holder.surface==="viewer"?"Shepherd":"agent on "+esc(VIA_LABEL[holder.surface]||holder.surface))+'</span> <span class="ask">'+(holder.verify?"is checking its change on the page":"is working"+(holder.ask?": "+esc(holder.ask):""))+'</span>')+'</span>';
      turnEl.innerHTML='<span class="spin" aria-hidden="true"></span>'+ssAvatar({seed:holder.seed,name:holder.name,picture:holder.picture,size:"sm"})+body+(canStop?'<button type="button" class="chat-stop" data-run="'+esc(holder.run_id)+'">Stop</button>':"");
      turnEl.hidden=false;
    }
    // Someone else's turn started: their ask joins the thread and a streaming
    // bubble follows it, fed by ss:chat events keyed on the run.
    // One of MY turns is followed too when this tab isn't the one posting it: an
    // ask spoken to Speak, or sent from another tab, had no bubble here at all.
    // A turn asked in a comment talks in that comment's thread: here it is one line,
    // drawn once it is over, pointing at the thread (markComment, commentLine).
    function markComment(runId,root){
      var hit=false;history.forEach(function(m){if(m.runId===runId&&(m.role==="user"||m.role==="assistant")){if(!m.comment)hit=true;m.comment=true;if(root&&!m.commentRoot)m.commentRoot=root}});
      return hit;
    }
    function followTurn(holder){
      // The holder's announcement can beat the ask's: whichever says "comment" marks the run.
      if(holder&&!holder.comment&&history.some(function(m){return m.runId===holder.run_id&&m.comment}))holder.comment=true;
      if(holder&&holder.comment&&markComment(holder.run_id,holder.commentRoot))render();
      if(holder&&holder.files&&holder.files.length){var had=null;history.forEach(function(m){if(m.role==="user"&&m.runId===holder.run_id)had=m});if(had&&!had.files){had.files=holder.files;render()}}
      if(!holder||watchers[holder.run_id])return;
      var mine=holder.seed===ME;
      if(mine&&posting>0)return;
      // The ask was written to the thread when the turn was taken, so a panel that
      // loaded mid-turn already has it — only add the ones that aren't here yet.
      // A check is the agent looking at its own change: no one asked it, so no bubble.
      if(!holder.verify&&!history.some(function(m){return m.role==="user"&&m.runId===holder.run_id}))history.push({role:"user",content:holder.ask||"",seed:holder.seed,name:holder.name,picture:holder.picture,surface:holder.surface,runId:holder.run_id,files:holder.files||undefined,comment:!!holder.comment,commentRoot:holder.commentRoot||null});
      var asst={role:"assistant",content:"",edits:[],streaming:true,to:holder.name,runId:holder.run_id,foreign:true,mine:mine,steps:holder.verify?[{t:"shot",pending:false,ok:true}]:[],comment:!!holder.comment,commentRoot:holder.commentRoot||null};
      history.push(asst);
      watchTurn({id:holder.run_id,edit:true,seed:holder.seed},null,asst,false);
      render();
      if(mine)setTurn(turnHolder);
    }
    window.addEventListener("ss:turn",function(e){
      var h=e.detail&&e.detail.holder;
      setTurn(h||null);
      // The presence socket announces the turn at page load, before the panel has a
      // thread to hang bubbles on; loadConfig follows whatever is running when it lands.
      if(h&&cfg)followTurn(h);
    });
    turnEl&&turnEl.addEventListener("click",function(e){var b=e.target.closest(".chat-stop");if(b){e.preventDefault();stopTurn(b.getAttribute("data-run"),b)}});

    var lastBd=null;
    // How the thread scrolls is ssThread's (jump-to-latest.ts): a send puts the ask at
    // the top of the view and the reply grows below it, never followed; ↓ goes to the
    // end; a redraw keeps the reader's place.
    
  function ssThread(box,btn,o){
    var GAP=(o&&o.gap)||12,pin=null,spacer=null,raf=0,trim=null;
    var smooth=!(window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches);
    function spH(){return spacer&&spacer.parentNode===box?spacer.offsetHeight:0}
    function place(h){
      if(!spacer){spacer=document.createElement("div");spacer.className="ss-thread-spacer";spacer.setAttribute("aria-hidden","true")}
      if(box.lastChild!==spacer)box.appendChild(spacer);
      if(h!=null)spacer.style.height=h+"px";
    }
    // The thread's height without the spacer, and the scrollTop that shows its end.
    function bare(){return box.scrollHeight-spH()}
    function endTop(){return Math.max(0,bare()-box.clientHeight)}
    function topOf(el){return el.getBoundingClientRect().top-box.getBoundingClientRect().top+box.scrollTop}
    function blocks(){var out=[];for(var i=0;i<box.children.length;i++)if(box.children[i]!==spacer)out.push(box.children[i]);return out}
    // The pinned ask, found again after a redraw replaced its node (by its message).
    function pinned(){
      if(!pin)return null;
      if(pin.el&&pin.el.isConnected)return pin.el;
      if(pin.k){var list=blocks();for(var i=0;i<list.length;i++)if(list[i].__k===pin.k)return pin.el=list[i]}
      return null;
    }
    function show(){if(btn)btn.hidden=!box.clientHeight||box.scrollTop>=endTop()-8}
    // The spacer is what the view needs and no more: room under a pinned ask while
    // its turn runs, otherwise just enough to keep the view where it is.
    function size(){
      if(!box.clientHeight){show();return}
      place();
      var cur=spH(),b=box.scrollHeight-cur,want=box.scrollTop;
      var p=pinned();if(p)want=Math.max(want,topOf(p)-GAP);
      var need=Math.max(0,Math.ceil(want+box.clientHeight-b));
      // Settling: the spacer eases down to nothing, and the browser brings the
      // thread's end down with it (scrollTop can't stay past the new bottom).
      if(trim&&!p){var q=Math.min(1,(Date.now()-trim.t0)/trim.ms);need=Math.min(need,Math.round(trim.from*(1-q)*(1-q)));if(q>=1)trim=null;else soon()}
      if(need!==cur)spacer.style.height=need+"px";
      show();
    }
    function soon(){if(!raf)raf=requestAnimationFrame(function(){raf=0;size()})}
    box.addEventListener("scroll",soon,{passive:true});
    if(window.ResizeObserver)new ResizeObserver(soon).observe(box);
    if(btn)btn.addEventListener("click",function(){box.scrollTo({top:endTop(),behavior:smooth?"smooth":"auto"})});
    return{
      size:size,
      // Before a redraw that replaces the blocks: the first one in view, by its
      // message (else its place), and how far down the view it starts.
      before:function(){
        var st={sh:spH(),top:box.scrollTop,a:null};
        if(!box.clientHeight)return st;
        var top=box.getBoundingClientRect().top,list=blocks();
        for(var i=0;i<list.length;i++){var r=list[i].getBoundingClientRect();if(r.bottom>top){st.a={k:list[i].__k,i:i,d:r.top-top};break}}
        return st;
      },
      after:function(st){
        place(st?st.sh:0);
        if(st&&box.clientHeight){
          var el=null,list=blocks(),a=st.a,i;
          if(a&&a.k)for(i=0;i<list.length;i++)if(list[i].__k===a.k){el=list[i];break}
          if(!el&&a&&!a.k)el=list[a.i];
          if(el)box.scrollTop+=el.getBoundingClientRect().top-box.getBoundingClientRect().top-a.d;
          else box.scrollTop=st.top;
        }
        size();
      },
      // Their own message: to the top of the view, with room for the reply below.
      pinTo:function(el){
        trim=null;pin=el?{el:el,k:el.__k}:null;size();
        if(pin)box.scrollTop=Math.max(0,topOf(el)-GAP);
        show();
      },
      unpin:function(){pin=null;size()},
      // The turn is over: let go of the ask and take the blank away below it.
      settle:function(){pin=null;var h=spH();trim=h>0?{from:h,t0:Date.now(),ms:smooth?220:0}:null;size()},
      // Opening the thread: the latest exchange, its ask at the top. While that turn
      // still runs the ask holds its place as after a send; a finished exchange
      // shorter than the view shows the end instead of a blank.
      land:function(el,running){
        trim=null;place(0);
        if(!el){pin=null;box.scrollTop=endTop();size();return}
        if(running){pin={el:el,k:el.__k};size();box.scrollTop=Math.max(0,topOf(el)-GAP);size();return}
        pin=null;box.scrollTop=Math.min(Math.max(0,topOf(el)-GAP),endTop());size();
      }
    };
  }
  
    var thread=ssThread(msgs,document.getElementById("chatJump"),{gap:12});

    // Debug (the status line's switch, per device, 2026-11-01): what a turn of yours is doing
    // and how fast, live. The panel's own events (first word, steps, tools, page changes)
    // on one clock from Send, the streamed words as tokens a second (4 characters a
    // token), and the run's ledger lines and token counts from /api/agent/status — the
    // same digest the agent_status tool reads. Only your own turns: the ledger is yours.
    var dbgBtn=document.getElementById("chatDbgBtn"),dbgEl=document.getElementById("chatDbg");
    var dbg={on:false,run:null,model:"",sent:0,first:0,chars:0,log:[],end:0,ledger:null,poll:null,tick:null};
    // No button: the coshep_debug switch is off for this reader, so nothing draws.
    try{dbg.on=!!dbgBtn&&localStorage.getItem("ss-coshep-debug")==="1"}catch(e){}
    function dbgSet(on){dbg.on=on;try{localStorage.setItem("ss-coshep-debug",on?"1":"0")}catch(e){}if(dbgBtn)dbgBtn.setAttribute("aria-pressed",on?"true":"false");if(dbgEl)dbgEl.hidden=!on;if(on){dbgRender();if(dbg.run&&!dbg.end)dbgPoll()}if(window.mixpanel)mixpanel.track("Co-shepherd Debug Switched",{on:on})}
    if(dbgBtn)dbgBtn.addEventListener("click",function(){dbgSet(!dbg.on)});
    // Fast lane only (beta): every send asks the server to keep the turn in the lane.
    var fastBtn=document.getElementById("chatFastBtn");
    try{window.ssFastOnly=!!fastBtn&&localStorage.getItem("ss-coshep-fast-only")==="1"}catch(e){}
    if(fastBtn){
      fastBtn.setAttribute("aria-pressed",window.ssFastOnly?"true":"false");
      fastBtn.addEventListener("click",function(){window.ssFastOnly=!window.ssFastOnly;try{localStorage.setItem("ss-coshep-fast-only",window.ssFastOnly?"1":"0")}catch(e){}fastBtn.setAttribute("aria-pressed",window.ssFastOnly?"true":"false");if(window.mixpanel)mixpanel.track("Co-shepherd Fast Lane Only Switched",{on:!!window.ssFastOnly})});
    }
    // No thinking (beta): the lane's model answers without thinking first.
    var thinkBtn=document.getElementById("chatThinkBtn");
    try{window.ssNoThink=!!thinkBtn&&localStorage.getItem("ss-coshep-no-think")==="1"}catch(e){}
    if(thinkBtn){
      thinkBtn.setAttribute("aria-pressed",window.ssNoThink?"true":"false");
      thinkBtn.addEventListener("click",function(){window.ssNoThink=!window.ssNoThink;try{localStorage.setItem("ss-coshep-no-think",window.ssNoThink?"1":"0")}catch(e){}thinkBtn.setAttribute("aria-pressed",window.ssNoThink?"true":"false");if(window.mixpanel)mixpanel.track("Co-shepherd No Thinking Switched",{on:!!window.ssNoThink})});
    }
    function dbgS(ms){return (ms/1e3).toFixed(1)+"s"}
    function dbgLog(s){dbg.log.push({t:Date.now()-dbg.sent,s:s});if(dbg.log.length>120)dbg.log.shift()}
    function dbgStart(run,sent){
      clearInterval(dbg.poll);clearInterval(dbg.tick);
      dbg={on:dbg.on,run:run.id,model:(run.provider?run.provider+" · ":"")+(run.model||""),sent:sent||Date.now(),first:0,chars:0,log:[],end:0,ledger:null,poll:null,tick:null};
      dbgLog("sent");dbg.tick=setInterval(dbgRender,250);dbg.poll=setInterval(dbgPoll,1500);dbgPoll();dbgRender();
    }
    function dbgEvent(id,d){
      if(!dbg.run||id!==dbg.run||dbg.end||!d)return;var t=d.type;
      if(t==="delta"){if(d.text){if(!dbg.first){dbg.first=Date.now();dbgLog("first word")}dbg.chars+=String(d.text).length}return}
      if(t==="status"&&d.text)dbgLog(String(d.text));
      else if(t==="step")dbgLog("step "+d.n+(d.max?" of "+d.max:""));
      else if(t==="tool")dbgLog("tool "+(d.tool||"")+(d.integration?" "+d.integration:"")+(d.query?" “"+String(d.query).slice(0,70)+"”":d.url?" "+String(d.url).slice(0,70):""));
      else if(t==="result")dbgLog("result "+(d.ok===false?"failed"+(d.error?": "+String(d.error).slice(0,70):""):"ok"));
      else if(t==="op")dbgLog("page change: "+(d.op||"")+" "+(d.anchor||"")+(d.matched===false?" (matched nothing)":""));
      else if(t==="handed")dbgLog("handed up to the agent");
      else if(t==="restart")dbgLog("started over: "+(d.text||""));
      else if(t==="screenshot")dbgLog("asked for a screenshot");
      else if(t==="done"||t==="error"){dbgLog(t==="done"?"done":"error: "+(d.message||""));dbgEnd();return}
      dbgRender();
    }
    function dbgEnd(){if(dbg.end)return;dbg.end=Date.now();clearInterval(dbg.tick);clearInterval(dbg.poll);setTimeout(dbgPoll,1500);setTimeout(dbgPoll,6000);dbgRender()}
    function dbgPoll(){
      if(!dbg.on||!dbg.run)return;var run=dbg.run,sent=dbg.sent;
      fetch("/api/agent/status?hours=1&events=all&recent=12").then(function(r){return r.ok?r.json():null}).then(function(j){
        if(!j||dbg.run!==run)return;
        var all=(j.active||[]).concat(j.recent||[]),best=null,bestGap=Infinity;
        all.forEach(function(r){if(!r||!r.link||String(r.link).indexOf(spaceId)<0)return;var gap=Math.abs(Date.parse(r.created_at)-sent);if(gap<15000&&gap<bestGap){best=r;bestGap=gap}});
        if(best){dbg.ledger=best;dbgRender()}
      }).catch(function(){});
    }
    function dbgRender(){
      if(!dbgEl||!dbg.on)return;
      if(!dbg.run){dbgEl.innerHTML='<div class="dbg-h">Debug is on. Send something to see what it does and how fast.</div>';return}
      // The model's speed is the ledger's output tokens over its model time (start →
      // end, less the setup before the first call), which counts everything it wrote:
      // the page, tool arguments and the reply. The reply bubble's words are a small
      // part of that (2026-11-01: ≈17 tokens shown as "2 tok/s" on a run that wrote
      // 3,212 tokens in 11 s), so they are only counted, never turned into a rate.
      var now=dbg.end||Date.now(),L=dbg.ledger,toks=Math.round(dbg.chars/4);
      var rate=null,secs=null;
      if(L&&L.output_tokens&&L.started_at){var st=Date.parse(L.started_at),fin=L.finished_at?Date.parse(L.finished_at):Date.now();secs=(fin-st-((L.spans&&L.spans.prep)||0))/1e3;if(secs>0.3)rate=Math.round(L.output_tokens/secs)}
      var h='<div class="dbg-h"><b>'+csEsc(L&&L.model?L.model:dbg.model)+'</b> · '+dbgS(now-dbg.sent)+(dbg.end?' total':'')+' · first word in the reply '+(dbg.first?dbgS(dbg.first-dbg.sent):'—')+'</div>';
      h+='<div class="dbg-h">'+(rate!=null?'<b>'+rate+' tok/s</b> model output · ':'')+(L&&L.output_tokens!=null?L.output_tokens+' tokens out in '+(secs!=null?secs.toFixed(1)+'s':'—')+' of model time':'model speed after the ledger reports tokens')+'</div>';
      if(L){h+='<div class="dbg-h">ledger: '+csEsc(L.status||"")+(L.steps!=null?' · '+L.steps+' step'+(L.steps===1?'':'s'):'')+(L.input_tokens!=null?' · in '+L.input_tokens:'')+((L.spans&&L.spans.prep)?' · setup '+dbgS(L.spans.prep):'')+' · reply words ≈'+toks+' tok</div>'}
      var rows=dbg.log.map(function(e){return {t:e.t,s:e.s,k:""}});
      if(L&&L.events)L.events.forEach(function(e){var t=Date.parse(e.at)-dbg.sent;rows.push({t:isFinite(t)?t:1e9,s:e.note,k:"led"})});
      rows.sort(function(a,b){return a.t-b.t});
      h+='<ol class="dbg-log">'+rows.map(function(e){return '<li'+(e.k?' class="dbg-'+e.k+'"':'')+'><span>+'+(e.t<1e9?dbgS(e.t):'?')+'</span>'+csEsc(e.s)+'</li>'}).join("")+'</ol>';
      dbgEl.innerHTML=h;
    }
    dbgSet(dbg.on);
    function askEl(m){var k=msgs.children;for(var i=0;i<k.length;i++)if(k[i].__k===m)return k[i];return null}
    function lastAsk(){for(var i=history.length-1;i>=0;i--){var m=history[i];if(m.role==="user"&&!m.kind&&!m.origin)return m}return null}
    // Their own ask (a send, a queued one going out, a retry) goes to the top.
    function pinAsk(m){thread.pinTo(m?askEl(m):null)}
    // Opening the drawer, or the thread arriving: the latest exchange. A thread
    // nobody has spoken in opens on the intro at its top, if it has one.
    function landThread(){
      if(!loaded||!cfg||!cfg.available)return;
      var m=lastAsk();
      if(!m&&msgs.querySelector(".chat-intro")){thread.size();return}
      thread.land(m?askEl(m):null,busy);
    }
    var SS_INT_NAMES={"you":"you.com"};function ssIntName(id){return SS_INT_NAMES[id]||id||""}
    function csEsc(s){var d=document.createElement("div");d.textContent=String(s==null?"":s);return d.innerHTML.replace(/"/g,"&quot;").replace(/'/g,"&#39;")}
    
    function csSearchInfo(s){
      if(s.t!=="fetch")return null;
      var q=typeof s.query==="string"?s.query.trim():"",u=null;
      try{u=new URL(s.url);if(!q){var keys=["q","query","search","search_query","keyword","keywords","term","text"];for(var i=0;i<keys.length;i++){q=(u.searchParams.get(keys[i])||"").trim();if(q)break}}}catch(e){}
      // A known search with no retained terms still gets a useful label. Other
      // integration calls must not be presented as searches.
      if(!q&&!(s.integration==="you"&&u&&u.pathname==="/v1/search"))return null;
      var sites=[];
      q=q.replace(/(^|\s)site:([a-z0-9.-]+)(?=\s|$)/gi,function(_,space,host){host=host.toLowerCase().replace(/^www\./,"");if(sites.indexOf(host)<0)sites.push(host);return space});
      var source=sites.length===1?(sites[0]==="commons.wikimedia.org"?"Wikimedia Commons":sites[0]):"the web";
      // Queries sometimes contain a URL too; show its host, never a request path.
      q=q.replace(/https?:\/\/\S+/gi,function(v){try{return new URL(v).hostname}catch(e){return ""}}).replace(/\s+/g," ").trim().slice(0,160);
      return{source:source,terms:q,sites:sites,provider:ssIntName(s.integration)};
    }
    function csSearchGroup(m,group,start){
      var infos=group.map(csSearchInfo),source=infos[0].source;
      if(infos.some(function(x){return x.source!==source}))source="the web";
      var pending=group.some(function(s){return s.pending&&m.streaming}),failed=group.filter(function(s){return s.ok===false}).length;
      var interrupted=group.filter(function(s){return s.pending&&!m.streaming&&s.ok!==false}).length;
      var incomplete=failed+interrupted;
      var label=pending?"Searching "+source+"…":incomplete===group.length?(group.length===1?"Couldn’t complete the search":"Couldn’t complete the searches"):"Searched "+source;
      var count=group.length,open=m.searchOpen&&m.searchOpen[start];
      var h='<details class="chat-search" data-search="'+start+'" data-count="'+count+'"'+(open?' open':'')+'><summary>'+csEsc(label);
      if(count>1)h+=' <span class="chat-search-count">· '+count+' searches</span>';
      if(incomplete&&incomplete!==count)h+=' <span class="chat-search-note">· '+incomplete+' incomplete</span>';
      h+='</summary><div class="chat-search-list">';
      group.forEach(function(s,i){var x=infos[i],state=s.ok===false?'Couldn’t complete this search':s.pending?(m.streaming?'Searching…':'Incomplete'):'';
        var context=x.sites.length?('On '+(x.source==="the web"?x.sites.join(', '):x.source)):'';
        h+='<div class="chat-search-item">'+csEsc(x.terms||('Search '+x.source))+(state?' <span class="'+(s.ok===false||!m.streaming?'chat-search-note':'chat-search-via')+'">· '+state+'</span>':'')+'<span class="chat-search-via">'+csEsc(context+(context&&x.provider?' · ':'')+(x.provider?'via '+x.provider:''))+'</span></div>';
      });
      h+='</div></details>';
      // Keep failures visible even when the details are closed. Upstream errors
      // can contain request URLs, so never print the raw error in this activity.
      if(incomplete)h+='<div class="chat-search-notice">'+(incomplete===1?'One search couldn’t be completed.':'Some searches couldn’t be completed.')+' See details.</div>';
      return h;
    }
    function csSearchToggle(e){
      var d=e.target;if(!d||!d.isConnected||!d.classList.contains("chat-search"))return;
      var bd=d.closest(".chat-md"),m=bd&&bd.__msg;if(!m)return;
      var key=d.getAttribute("data-search");if(!m.searchOpen)m.searchOpen={};
      if(!!m.searchOpen[key]===d.open)return;
      m.searchOpen[key]=d.open;
      if(window.mixpanel)try{mixpanel.track(d.open?"AI Chat Search Details Opened":"AI Chat Search Details Closed",{space_id:spaceId,surface:"viewer",search_count:Number(d.getAttribute("data-count"))})}catch(e){}
    }
    msgs.addEventListener("toggle",csSearchToggle,true);

    function stepsHtml(m){
      if(!m.steps||!m.steps.length)return"";
      var rows=[];
      for(var i=0;i<m.steps.length;i++){
        var s=m.steps[i],ic=s.pending?"⟳":(s.ok===false?"⚠":"✓");
        if(csSearchInfo(s)){
          var start=i,group=[s];
          while(i+1<m.steps.length&&csSearchInfo(m.steps[i+1]))group.push(m.steps[++i]);
          rows.push(csSearchGroup(m,group,start));continue;
        }
        if(s.t==="list"){rows.push('<div class="chat-step"><span class="cs-ic">🔌</span>Checked connected integrations</div>');continue}
        if(s.t==="shot"){rows.push('<div class="chat-step"><span class="cs-ic">'+(s.pending?"⟳":(s.ok===false?"⚠":"📸"))+'</span>'+(s.ok===false?"Couldn't screenshot":(s.pending?"Screenshotting to verify…":"Verified against a screenshot"))+(s.error?' <span class="cs-err">'+csEsc(s.error)+'</span>':'')+'</div>');continue}
        if(s.t==="comment"){rows.push('<div class="chat-step"><span class="cs-ic">'+(s.ok===false?"⚠":"💬")+'</span>'+csEsc(s.label||"comment")+(s.error?' <span class="cs-err">'+csEsc(s.error)+'</span>':'')+'</div>');continue}
        // The same request to the same integration in a row is one line with a count:
        // eleven "Sent a request to tavily" lines said nothing the twelfth didn't.
        var line=fetchLine(m,s),n=1;
        while(i+1<m.steps.length&&m.steps[i+1].t==="fetch"&&!csSearchInfo(m.steps[i+1])&&fetchLine(m,m.steps[i+1])===line){i++;n++}
        rows.push('<div class="chat-step"><span class="cs-ic">'+ic+'</span>'+csEsc(line)+(n>1?' <span class="cs-n">· '+n+' times</span>':'')+'</div>');
      }
      return '<div class="chat-steps">'+rows.join("")+'</div>';
    }
    function fetchLine(m,s){
      var name=ssIntName(s.integration)||"an integration",verb=s.pending?(m.streaming?"Connecting to ":"Connection interrupted: "):(s.ok===false?"Couldn’t complete the request to ":String(s.method||"GET").toUpperCase()==="GET"?"Read from ":"Sent a request to ");
      return verb+name;
    }
    // The run's steps, drawn where the ask is (design-explorations/
    // coshepherd-working-in-drawer.html, variant C — it replaced the card that floated
    // over the page). The steps are the room's status (shared/live-layer.ts foldStatus,
    // relayed by the shell as ss:work); the room keeps only the last few, so the drawer
    // keeps every step it has heard, per run. A turn that never says a step still gets
    // a working line once it has been quiet for a while: a build on a thinking model can
    // be silent for minutes, and a bare caret over that read as a dead session (2026-09-27).
    var room={st:null,skew:0},trails={},openWorked={};
    function dur(n){n=Math.max(0,Math.round(n));return n>=60?Math.floor(n/60)+"m "+(n%60)+"s":n+"s"}
    function clockOf(ms){var s=Math.max(0,Math.floor(ms/1e3)),m=Math.floor(s/60);return m>=60?Math.floor(m/60)+"h "+(m%60)+"m":m+":"+(s%60<10?"0":"")+(s%60)}
    // The room's times are its own clock; skew turns them into this machine's.
    function roomNow(){return Date.now()-room.skew}
    // A Co-shepherd status with no word for ten minutes is gone: the run died without
    // clearing it (the same rule the card had).
    function roomLive(st){return !!st&&!st.stopped&&roomNow()-(st.updated||st.at)<=6e5}
    function trailKey(st){return st.run_id||"lane"}
    // The room says the Co-shepherd is at work, on a run that hasn't ended here.
    function roomWorking(){var st=room.st;if(!roomLive(st))return false;var t=trails[trailKey(st)];return !(t&&t.done)}
    function noteTrail(st){
      var k=trailKey(st),t=trails[k];
      // A lane's steps carry no run: a status that began after the last one finished
      // is a new run.
      if(t&&t.done&&st.since>t.since)t=null;
      if(!t)t=trails[k]={since:st.since,items:{},cur:null,done:false};
      if(st.since<t.since)t.since=st.since;
      (st.steps||[]).forEach(function(x){t.items[x.at]=x.text});
      t.items[st.at]=st.text;t.cur=st.at;
      return t;
    }
    function trailSteps(t){return Object.keys(t.items).map(Number).sort(function(a,b){return a-b}).map(function(at){return{at:at,text:t.items[at]}})}
    // The steps the run said, frozen when it ends: how long each took, and in all.
    function freezeTrail(m){
      if(m.worked||!m.trail)return;
      var t=trails[m.trail];if(!t)return;
      // The run is over here, whatever the room still says until its clear arrives.
      t.done=true;
      var end=roomNow(),steps=trailSteps(t);if(!steps.length)return;
      m.worked={ms:end-t.since,steps:steps.map(function(x,i){return{text:x.text,ms:(i+1<steps.length?steps[i+1].at:end)-x.at}})};
    }
    // The bubble a status belongs to: its own run's, or — a lane's few words carry no
    // run — the one still working.
    function boundMsg(st){
      var last=null;
      for(var i=history.length-1;i>=0;i--){var m=history[i];if(m.role!=="assistant")continue;
        if(st.run_id){if(m.runKey===st.run_id)return m}
        else if(m.streaming&&!last)last=m}
      return last;
    }
    function stepRow(text,right,now,since){
      return '<div class="chat-wstep'+(now?' is-now':'')+'"'+(now?' role="status"':'')+'>'+(now?"<span class=\"ss-dots\" aria-hidden=\"true\"><i></i><i></i><i></i></span>":'<span class="wck" aria-hidden="true">'+CHECK_IC+'</span>')+'<span class="wtx">'+csEsc(text)+'</span><span class="wd"'+(since?' data-since="'+since+'"':'')+'>'+csEsc(right)+'</span></div>';
    }
    // Steps of one kind in a row ("Searching the web: …" nine times, "Writing the page
    // · <section>") fold into one line once the run has moved on to something else; the
    // group still in hand stays open. A row: {text, ms, now, since}.
    var openGroups={};
    function wKind(t){var i=t.indexOf(": "),j=t.indexOf(" · ");if(j>0&&(i<0||j<i))i=j;return i>0?t.slice(0,i):t}
    function wDetail(t){var k=wKind(t);return k.length<t.length?t.slice(k.length+(t.charAt(k.length)===":"?2:3)):t}
    function wRow(r){return stepRow(r.text,r.now?clockOf(Date.now()-r.since):dur(r.ms/1e3),r.now,r.now?r.since:0)}
    function wRows(rows,key){
      var h="";
      for(var i=0;i<rows.length;i++){
        var k=wKind(rows[i].text),j=i;
        while(j+1<rows.length&&wKind(rows[j+1].text)===k)j++;
        var g=rows.slice(i,j+1);
        if(g.length<2||g[g.length-1].now)g.forEach(function(r){h+=wRow(r)});
        else{
          var gk=key+"|"+i,ms=0;g.forEach(function(r){ms+=r.ms});
          h+='<details class="chat-wgroup" data-wg="'+csEsc(gk)+'"'+(openGroups[gk]?' open':'')+'><summary class="chat-wstep"><span class="wck" aria-hidden="true">'+CHECK_IC+'</span><span class="wtx">'+csEsc(k)+' <span class="wn">· '+g.length+' steps</span></span><span class="wd">'+dur(ms/1e3)+'</span><span class="wchev" aria-hidden="true">'+CHEV_IC+'</span></summary><div class="chat-wsub">'+g.map(function(r){return stepRow(wDetail(r.text),dur(r.ms/1e3),false)}).join("")+'</div></details>';
        }
        i=j;
      }
      return h;
    }
    // While it works: each step said so far, then the one in hand with the run's clock.
    function trailHtml(m){
      var t=m.trail?trails[m.trail]:null,rows=[],since=m.startedAt||Date.now(),now="";
      if(t){
        since=t.since+room.skew;
        var steps=trailSteps(t);
        for(var i=0;i<steps.length;i++){if(steps[i].at===t.cur){now=steps[i].text;continue}var nx=i+1<steps.length?steps[i+1].at:roomNow();rows.push({text:steps[i].text,ms:nx-steps[i].at})}
      }
      var s=(Date.now()-since)/1e3,key=m.trail||"";
      if(!now){if(!m.status&&s<8)return rows.length?'<div class="chat-work">'+wRows(rows,key)+'</div>':"";now=m.status||"Working"}
      rows.push({text:now,now:true,since:since});
      var h=wRows(rows,key);
      // A long silence is said out loud, so a slow model reads as slow, not dead —
      // and as still working: "No word from the model" read as a model that never
      // answered to a new person whose first page took two minutes (2026-10-23).
      var q=m.heardAt?(Date.now()-m.heardAt)/1e3:0;
      // A build says its thinking and its writing as steps now (agent/build-progress.ts
      // BuildNarrator), so this shows only when the model itself has sent nothing:
      // name what is being waited on, not the age of the last word.
      if(q>=60)h+='<div class="chat-wquiet">Waiting on the model · '+dur(q)+' with no news</div>';
      return '<div class="chat-work">'+h+'</div>';
    }
    // Once it's done: the steps folded into one line above the answer (render puts it
    // over the bubble's label), open on a tap.
    function workedHtml(m){
      var w=m.worked;if(!w||!w.steps.length)return "";
      var k=m.runKey||"",n=w.steps.length;
      return '<details class="chat-worked"'+(k?' data-run="'+csEsc(k)+'"':'')+(k&&openWorked[k]?' open':'')+'><summary><span class="wck" aria-hidden="true">'+CHECK_IC+'</span><span><b>Worked for '+dur(w.ms/1e3)+'</b> · '+n+(n===1?' step':' steps')+'</span><span class="wchev" aria-hidden="true">'+CHEV_IC+'</span></summary><div class="chat-wlist">'+wRows(w.steps,k)+'</div></details>';
    }
    // A reply the model wrote as HTML (a verdict per section, a flow, a table) is
    // drawn, not shown as tags: the web chats' renderer (assets/components/
    // agent-reply.ts) puts it in a shadow root in the bubble, in the panel's type
    // and colours. A reply of words keeps the panel's own markdown.
    function richReply(t){return !!(t&&window.ssAgentReply&&window.ssAgentReply.rich(t))}
    function replyHtml(m){return richReply(m.content)?'<div class="chat-rich"></div>':mdToHtml(m.content)}
    function fillRich(bd,m){var r=bd.querySelector(".chat-rich");if(r)window.ssAgentReply.render(r,m.content,{live:!!m.streaming})}
    function bubbleHtml(m){
      // The caret follows words that are arriving; the steps say the rest.
      var tr=m.streaming?trailHtml(m):"";
      return stepsHtml(m)+tr+replyHtml(m)+(m.editingNote?'<div class="chat-note">✎ Editing the document…</div>':"")+(m.streaming&&(m.content||!tr)?"<span class=\"ss-caret\" aria-hidden=\"true\"></span>":"");
    }
    // A step said with no bubble here to put it in (a lane's edit started outside this
    // panel, a run this tab hasn't followed): its own line at the foot of the thread.
    function roomBlock(){
      var st=room.st;if(!roomWorking()||boundMsg(st)||posting>0)return null;
      var b=document.createElement("div");b.className="chat-msg assistant chat-roomwork";
      var w=document.createElement("div");w.className="chat-who";w.textContent="AI";b.appendChild(w);
      var bd=document.createElement("div");bd.className="chat-md";bd.innerHTML=trailHtml({trail:trailKey(st),streaming:true});b.appendChild(bd);
      return b;
    }
    // Running = a bubble here still working, or the room saying the Co-shepherd is at
    // work on this page. It moves the line under the header and the folded drawer's
    // edge; Stop in the header is for a run this reader may stop (their own).
    var hStop=document.getElementById("chatHStop"),runTick=null;
    function stoppable(){for(var i=history.length-1;i>=0;i--){var m=history[i];if(m.role==="assistant"&&m.streaming&&m.runId&&(!m.foreign||m.mine))return m.runId}return null}
    function syncRun(){
      if(!room)return;
      var on=busy||roomWorking()||history.some(function(m){return m.role==="assistant"&&m.streaming});
      chat.classList.toggle("is-running",on);
      handle.title=on?"Shepherd is working…":"Shepherd: ask about this document";
      if(hStop){var id=stoppable();hStop.hidden=!id;if(id&&hStop.getAttribute("data-run")!==id){hStop.setAttribute("data-run",id);hStop.disabled=false}}
      // The clocks change in place, once a second, only while something is running.
      if(on&&!runTick)runTick=setInterval(function(){
        [].forEach.call(msgs.querySelectorAll(".chat-wstep [data-since]"),function(el){el.textContent=clockOf(Date.now()-Number(el.getAttribute("data-since")))});
      },1000);
      else if(!on&&runTick){clearInterval(runTick);runTick=null}
    }
    hStop&&hStop.addEventListener("click",function(e){e.preventDefault();stopTurn(hStop.getAttribute("data-run"),hStop)});
    // toggle doesn't bubble: listened for on the way down.
    msgs.addEventListener("toggle",function(e){var d=e.target;if(!d||!d.classList)return;if(d.classList.contains("chat-worked")){var k=d.getAttribute("data-run");if(k)openWorked[k]=d.open}else if(d.classList.contains("chat-wgroup"))openGroups[d.getAttribute("data-wg")]=d.open},true);
    function onWork(r){
      if(!r)return;
      if(typeof r.skew==="number")room.skew=r.skew;
      var st=r.status&&r.status.who==="Co-shepherd"?r.status:null;
      // Only a Co-shepherd status, or the clear that ends one, is ours.
      if(r.status&&!st)return;
      room.st=st;
      if(st){noteTrail(st);var m=boundMsg(st);if(m&&m.streaming&&!m.trail)m.trail=trailKey(st)}
      syncRun();
      // A drawer that can't chat (no model, no access) says so, and that stays.
      if(!loaded||!cfg||!cfg.available)return;
      var bm=st&&boundMsg(st);
      if(bm&&bm.comment&&bm.streaming)return;
      if(bm&&bm===(lastBd&&lastBd.__msg))renderLast(bm);else render();
    }
    window.addEventListener("ss:work",function(e){onWork(e.detail)});
    onWork(window.ssWorkNow?window.ssWorkNow():null);
    // Where a version came from, and the way back to its session (the server sends
    // session to the one who ran it alone).
    function versionFrom(m){var sv=m.session||{};return sv.label||(m.via&&m.via!=="viewer"&&m.via!=="edit"?(VIA_LABEL[m.via]||m.via):"")}
    function versionHref(m){var sv=m.session||{};return typeof sv.href==="string"&&((sv.href.charAt(0)==="/"&&sv.href.charAt(1)!=="/")||sv.href.indexOf("https://")===0)?sv.href:""}
    // A session that publishes thirteen times in an evening drew thirteen lines with
    // the same face and the same sentence. Versions in a row by one person from one
    // place, each within EV_GAP of the last, are one run: the first index holds the
    // run's list, the rest hold -1. Anything said between them ends the run.
    var EV_GAP=3*3600*1000,EV_SHOW=3,evOpen={};
    function versionRuns(){
      var out={},cur=null;
      history.forEach(function(m,i){
        if(m.kind==="version"&&m.via==="blank")return;
        if(m.kind!=="version"){cur=null;return}
        var key=((m.author||{}).seed||"")+"|"+versionFrom(m),t=Date.parse(m.created_at)||0;
        if(cur&&cur.key===key&&t-cur.t<=EV_GAP){cur.list.push(m);cur.t=t;out[i]=-1}
        else{cur={key:key,t:t,list:[m]};out[i]=cur.list}
      });
      return out;
    }
    // One run: who and from where once, then each version's name and time. A long
    // run shows its last EV_SHOW and folds the rest behind a button, redrawn in place
    // so opening it doesn't scroll the thread.
    function versionGroup(list){
      var first=list[0],a=first.author||{},from=versionFrom(first),key=first.sha||first.created_at;
      var fold=list.length>EV_SHOW+1,open=!!evOpen[key],hidden=fold&&!open?list.length-EV_SHOW:0;
      // One session behind the whole run: its link goes on the header, once.
      var one=versionHref(first);list.forEach(function(v){if(versionHref(v)!==one)one=""});
      function sessLink(href){return '<a class="ev-sess" href="'+esc(href)+'" target="_blank" rel="noopener">Open session ↗</a>'}
      var g=document.createElement("div");g.className="chat-event ev-group";
      var h=ssAvatar({seed:a.seed,name:a.name,picture:a.picture,size:"sm"})+'<span><b>'+esc(a.name)+'</b> updated the space'+(from?" from "+esc(from):"")+'<span class="ev-n"> · '+list.length+' versions</span>'+(one?sessLink(one):"")+'</span><ol class="ev-list">';
      if(fold)h+='<li><button type="button" class="ev-more" aria-expanded="'+open+'">'+(open?"Show fewer":"Show "+hidden+" earlier")+'</button></li>';
      list.slice(hidden).forEach(function(v){var sh=one?"":versionHref(v);h+='<li><span class="ev-ver">'+esc(v.name||"New version")+'</span>'+(sh?sessLink(sh):"")+'<span class="ev-when">'+esc(whenShort(v.created_at))+'</span></li>'});
      g.innerHTML=h+"</ol>";
      var mb=g.querySelector(".ev-more");
      if(mb)mb.addEventListener("click",function(){evOpen[key]=!open;var n=versionGroup(list);g.parentNode.replaceChild(n,g);var nb=n.querySelector(".ev-more");if(nb)nb.focus()});
      return g;
    }
    function commentLine(m,mi){
      var ask=null;for(var j=mi-1;j>=0;j--){var u=history[j];if(u.role==="user"&&u.runId===m.runId){ask=u;break}}
      var whose=!ask||!ask.seed||ask.seed===ME?"your comment":esc(ask.name||"someone")+"’s comment";
      var tmp=document.createElement("div");tmp.innerHTML=richReply(m.content)?"":mdToHtml(m.content||"");
      // The reply's first block, which is where a reply says what it did.
      var first=tmp.querySelector("p,li,h1,h2,h3,h4")||tmp;
      var gist=(first.textContent||"").replace(/\s+/g," ").trim();
      var changed=(!!m.committed||!!m.commentChanged)&&!m.reverted,failed=!changed&&gist.indexOf("⚠")>=0;
      var did=failed?"couldn’t answer "+whose:changed?"changed the page for "+whose:"answered "+whose;
      var root=m.commentRoot||(ask&&ask.commentRoot)||null;
      var b=document.createElement("div");b.className="chat-event chat-cmt";
      b.innerHTML='<span class="cm-ic" aria-hidden="true">💬</span><span class="cm-txt" title="'+esc(gist)+'"><b>Shepherd</b> '+did+(gist?' · '+esc(gist):'')+'</span>'+(root&&window.ssOpenThread?'<button type="button" class="cm-show">Show</button>':'');
      var sb=b.querySelector(".cm-show");
      if(sb)sb.addEventListener("click",function(){window.ssOpenThread(root);if(window.mixpanel)mixpanel.track("Shepherd Comment Line Opened",{space_id:spaceId,changed:changed})});
      return b;
    }
    function render(){
      var keep=thread.before();
      msgs.innerHTML="";lastBd=null;
      // Bubbles to fold at ten lines, measured once the thread is in the document —
      // a bubble still detached from it has no height to measure.
      var toClamp=[],runs=versionRuns();
      // Each block is tagged with its message, which is what a redraw anchors on.
      history.forEach(function(m,mi){var n0=msgs.children.length;drawMsg(m,mi);for(var j=n0;j<msgs.children.length;j++)msgs.children[j].__k=m});
      function drawMsg(m,mi){
        var b=document.createElement("div");b.className="chat-msg "+m.role;
        // A version published outside the panel: the line is all an MCP client ever
        // shares, and it is enough.
        if(m.kind==="version"){
          // The blank a space starts as is not news: no line for it.
          if(m.via==="blank")return;
          var run=runs[mi];
          if(run===-1)return;
          if(run&&run.length>1){msgs.appendChild(versionGroup(run));return}
          b.className="chat-event";
          // Named for the harness that published it ("from Claude Code") only for
          // the one who ran that session, with the way back to it — the server sends
          // session to them alone; everyone else reads the surface.
          var from=versionFrom(m),sh=versionHref(m);
          b.innerHTML=ssAvatar({seed:m.author.seed,name:m.author.name,picture:m.author.picture,size:"sm"})+'<span><b>'+esc(m.author.name)+'</b> updated the space'+(from?" from "+esc(from):"")+'</span><span class="ev-when">'+esc(whenShort(m.created_at))+'</span>'+(m.name||sh?'<span class="ev-ver">'+(m.name?esc(m.name):"")+(sh?'<a class="ev-sess" href="'+esc(sh)+'" target="_blank" rel="noopener">Open session ↗</a>':"")+'</span>':"");
          msgs.appendChild(b);return;
        }
        // The page got its name (from the first ask, or from its own title): the
        // address to share, said once, where the turn that named it is.
        if(m.kind==="named"){
          b.className="chat-event chat-named";
          b.innerHTML='<span class="nm-ic">'+LINK_IC+'</span><span class="nm-txt">Named <b>'+esc(m.title)+'</b></span>'+COPY_BTN_LINK+'<a class="nm-url" href="'+esc(m.url)+'">'+esc(m.url.replace(location.protocol+"//",""))+'</a>';
          var cb=b.querySelector(".ss-copy");if(cb)cb.setAttribute("data-copy",m.url);
          msgs.appendChild(b);return;
        }
        // A turn asked in a comment: the conversation is in that thread (the ask, the
        // reply, what changed and Undo), so the drawer keeps one line of it once it is
        // over: whose comment, whether the page changed, the reply's first words, the way there.
        if(m.comment){if(m.role==="assistant"&&!m.streaming)msgs.appendChild(commentLine(m,mi));return}
        if(m.role==="assistant"){if(!m.streaming&&m.worked){var wk=document.createElement("div");wk.innerHTML=workedHtml(m);b.appendChild(wk.firstChild)}var w=document.createElement("div");w.className="chat-who";w.textContent="AI";if(m.to){var t=document.createElement("span");t.className="to";t.textContent="· to "+m.to;w.appendChild(t)}b.appendChild(w);var bd=document.createElement("div");bd.className="chat-md";bd.innerHTML=bubbleHtml(m);b.appendChild(bd);fillRich(bd,m);lastBd=bd;lastBd.__msg=m}
        else if(m.seed&&m.seed!==ME){
          b.className="chat-msg other";
          b.innerHTML=ssAvatar({seed:m.seed,name:m.name||"?",picture:m.picture,size:"sm"});
          var who=document.createElement("div");who.className="chat-who";who.textContent=m.name||"";
          // Someone else's brief says where it was typed in the same breath as who
          // typed it — the caption the owner gets on their own copy, as a suffix.
          if(m.origin){var ow=document.createElement("span");ow.className="via";ow.textContent=" · "+originCaption(m.origin);who.appendChild(ow)}
          else if(m.surface&&m.surface!=="viewer"){var via=document.createElement("span");via.className="via";via.textContent=" · via "+(VIA_LABEL[m.surface]||m.surface);who.appendChild(via)}
          b.appendChild(who);
          // Files and words share the second column, so the face stays beside both.
          var obody=document.createElement("div");obody.className="chat-body";b.appendChild(obody);
          if(m.files&&m.files.length)obody.appendChild(filesBlock(m.files));
          if(!filesOnly(m)){var ob=document.createElement("div");ob.className="chat-bubble";obody.appendChild(ob);
          if(m.origin)toClamp.push(fillClampable(ob,m.content,b));else ob.textContent=m.content}
        }
        else{if(m.origin){var oc=document.createElement("div");oc.className="chat-origin";oc.textContent=originCaption(m.origin);b.appendChild(oc)}
          if(m.files&&m.files.length)b.appendChild(filesBlock(m.files));
          if(!filesOnly(m)){var ub=document.createElement("div");ub.className="chat-bubble";b.appendChild(ub);
          if(m.origin)toClamp.push(fillClampable(ub,m.content,b));else ub.textContent=m.content}}
        msgs.appendChild(b);
        var otherList=m.role==="assistant"&&!m.retrying&&m.others&&m.others.list&&m.others.list.length?m.others.list:null;
        if(m.role==="assistant"&&(m.retry||m.retrying||otherList)){
          var rw=document.createElement("div");rw.className="chat-retry";
          if(m.retry||m.retrying){var rb=document.createElement("button");rb.type="button";rb.textContent=m.retrying?"Retrying…":"Retry";rb.disabled=!!m.retrying;
          rb.onclick=function(){retryFailedMessage(m)};rw.appendChild(rb)}
          if(otherList){
            var ol=document.createElement("span");ol.className="chat-retry-or";ol.textContent=m.retry?"or try":"Try again with";rw.appendChild(ol);
            otherList.forEach(function(o){var ob=document.createElement("button");ob.type="button";ob.className="chat-retry-model";ob.textContent=o.label;ob.title="Send it again on "+o.label;
              ob.onclick=function(){retryFailedMessage(m,o)};rw.appendChild(ob)});
          }
          b.appendChild(rw);
        }
        if(m.role==="assistant"&&m.proposed){
          var wrap=document.createElement("div");wrap.className="chat-apply";
          var ap=document.createElement("button");ap.textContent=m.applied?"Applied ✓":"Apply to document";if(m.applied)ap.disabled=true;
          ap.onclick=function(){applyEdit(m,ap)};wrap.appendChild(ap);
          if(!m.applied){var dc=document.createElement("button");dc.className="discard";dc.textContent="Discard";dc.onclick=function(){m.proposed=null;render()};wrap.appendChild(dc)}
          b.appendChild(wrap);
        }
        if(m.role==="assistant"&&m.committed){
          var cw=document.createElement("div");cw.className="chat-apply";
          var ok=document.createElement("span");ok.className="chat-saved";ok.textContent=m.reverted?"Undone ✓":"Applied automatically ✓";cw.appendChild(ok);
          if(m.prevSha&&!m.reverted){
            var un=document.createElement("button");un.className="discard";un.textContent="Undo";
            un.onclick=function(){
              un.disabled=true;
              fetch("/api/space/"+spaceId+"/ai/revert",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({sha:m.prevSha})})
                .then(function(r){if(r.ok){m.reverted=true;render();reloadContent(m.prevSha)}else{un.disabled=false;ssAsk({title:"Couldn’t undo that change",cancel:false})}})
                .catch(function(){un.disabled=false});
            };
            cw.appendChild(un);
          }
          b.appendChild(cw);
        }
        if(m.role==="assistant"&&m.saveFailed){
          var fw=document.createElement("div");fw.className="chat-apply";
          var warn=document.createElement("span");warn.className="chat-savefail";warn.textContent="⚠️ Changes are previewed but couldn’t be saved.";fw.appendChild(warn);
          var rt=document.createElement("button");rt.textContent="Retry save";
          rt.onclick=function(){
            rt.disabled=true;rt.textContent="Saving…";
            fetch("/api/space/"+spaceId+"/ai/apply-ops",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({edits:m.edits||[],nonce:window.__ssAiNonce,version_name:askFor(m)})})
              .then(function(r){return r.json().then(function(d){return{ok:r.ok,d:d}})})
              .then(function(res){
                if(res.ok){m.saveFailed=false;m.committed=res.d.sha;render()}
                else{rt.disabled=false;rt.textContent="Retry save";ssAsk({title:"Couldn’t save the changes",lede:(res.d&&res.d.message)||"",cancel:false})}
              }).catch(function(){rt.disabled=false;rt.textContent="Retry save"});
          };
          fw.appendChild(rt);
          b.appendChild(fw);
        }
        // Both roles get one: a reply is worth copying out, and so is the question
        // that produced it — re-asking it against another doc, or of another model,
        // otherwise means retyping it. The copy carries the raw markdown, not the
        // rendered HTML: what lands in the doc someone is pasting into should be the
        // message as written. Skipped while a reply is still streaming — half an
        // answer isn't worth a button.
        if(m.content&&!m.streaming&&!filesOnly(m)){
          var user=m.role==="user";
          var acts=document.createElement("div");acts.className="chat-acts"+(user?" chat-acts--end":"");
          acts.innerHTML=user?COPY_BTN_MSG:COPY_BTN_REPLY;
          var cb=acts.firstChild;
          // A reply drawn from HTML copies as its words, lines kept; markup pasted
          // into a doc or another chat is noise.
          cb.addEventListener("click",function(){window.ssCopy(!user&&richReply(m.content)?window.ssAgentReply.text(m.content):m.content,cb)});
          b.appendChild(acts);
        }
      }
      // A brand-new document is not a blank thread: its "First version" event is
      // already on the wire. So the intro asks whether anyone has SAID anything,
      // not whether the thread is empty — and goes above that line, since on a
      // page nobody has written yet the ask is the content and the event is the
      // footnote.
      var spoken=history.some(function(m){return !m.kind&&!m.origin});
      var intro=cfg&&cfg.available&&introOn()&&!spoken;
      if(intro){msgs.insertBefore(introBlock(),msgs.firstChild)}
      // The empty hint sits under the pinned origin (if any), never above it.
      else if(!history.some(function(m){return !m.origin})&&cfg&&cfg.available){
        var e=document.createElement("div");e.className="chat-empty";
        e.innerHTML="Ask me anything about this document."+(cfg.can_edit?" Turn on <b>Edit mode</b> below to ask for changes.":"");
        msgs.appendChild(e);
      }
      var rb=cfg&&cfg.available?roomBlock():null;if(rb)msgs.appendChild(rb);
      if(busy&&!rb&&(!history.length||!history[history.length-1].streaming)){var t=document.createElement("div");t.className="chat-typing";t.innerHTML="<span class=\"ss-dots\" aria-hidden=\"true\"><i></i><i></i><i></i></span>"+"<span>"+(savingFirst?"Saving what you typed on the page first…":"Thinking…")+"</span>";msgs.appendChild(t)}
      toClamp.forEach(clampBubble);
      thread.after(keep);
      renderFaces();syncRun();
    }
    // The text of a foldable bubble goes in its own box, so the fold clips at the
    // line and not at the bubble's padding edge.
    function fillClampable(bubble,text,host){
      var inner=document.createElement("div");inner.textContent=text;
      bubble.appendChild(inner);
      return{el:inner,host:host};
    }
    // Fold it to ten lines — ssClampLines measures, decides whether a toggle is
    // even warranted, and animates both directions. The toggle lands at the head
    // of the message's own action row (the one the copy button lives on), which
    // comes into flow for the occasion: a control that is always visible cannot
    // hover-fade with the rest of that row, and it would sit on a line of its own
    // above it otherwise.
    function clampBubble(t){
      window.ssClampLines(t.el,{lines:10,className:"chat-more",mount:function(btn){
        var acts=t.host.querySelector(".chat-acts");
        if(!acts){t.host.appendChild(btn);return}
        acts.classList.add("chat-acts--row");
        acts.insertBefore(btn,acts.firstChild);
      }});
    }
    // Cheap per-token update: rewrite only the last bubble instead of rebuilding
    // the whole thread on every delta.
    function renderLast(m){
      // A comment's turn isn't drawn until it is over: nothing to update.
      if(m&&m.comment&&m.streaming)return;
      if(!lastBd||lastBd.__msg!==m){render();return}
      lastBd.innerHTML=bubbleHtml(m);
      fillRich(lastBd,m);
      thread.size();
    }

    function parseChatLlmValue(v){
      if(!v||v.indexOf(":")<0)return{provider:"",model:v||""};
      var i=v.indexOf(":");
      return{provider:v.slice(0,i),model:v.slice(i+1)};
    }
    function chatLlmValue(provider,model){return(provider||"")+":"+(model||"")}
    // A turn that failed on its model offers others from the picker, one press each
    // (2026-10-13: a 404 from Kimi left only the picker, behind the error, to change).
    // Never the model that failed (the payload's, or one the error names): Auto first
    // when a model was pinned, then one model per other provider, then the failed
    // provider's own, so three suggestions are three different chances.
    var chatGroups=[];
    function otherModels(payload,message){
      var failed=payload&&payload.model?chatLlmValue(payload.provider,payload.model):"auto",text=String(message||"").toLowerCase();
      var auto=[],firsts=[],same=[],rest=[];
      chatGroups.forEach(function(g){
        var label=String(g.label||"").toLowerCase(),sameProvider=!!label&&text.indexOf(label.split(" ")[0])>=0,first=true;
        (g.items||[]).forEach(function(it){
          if(!it||it.value===failed)return;
          var name=String(it.label||"").toLowerCase();
          if(it.value==="auto"){auto.push(it);return}
          if(name&&text.indexOf(name)>=0)return;
          if(first){(sameProvider?same:firsts).push(it);first=false}else rest.push(it);
        });
      });
      return auto.concat(firsts,same,rest).slice(0,3).map(function(it){return{value:it.value,label:it.label}});
    }
    function selectedChatLlm(){
      var v=chatModelPick&&chatModelPick.getValue();
      if(!v||v==="auto")return{provider:"",model:""};
      var parsed=parseChatLlmValue(v);
      if(parsed.provider&&parsed.model)return parsed;
      if(cfg&&cfg.provider)return{provider:cfg.provider,model:parsed.model||cfg.model||""};
      return{provider:"",model:parsed.model||""};
    }
    // Until 2026-09-28 every send carried the picker's model, the default included,
    // and saved it: the server read that as the person's choice, so a question never
    // reached the fast model and the lane never ran on it. Auto sends nothing.
    function applyChatLlmPayload(payload){
      var sel=selectedChatLlm();
      if(sel.model)payload.model=sel.model;
      if(sel.provider)payload.provider=sel.provider;
    }
    // "at 3:42 PM (in 23 min)", "tomorrow at 9:05 AM", "on Wed, Oct 29 at 3:42 PM":
    // when a spent allowance frees up, in the reader's own clock (the comment rail's words).
    function freesWhen(at){
      var now=new Date(),d=new Date(at),mins=Math.max(1,Math.ceil((at-now.getTime())/60000));
      var t=d.toLocaleTimeString([],{hour:"numeric",minute:"2-digit"});
      if(mins<60)return "at "+t+" (in "+mins+" min)";
      var day=function(x){return new Date(x.getFullYear(),x.getMonth(),x.getDate()).getTime()};
      var days=Math.round((day(d)-day(now))/86400000);
      if(days===0)return "at "+t;
      if(days===1)return "tomorrow at "+t;
      return "on "+d.toLocaleDateString([],{weekday:"short",month:"short",day:"numeric"})+" at "+t;
    }
    // Why there is no model, in the composer's place: what ran out and when it frees
    // up (the server's no_model, the same reading the comment rail gets), and the one
    // way past it — the plan above, or Settings for a key of their own. The time
    // stays current in place, and when it comes the panel loads again by itself.
    var noModelTimer=0,noModelShown=null;
    // The brand's jet sheep with its flame out and its eyes half shut: what the card
    // shows while there is nothing to run on. The flame is the mark's rects (hidden in
    // CSS); the lids are drawn over the eyes here.
    var CNM_SHEEP="<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 398.1 327.98\" height=\"46\"><path class=\"ss-wool\" fill=\"none\" d=\"M133.1,88.1H273.2V248.1H133.1Z M273.69,148.09h19.39v19.39h-19.39Z M313.19,148.34h19.39v19.39h-19.39Z\"/><path d=\"M193.16,248.06l-.16,60h-19.95l-.16-60h20.28Z\" class=\"ss-ink\" fill=\"#43434b\"/><path d=\"M273.29,248.06l-.24,60h-19.87l-.24-60h20.36Z\" class=\"ss-ink-legs\" fill=\"#404048\"/><path d=\"M313.42,248.06l-.24,60h-19.87l-.24-60h20.36Z\" class=\"ss-ink-legs\" fill=\"#404048\"/><path d=\"M153.49,248.18l-.16,59.88h-19.95l-.24-60,20.36.12Z\" class=\"ss-ink-legs\" fill=\"#404048\"/><polygon points=\"132 68.17 132 88.13 113.03 88.21 113.03 248.06 135.19 248.07 135.19 267.9 306.85 267.72 306.85 252.44 302.46 248.06 273.66 247.57 153.49 247.7 153.49 228.08 133.11 228.08 133.11 108.19 153.09 108.11 153.37 87.94 307.74 88.01 308.29 68.25 132 68.17\" class=\"ss-ink\" fill=\"#43434b\"/><path d=\"M353.61,108.12l.08-39.95h-100.5l-.08,40.04h-19.81v39.8h19.64v60.23h20.36v39.82h59.55v-39.82h20.76v-60.23h19.47v-39.89h-19.47ZM293.08,167.48h-19.39v-19.39h19.39v19.39ZM332.58,167.73h-19.39v-19.39h19.39v19.39Z\" class=\"ss-ink\" fill=\"#43434b\"/><path d=\"M313.24,208.37h-20v20.01h20v-20.01Z\" style=\"fill:#d58e9e;\"/><path d=\"M293.06,28.12v40.06h-19.88V28.12h19.88Z\" style=\"fill:#fea900;\"/><path d=\"M332.81,28.12v40.06h-19.88V28.12h19.88Z\" style=\"fill:#fea900;\"/><rect x=\"93.04\" y=\"88.16\" width=\"19.99\" height=\"19.99\" style=\"fill:#ed5544;\"/><rect x=\"53.07\" y=\"168.11\" width=\"19.99\" height=\"19.99\" style=\"fill:#fe7700;\"/><rect x=\"53.07\" y=\"108.15\" width=\"19.99\" height=\"19.99\" style=\"fill:#feed87;\"/><rect x=\"93.04\" y=\"68.17\" width=\"38.76\" height=\"19.99\" style=\"fill:#ffdf01;\"/><rect x=\"73.06\" y=\"188.1\" width=\"19.99\" height=\"19.99\" style=\"fill:#ffdf01;\"/><rect x=\"53.07\" y=\"88.16\" width=\"19.99\" height=\"19.99\" style=\"fill:#fea900;\"/><rect x=\"33.08\" y=\"88.16\" width=\"19.99\" height=\"19.99\" style=\"fill:#ffdf01;\"/><rect x=\"93.04\" y=\"128.13\" width=\"19.99\" height=\"19.99\" style=\"fill:#ed5544;\"/><rect x=\"73.06\" y=\"128.13\" width=\"19.99\" height=\"19.99\" style=\"fill:#fe7700;\"/><rect x=\"53.07\" y=\"148.12\" width=\"19.99\" height=\"19.99\" style=\"fill:#feed87;\"/><rect x=\"93.04\" y=\"108.15\" width=\"19.99\" height=\"19.99\" style=\"fill:#fea900;\"/><rect x=\"73.06\" y=\"148.12\" width=\"19.99\" height=\"19.99\" style=\"fill:#ffdf01;\"/><rect x=\"13.09\" y=\"128.13\" width=\"19.99\" height=\"19.99\" style=\"fill:#ffdf01;\"/><rect x=\"53.07\" y=\"128.13\" width=\"19.99\" height=\"19.99\" style=\"fill:#fea900;\"/><rect x=\"33.08\" y=\"128.13\" width=\"19.99\" height=\"19.99\" style=\"fill:#fea900;\"/><rect x=\"93.04\" y=\"168.11\" width=\"19.99\" height=\"19.99\" style=\"fill:#ed5544;\"/><rect x=\"73.06\" y=\"88.16\" width=\"19.99\" height=\"19.99\" style=\"fill:#fe7700;\"/><rect x=\"53.07\" y=\"188.1\" width=\"19.99\" height=\"19.99\" style=\"fill:#feed87;\"/><rect x=\"73.06\" y=\"68.17\" width=\"19.99\" height=\"19.99\" style=\"fill:#feed87;\"/><rect x=\"93.04\" y=\"148.12\" width=\"19.99\" height=\"19.99\" style=\"fill:#fea900;\"/><rect x=\"73.06\" y=\"108.15\" width=\"19.99\" height=\"19.99\" style=\"fill:#ffdf01;\"/><rect x=\"33.08\" y=\"168.11\" width=\"19.99\" height=\"19.99\" style=\"fill:#ffdf01;\"/><rect x=\"73.06\" y=\"168.11\" width=\"19.99\" height=\"19.99\" style=\"fill:#fea900;\"/><rect x=\"93.04\" y=\"208.08\" width=\"19.99\" height=\"19.99\" style=\"fill:#ed5544;\"/><rect x=\"93.04\" y=\"188.1\" width=\"19.99\" height=\"19.99\" style=\"fill:#fea900;\"/><path class=\"cnm-lid ss-ink\" fill=\"#43434b\" d=\"M273.69,148.09h19.39v10.5h-19.39Z M313.19,148.34h19.39v10.5h-19.39Z\"/></svg>";
    var CNM_SPAN={hour:3600000,day:86400000,month:2592000000},CNM_SEGS=10;
    function hideNoModel(){clearTimeout(noModelTimer);noModelTimer=0;noModelShown=null;if(noModelEl){noModelEl.hidden=true;noModelEl.innerHTML=""}if(heldEl){heldEl.hidden=true;heldEl.textContent=""}}
    // How far the allowance has refilled toward the moment it frees up, as the gauge's
    // lit segments (at least one: a gauge that reads empty looks broken, not resting).
    function cnmGauge(at,span){
      var left=Math.max(0,at-Date.now()),lit=span?Math.max(1,Math.min(CNM_SEGS-1,Math.floor(CNM_SEGS*(1-left/span)))):0,h="";
      for(var i=0;i<CNM_SEGS;i++)h+='<i class="'+(i<lit?"on":"")+(i===lit-1?" tip":"")+'"></i>';
      return h;
    }
    function showNoModel(nm){
      nm=nm||{};compose.style.display="none";if(toolRow)toolRow.style.display="none";
      if(!noModelEl)return;
      clearTimeout(noModelTimer);noModelTimer=0;
      var at=nm.when?Date.parse(nm.when.at):NaN,timed=at===at&&at>Date.now(),span=timed?CNM_SPAN[nm.when.window]||0:0;
      var safe=function(f){return !!f&&(String(f.href||"").indexOf("/settings/")===0||f.href==="/plans")};
      var fix=safe(nm.fix)?nm.fix:{label:"Set up your AI model",href:"/settings/ai-assistant"};
      var spent=timed||!!fix.upgrade;
      var why=timed?nm.when.head:(fix.upgrade&&nm.brief)||nm.message||"Shepherd needs an AI model, and none is set up for your account yet.";
      // The words that were turned away sit in the hidden box; they show right above
      // the card as the person's own unsent message, so they read as kept, not lost.
      var heldText=textEl.value.trim(),heldFiles=pending.filter(function(p){return p.key}).length;
      if(heldEl){
        heldEl.innerHTML='<span class="chat-held-t">'+(heldText?esc(heldText):"")+(heldFiles?'<span class="chat-held-f">'+(heldText?" · ":"")+heldFiles+(heldFiles>1?" files":" file")+'</span>':'')+'</span>';
        heldEl.hidden=!(heldText||heldFiles);
      }
      noModelEl.className="chat-nomodel"+(spent?" is-spent":"");
      noModelEl.innerHTML='<div class="cnm-top"><span class="cnm-sheep" aria-hidden="true">'+CNM_SHEEP+(spent?'<span class="cnm-z"><b>z</b><b>z</b><b>z</b></span>':'')+'</span>'
        +'<div><p class="cnm-title">'+(spent?"Sheep’s out of fuel":"Shepherd needs a model")+'</p><p class="cnm-why">'+esc(why)+'</p></div></div>'
        +(timed?'<div class="cnm-fuel"><span class="cnm-gauge" aria-hidden="true">'+cnmGauge(at,span)+'</span><span class="cnm-eta">Refuels <b class="cnm-when">'+esc(freesWhen(at))+'</b></span></div>':'')
        +'<a class="cnm-cta" href="'+esc(fix.href)+'" target="_blank" rel="noopener"'+(fix.upgrade?' data-upgrade="'+esc(fix.upgrade)+'"':'')+'>'+esc(fix.label||"Set up a model")+(fix.upgrade?'<span>keep going now</span>':'')+'</a>'
        +(fix.upgrade?'<a class="cnm-alt" href="/settings/ai-assistant" target="_blank" rel="noopener">or use your own API key</a>':'');
      noModelEl.hidden=false;
      var up=noModelEl.querySelector("[data-upgrade]");
      if(up)up.addEventListener("click",function(){if(window.mixpanel)try{mixpanel.track("Upgrade Clicked",{feature:"co_shepherd",plan:up.getAttribute("data-upgrade"),space_id:spaceId})}catch(x){}});
      if(noModelShown!==why&&window.mixpanel)try{mixpanel.track("AI Chat No Model Shown",{space_id:spaceId,upgrade:fix.upgrade||null,timed:timed})}catch(x){}
      noModelShown=why;
      // The time and the gauge stay current in place; when the moment comes the
      // panel loads again by itself, words in the box and all.
      if(timed)(function tick(){
        noModelTimer=setTimeout(function(){
          if(Date.now()>=at){hideNoModel();loadConfig();return}
          var w=noModelEl.querySelector(".cnm-when");if(w)w.textContent=freesWhen(at);
          var g=noModelEl.querySelector(".cnm-gauge");if(g)g.innerHTML=cnmGauge(at,span);
          tick();
        },Math.max(1000,Math.min(30000,at-Date.now())));
      })();
    }
    function loadConfig(){
      loaded=true;
      msgs.innerHTML=CHAT_SKEL;
      compose.style.display="none";if(skelCompose)skelCompose.style.display="";
      fetch("/api/space/"+spaceId+"/ai/config").then(function(r){return r.json().then(function(d){d.lost=r.status===403||r.status===404;return d})}).then(function(d){
        if(skelCompose)skelCompose.style.display="none";
        cfg=d;ME=d.me_seed||null;
        // The corner mic waits on this to send (after the rest of this answer is read).
        if(window.__ssShCfg)setTimeout(window.__ssShCfg,0);
        // Lost access is not a missing model: say which one it is.
        if(d.lost){
          compose.style.display="none";if(toolRow)toolRow.style.display="none";msgs.innerHTML="";
          var le=document.createElement("div");le.className="chat-empty";
          le.innerHTML='<div style="color:var(--ss-text-subtle)">You no longer have access to this document, so Shepherd can&rsquo;t work on it for you. Reload to see what you can open.</div>';
          msgs.appendChild(le);return;
        }
        // No model to run on: the thread is still the room's and is drawn as ever;
        // only the composer gives way to the reason, the moment it frees up and the
        // way past it. Until 2026-10-26 the panel cleared the thread and said "none
        // is set up" to a Free account whose allowance had just run out mid-demo.
        // A message an earlier refusal kept (this page or one before it) goes back
        // in the box first, so the card can show it and the composer has it ready.
        restoreHeld();
        if(!d.available)showNoModel(d.no_model);
        else{
          hideNoModel();compose.style.display="";if(toolRow)toolRow.style.display="";
          if(readHeld()&&textEl.value.trim()){window.ssAutoGrow(textEl);syncSend();if(textEl.offsetParent)textEl.focus()}
        }
        var groups=[];
        var providers=(d.providers&&d.providers.length)?d.providers:null;
        if(providers){
          providers.forEach(function(p){
            if(!p||!p.id)return;
            groups.push({label:p.label||p.id,items:window.ssPillModelItems(p,chatLlmValue)});
          });
        }else{
          var models=(d.models&&d.models.length)?d.models:[d.model];
          groups.push({
            label:d.provider||"Model",
            items:models.filter(Boolean).map(function(m){return{value:d.provider?chatLlmValue(d.provider,m):m,label:m}})
          });
        }
        // setGroups gives its preferred argument priority over the stored key, so
        // resolve the precedence here: a viewer's own saved pick beats the server
        // default, exactly as the native select did. A stale saved value (key
        // revoked, model retired) is no longer in the groups, and falls back.
        var want=chatLlmValue(d.provider,d.model),saved=null,old=null;
        groups.unshift({label:"",items:[{value:"auto",label:"Auto"}]});
        // The models a higher plan adds, under a rule: the plan's name and a lock, and a
        // tap that picks nothing.
        var locked=(d.locked||[]).filter(function(l){return l&&l.model});
        if(locked.length)groups.push({label:"",divider:true,items:locked.map(function(l){return{value:"locked:"+l.model,label:l.model,disabled:true,locked:true,badge:l.plan==="pro"?"Pro":"Max",plan:l.plan}})});
        try{saved=localStorage.getItem("ss-chat-llm2");old=localStorage.getItem("ss-chat-llm")}catch(e){}
        var inGroups=function(v){return !!v&&groups.some(function(g){
          return (g.items||[]).some(function(it){return it.value===v})})};
        // The old key was written on every send, so it mostly holds the default. Only
        // a model other than the default was ever somebody's choice; keep that one.
        if(!saved&&old&&old!==want&&inGroups(old)){saved=old;try{localStorage.setItem("ss-chat-llm2",old)}catch(e){}}
        try{if(old!==null)localStorage.removeItem("ss-chat-llm")}catch(e){}
        chatGroups=groups;
        chatAllowance=d.allowance||null;chatProviders=providers;
        if(chatModelPick){chatModelPick.setGroups(groups,inGroups(saved)?saved:"auto");chatMeter(chatModelPick.getValue())}
        editRow.style.display=d.can_edit?"":"none";
        designGroups(d);
        // Someone who can edit is here to change the page: a correction typed at
        // it should land as a version, not a discussion. Off is the opt-out for
        // asking about the page (2026-09-25 feedback: "actioned on, not morally
        // supported").
        if(d.can_edit&&editToggle)editToggle.checked=true;
        var ints=document.getElementById("chatInts");
        if(ints){
          var list=d.integrations||[],onHtml="",offHtml="",offCount=0;
          list.forEach(function(it){
            if(it.connected){
              onHtml+='<span class="ci on" title="'+csEsc(it.detail?"Connected — "+it.detail:"Connected — the assistant can pull live data from this")+'"><span class="d"></span>'+csEsc(it.label)+'</span>';
            }else{
              offCount++;
              offHtml+='<a class="ci chip-src-off" href="/settings/integrations" target="_blank" rel="noopener" title="Connect this in settings"><span class="d"></span>'+csEsc(it.label)+' · add</a>';
            }
          });
          var intsHtml=list.length?'<span class="lead">🔌 Data sources</span>'+onHtml:'';
          if(offCount)intsHtml+='<button type="button" class="chip-more" title="'+csEsc(MORE_TIP)+'"></button>'+offHtml;
          ints.innerHTML=intsHtml;
          window.wireConnectMore(ints,offCount);
          // After the connect-more label is in: its width is part of what fits.
          window.ssFoldRow(ints,{count:".ci.on",head:ints.querySelector(".lead"),title:"Show every data source"});
        }
        // The space's thread, not this viewer's: everyone's messages plus the
        // versions published outside the panel, merged in time order. Skipped when
        // the session already has live messages of its own.
        if(!history.length){
          var items=[];
          (d.thread||[]).forEach(function(m){if((m.role==="user"||m.role==="assistant")&&m.content)items.push({role:m.role,content:m.content,seed:m.seed,name:m.name,picture:m.picture,surface:m.surface,runId:m.run_id,created_at:m.created_at,comment:m.surface==="comment",commentRoot:m.comment_root||null,commentChanged:!!m.comment_changed,to:m.role==="assistant"?null:undefined,files:Array.isArray(m.files)&&m.files.length?m.files:undefined})});
          // A reply answers the user turn before it; label it when that person is not me.
          for(var i=0;i<items.length;i++){if(items[i].role==="assistant"){for(var j=i-1;j>=0;j--){if(items[j].role==="user"){if(items[j].seed!==ME)items[i].to=items[j].name;break}}}}
          (d.versions||[]).forEach(function(v){if(v.via!=="viewer")items.push({kind:"version",sha:v.sha,name:v.name,via:v.via,author:v.author,session:v.session||null,created_at:v.created_at})});
          items.sort(function(a,b){return (a.created_at||"")<(b.created_at||"")?-1:1});
          history=items;
        }
        // The words this doc was built from, pinned as the first message of the
        // space's thread — wherever they were typed (dashboard, Telegram, Slack…).
        // It carries its author's seed, so to everyone but the person who wrote it
        // the brief arrives as their message, with their face on it, rather than as
        // the reader's own words. Display only: it never travels back to the model
        // as a turn.
        // A page built from the dashboard also has the ask in its thread (the build
        // is a Co-shepherd turn on it), so that message becomes the pinned origin
        // rather than the same words drawn twice.
        if(d.origin&&d.origin.prompt&&!history.some(function(m){return m.origin})){
          var oa=d.origin.author||{},op=String(d.origin.prompt).trim(),dup=-1;
          for(var oi=0;oi<history.length;oi++){var hm0=history[oi];if(hm0.role==="user"&&!hm0.kind&&typeof hm0.content==="string"&&hm0.content.trim()===op&&(!oa.seed||!hm0.seed||hm0.seed===oa.seed)){dup=oi;break}}
          var om=dup>=0?history.splice(dup,1)[0]:{role:"user",content:d.origin.prompt,seed:oa.seed||null,name:oa.name||"",picture:oa.picture||null};
          om.origin=d.origin;
          history.unshift(om);
        }
        renderFaces();
        setTurn(d.turn||null);
        // My own running turn is resumed below from /ai/active, with its events so far.
        if(d.turn&&d.turn.seed!==ME)followTurn(d.turn);
        // The queue a reload kept waits for this answer: my own turn may still be
        // running, and a reader's turn holds nothing the room would announce.
        fetch("/api/space/"+spaceId+"/ai/active").then(function(r){return r.ok?r.json():null}).then(function(a){if(a&&a.run)resumeTurn(a.run)}).catch(function(){}).then(function(){qReady=true;renderQueue();pump();landThread()});
        render();
      }).catch(function(){if(window.__ssShCfg)window.__ssShCfg();if(skelCompose)skelCompose.style.display="none";msgs.innerHTML='<div class="chat-empty">Couldn\u2019t load the assistant.</div>'});
    }

    textEl.oninput=function(){syncSend();if(readHeld())holdBox()};
    if(attachBtn&&fileInput){
      attachBtn.onclick=function(){if(canAttach())fileInput.click()};
      fileInput.onchange=function(){stageFiles(fileInput.files);fileInput.value="";textEl.focus()};
    }
    // A pasted screenshot or file. A clipboard that also carries words (a copy from a
    // document often brings a picture of itself along) pastes the words, unless those
    // words are only the file's own name.
    textEl.addEventListener("paste",function(e){
      var cd=e.clipboardData;if(!cd||!cd.files||!cd.files.length||!canAttach())return;
      var fs=Array.prototype.slice.call(cd.files),words=(cd.getData("text/plain")||"").trim();
      if(words&&!fs.some(function(f){return f.name===words}))return;
      e.preventDefault();stageFiles(fs);
    });
    // Dropped anywhere on the open panel.
    function dragsFiles(e){var t=e.dataTransfer&&e.dataTransfer.types;return !!t&&Array.prototype.indexOf.call(t,"Files")>=0}
    function dropShown(on){if(dropEl)dropEl.hidden=!on}
    if(panelEl){
      panelEl.addEventListener("dragenter",function(e){if(!dragsFiles(e)||!canAttach())return;e.preventDefault();dragDepth++;dropShown(true)});
      panelEl.addEventListener("dragover",function(e){if(!dragsFiles(e)||!canAttach())return;e.preventDefault();e.dataTransfer.dropEffect="copy"});
      panelEl.addEventListener("dragleave",function(e){if(!dragsFiles(e))return;dragDepth=Math.max(0,dragDepth-1);if(!dragDepth)dropShown(false)});
      panelEl.addEventListener("drop",function(e){if(!dragsFiles(e))return;e.preventDefault();dragDepth=0;dropShown(false);if(canAttach())stageFiles(e.dataTransfer.files)});
    }
    textEl.onkeydown=function(e){if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();send()}};
    sendBtn.onclick=send;
    // Post a screenshot request into the content iframe (snapdom runs there) and
    // resolve with its reply — or a failure on timeout / no frame.
    function captureFrame(req){
      return new Promise(function(resolve){
        var f=document.getElementById("content");
        if(!f||!f.contentWindow){resolve({ok:false,error:"no preview frame"});return}
        if(!window.__ssShotWaits)window.__ssShotWaits={};
        var id="shot-"+Date.now().toString(36)+Math.random().toString(36).slice(2,8),settled=false;
        // 20s: the iframe now owns the real deadline (a 10s capture + a 6s fontless
        // fallback = ~16s worst case) and always replies, so this is just a backstop
        // for a frame that went away entirely. It must stay ABOVE the iframe budget.
        // A frame that reloads while it is asked (a save's deploy reloads it, and the
        // look at a new page is asked for right then) drops the request with the old
        // document, so each fresh document that reports ready is asked again under the
        // same id; the first answer wins. Before this, the panel sat out the whole 20s
        // backstop and said "timed out" (2026-09-30, a page written on a blank space).
        function onFrameReady(e){if(settled||!e.data||e.data.type!=="ss-anchor-ready"||(co&&e.origin!==co))return;var nf=document.getElementById("content");if(nf&&nf.contentWindow)post(nf.contentWindow)}
        function done(){clearTimeout(to);window.removeEventListener("message",onFrameReady)}
        var to=setTimeout(function(){if(settled)return;settled=true;done();delete window.__ssShotWaits[id];resolve({ok:false,error:"timed out"})},20000);
        window.__ssShotWaits[id]=function(res){if(settled)return;settled=true;done();resolve(res||{ok:false})};
        window.addEventListener("message",onFrameReady);
        var msg={type:"ss-screenshot",id:id,anchor:(req&&req.anchor)||null,selector:(req&&req.selector)||null};
        // Prefer the exact content origin, but fall back to "*" if that throws (a
        // malformed/edge targetOrigin throws synchronously) or if co is missing. Safe:
        // the request carries no secret and anchor.js checks the sender origin before
        // acting. On total failure, surface the real exception so it's diagnosable.
        function giveUp(err){if(settled)return;settled=true;done();delete window.__ssShotWaits[id];resolve({ok:false,error:"postMessage failed: "+((err&&err.message)||err)})}
        function post(win){
          try{
            if(co&&/^https?:\/\//.test(co))win.postMessage(msg,co);
            else win.postMessage(msg,"*");
          }catch(e1){
            try{win.postMessage(msg,"*")}catch(e2){giveUp(e2)}
          }
        }
        post(f.contentWindow);
      });
    }
    var ORIGIN_SURFACE={dashboard:"in the dashboard",viewer:"in this panel",web:"in Messages",tg:"in Telegram",imsg:"in iMessage",wa:"in WhatsApp",slack:"in Slack",task:"by a scheduled task"};
    function originCaption(o){
      var when="";
      try{if(o.created_at){when=new Date(o.created_at).toLocaleDateString(undefined,{month:"short",day:"numeric"})}}catch(e){}
      return "Initiated "+(ORIGIN_SURFACE[o.surface]||"in Spacesheep")+(when?" · "+when:"");
    }
    function modelTurns(list){
      return list.filter(function(m){return (!m.origin||m.runId)&&!m.kind}).map(function(m){return{role:m.role,content:m.content}});
    }
    function expireChatRetries(){
      history.forEach(function(m){m.retry=null;m.others=null;m.retrying=false});
    }
    function send(){
      var v=textEl.value.trim(),ready=pending.filter(function(p){return p.key});
      if((!v&&!ready.length)||uploading()||!cfg||!cfg.available)return;
      var files=ready.map(function(p){return{key:p.key,name:p.name,media_type:p.media_type,kind:p.kind,size:p.size}});
      if(!((function(m){return !m||m[1]==="off"||("."+m[1]+".").indexOf(".messages.")>=0})(/(?:^|;\s*)ss_sound=([a-z.]+)/.exec(document.cookie))))try{sendSound.currentTime=0;sendSound.play().catch(function(){})}catch(e){}
      // What was on screen when it was pressed travels with it, queued or not.
      var item={text:v,files:files,edit:!!(cfg.can_edit&&editToggle.checked),llm:{}};
      applyChatLlmPayload(item.llm);
      clearPending();showFileErr("");
      textEl.value="";window.ssAutoGrow(textEl);
      // Something is running, or messages are already in line: this one joins the
      // line. A paused line is not in the way — a new send goes now, and the line
      // stays paused for the person to resume or clear.
      if(mustWait()||(queue.length&&!queuePaused)){enqueue(item);return}
      dispatch(item,true);
    }
    // One message out: the panel's own send, or the next one in the line. Never
    // touches the composer — the person may be typing the next one.
    // pin: sent this moment (the ask goes to the top of the view). A queued one going
    // out later doesn't move a reader who is meanwhile reading the turn before it.
    function dispatch(item,pin){
      var v=item.text||"",files=item.files||[];
      expireChatRetries();
      // Notices from a refused send ("your turn from another tab…") are not part of
      // the thread: the next send takes them back out.
      while(history.length&&history[history.length-1].transient)history.pop();
      var ask={role:"user",content:v||filesPlaceholder(files),files:files.length?files:undefined};
      history.push(ask);
      setBusy(true);window.__ssVerifyDepth=0;render();if(pin)pinAsk(ask);
      var editMode=!!(cfg.can_edit&&item.edit);
      // The nonce marks this edit as ours: the WS patch/deploy echo carries it back
      // and the viewer skips re-applying what the stream already patched live.
      var nonce=Date.now().toString(36)+Math.random().toString(36).slice(2,10);
      window.__ssAiNonce=nonce;window.__ssPatchMissed=false;
      // Only the new message travels: the job builds the model's history from the
      // space's thread, so a tab can't hand the server one it invented.
      var payload={message:v,edit:editMode,nonce:nonce,visible:Array.isArray(window.ssFrameVisible)?window.ssFrameVisible.slice(0,400):[]};
      if(files.length){
        payload.files=files.map(function(f){return f.key});
        if(window.mixpanel)mixpanel.track("AI Chat Files Sent",{space_id:spaceId,count:files.length,images:files.filter(function(f){return f.kind==="image"}).length,pdfs:files.filter(function(f){return f.kind==="pdf"}).length,texts:files.filter(function(f){return f.kind==="text"}).length,words:!!v,edit:editMode});
      }
      if(item.llm&&item.llm.model)payload.model=item.llm.model;
      if(item.llm&&item.llm.provider)payload.provider=item.llm.provider;
      var asst={role:"assistant",content:"",edits:[],streaming:true};
      // Allow the screenshot/verify loop in BOTH modes: a reader can ask the assistant
      // to look at the live page in ask mode too, not just to verify an edit.
      runStream(payload,asst,true,false,files,item);
    }
    function retryFailedMessage(m,other){
      if(busy||!(other?m.others:m.retry))return;
      var retry=other?m.others:m.retry;
      if(other){
        // The picked model becomes the picker's, as a pick there would: the one
        // that failed would fail the next message too.
        var pl=Object.assign({},retry.payload),pv=parseChatLlmValue(other.value);
        delete pl.provider;delete pl.model;
        if(other.value!=="auto"){if(pv.provider)pl.provider=pv.provider;if(pv.model)pl.model=pv.model}
        if(chatModelPick){chatModelPick.setValue(other.value);chatMeter(other.value)}
        try{if(other.value==="auto")localStorage.removeItem("ss-chat-llm2");else localStorage.setItem("ss-chat-llm2",other.value)}catch(e){}
        retry={payload:pl,allowVerify:retry.allowVerify};
        if(window.mixpanel)mixpanel.track("AI Chat Retried Other Model",{space_id:spaceId,from:m.others.payload.model||"auto",to:other.value==="auto"?"auto":pv.model});
      }
      m.others=null;
      setBusy(true);
      window.__ssAiNonce=retry.payload.nonce;
      m.content="";m.edits=[];m.steps=[];m.searchOpen={};m.streaming=true;m.editingNote=false;m.retry=null;m.retrying=true;
      var prev=history[history.indexOf(m)-1];render();if(prev&&prev.role==="user")pinAsk(prev);
      if(window.mixpanel)mixpanel.track("AI Chat Retried",{space_id:spaceId,provider:retry.payload.provider||null,model:retry.payload.model||null,edit:!!retry.payload.edit,surface:"viewer"});
      runStream(retry.payload,m,retry.allowVerify,true);
    }
    function isTransientChatStatus(status){
      return status===408||status===425||status===500||status===502||status===503||status===504;
    }
    // After an edit turn that requested a screenshot, capture the live rendering and
    // loop it back to the model as an image so it can verify (or fix) its own work.
    // savedSha: the version the turn just saved. The look is of that version, never
    // of a tab still showing an older one (__ssShowSaved waits for the save to land
    // here, or reloads onto it), and the model is told so.
    function runVerifyTurn(req,editMode,savedSha){
      window.__ssVerifyDepth=(window.__ssVerifyDepth||0)+1;
      var asst={role:"assistant",content:"",edits:[],streaming:true,steps:[{t:"shot",pending:true,anchor:(req&&req.anchor)||null}]};
      history.push(asst);setBusy(true);render();
      var onSaved=false;
      (savedSha&&window.__ssShowSaved?window.__ssShowSaved(savedSha):Promise.resolve(false)).then(function(ok){onSaved=ok===true;return captureFrame(req)}).then(function(shot){
        var st=asst.steps[0];
        if(!shot||!shot.ok||!shot.dataUrl){
          var why=(shot&&shot.error)||"failed";
          if(window.mixpanel)mixpanel.track("AI Chat Verify Shot Failed",{space_id:spaceId,edit:!!editMode,error:String(why).slice(0,80)});
          // The look is a check on work already done. When it fails after an edit
          // landed, the outcome stands, so only an admin sees the failure: to anyone
          // else it read as the agent struggling over a page that was fine
          // (2026-10-31). A reader's question still gets a plain sentence, without
          // the renderer's error.
          var admin=!!(cfg&&cfg.admin);
          if(editMode&&!admin){var ai=history.indexOf(asst);if(ai>=0)history.splice(ai,1);setBusy(false);render();return}
          st.pending=false;st.ok=false;if(admin)st.error=why;
          asst.streaming=false;asst.content=editMode?"I couldn't capture a screenshot to double-check, but the edit was applied.":"I couldn't capture a screenshot of the page.";setBusy(false);render();return;
        }
        st.pending=false;st.ok=true;renderLast(asst);
        // Readable windows of the page (the frame cuts one around each thing that
        // changed), not the whole page shrunk: a face on a long feed was six pixels.
        var shots=(shot.shots&&shot.shots.length?shot.shots:[shot.dataUrl]).slice(0,3);
        var where=(req&&req.anchor)?(" of #"+req.anchor):((req&&req.selector)?(" of "+req.selector):(shot.where==="changes"?(shots.length>1?" — "+shots.length+" views, one around each part you changed,":" around what you changed"):(shot.where==="screen"?" — the screen the reader is looking at —":" of the page")));
        // What they asked, from the thread: the check is against their words.
        var asked="";
        for(var hi=history.length-1;hi>=0;hi--){var hm=history[hi];if(hm&&hm.role==="user"&&(!hm.origin||hm.runId)&&typeof hm.content==="string"&&hm.content.indexOf("Here is a screenshot")!==0&&hm.content.indexOf("Here is how the page looks")!==0){asked=hm.content;break}}
        var verifyMsg={role:"user",content:editMode
          ?("Here is how the page looks now"+where+" after your edit."+(onSaved?" It shows the version your edit saved.":"")+(asked?" They asked: “"+asked.slice(0,600)+"”.":"")+" Look hard before you answer: a picture that didn't load (an empty box, a broken-image icon, alt text where a picture should be), something covering or cutting off something else (a face cut off, text over a picture, a picture behind another), text that overflows, overlaps or runs off its box, anything they asked to remove that is still there, anything that looks out of place next to the rest of the page. If anything is wrong, fix it now and say what you fixed. If it all looks right, say so in one short sentence and change nothing.")
          :("Here is how the page looks"+where+". Use it to answer the reader's question.")};
        var msgs=modelTurns(history.filter(function(m){return m!==asst})).concat([verifyMsg]);
        var nonce=Date.now().toString(36)+Math.random().toString(36).slice(2,10);
        window.__ssAiNonce=nonce;window.__ssPatchMissed=false;
        var payload={messages:msgs,edit:editMode,nonce:nonce,verify:true,images:shots,verify_of:asked.slice(0,300)};
        applyChatLlmPayload(payload);
        runStream(payload,asst,(window.__ssVerifyDepth||0)<2,true);
      });
    }
    // A turn is a background job: the POST answers with the run, and its events —
    // the same shapes this panel always rendered — arrive as ss:chat over the inbox
    // socket the bell holds. Leaving the page changes nothing about the reply or
    // the edit; a panel that opens mid-turn rebuilds it from /ai/active.
    var watchers={};
    // Events for a run nobody here watches yet, kept while this tab's own POST is
    // in flight: the route announces the ask and the holder, and the job may start
    // talking, before the 202 that names the run reaches us. watchTurn replays them.
    var early={},posting=0;
    // The shell hears the space renamed (viewer.ts) and has already moved the
    // header and the address bar; the thread gets the link, above the reply still
    // being written so it doesn't jump around under it. The commit can announce
    // the same name again — one line per address.
    var namedUrl="";
    window.addEventListener("ss:renamed",function(e){
      // Only into a thread this panel has: a line in an unloaded one would read as
      // "live messages already here" and keep the thread from loading.
      var d=e.detail||{};if(!cfg||!history.length||typeof d.url!=="string"||d.url.charAt(0)!=="/"||d.url===namedUrl)return;namedUrl=d.url;
      var line={kind:"named",title:String(d.title||""),url:location.origin+d.url};
      var at=history.length;while(at>0&&history[at-1].role==="assistant"&&history[at-1].streaming)at--;
      history.splice(at,0,line);render();
    });
    window.addEventListener("ss:chat",function(e){
      var d=e.detail||{};
      if(d.reconnected){Object.keys(watchers).forEach(function(id){watchers[id].reconcile()});return}
      if(d.space_id!==spaceId)return;
      // Someone's ask just joined the thread: follow it exactly as a turn holder is
      // followed (same dedup on the run, same foreign bubble). For an editor this
      // and the holder announcement race harmlessly; for a reader, whose turn
      // holds nothing, it is the only word this panel gets of the run.
      if(d.type==="ask"){if(cfg)followTurn({run_id:d.run_id,seed:d.seed,name:d.name,picture:d.picture,surface:d.surface||"viewer",ask:d.ask,files:Array.isArray(d.files)?d.files:null,comment:d.surface==="comment"||!!d.comment_id,commentRoot:d.comment_root||null});return}
      var w=watchers[d.run_id];if(w)w.handle(d);
      else if(posting>0&&d.run_id){var q=early[d.run_id]||(early[d.run_id]=[]);if(q.length<200)q.push(d)}
    });
    msgs.addEventListener("click",function(e){
      var b=e.target&&e.target.closest?e.target.closest(".chat-stop"):null;
      if(!b)return;e.preventDefault();stopTurn(b.getAttribute("data-run"),b);
    });
    function stopTurn(id,btn){
      if(!id)return;if(btn)btn.disabled=true;
      fetch("/api/space/"+spaceId+"/ai/runs/"+encodeURIComponent(id)+"/cancel",{method:"POST",headers:{"Content-Type":"application/json"},body:"{}"})
        .then(function(r){return r.ok?r.json():null})
        .then(function(d){
          // A turn that never started emits nothing; settle from the answer. A
          // running one also reports back — ignored once settled.
          var w=watchers[id];if(w&&d&&d.run&&d.run.status!=="running")w.handle({type:"error",code:"stopped",message:"Stopped.",retryable:false});
        }).catch(function(){if(btn)btn.disabled=false});
    }
    // Follow one turn into its bubble. payload is what started it (for Retry);
    // a turn rebuilt from the row has none.
    function watchTurn(run,payload,asst,allowVerify){
      var opsSeen=0,editMode=!!(payload?payload.edit:run.edit),screenshotReq=null,streamDone=false,retryUnsafe=false,heard=Date.now(),quiet=null;
      asst.runId=run.id;asst.runKey=run.id;asst.heardAt=Date.now();
      // Send → first word, on one clock from the press of Send (coshep.* on the
      // Datadog board, via /ai/runs/:id/timing). Only the person's own sends carry
      // a clock (runStream); a screenshot check starts itself. One beacon, at the end.
      var tmT=asst.tm||null;asst.tm=null;
      function tmMark(k){if(tmT&&!tmT[k])tmT[k]=Date.now()}
      // Only the Co-shepherd's own change (the lane's ops say "viewer", the job's streamed
      // tool calls "agent"), and only on an editing turn: a space takes one editing turn
      // at a time, so that change is this one's, while a collaborator's save or an
      // outside publish says nothing about this send.
      function onLiveIn(e){var by=e&&e.detail&&e.detail.by;if(editMode&&(by==="viewer"||by==="agent"))tmMark("first_change")}
      if(tmT){tmT.path=run.phase==="lane"?"lane":"agent";if(window.addEventListener)window.addEventListener("ss:live-in",onLiveIn)}
      if(!asst.foreign&&tmT)dbgStart(run,tmT.sent);
      function sendTiming(outcome){
        if(!tmT||tmT.beaconed)return null;tmT.beaconed=true;
        if(window.removeEventListener)window.removeEventListener("ss:live-in",onLiveIn);
        var b={path:tmT.path,outcome:outcome,queued:!!tmT.queued,done:Date.now()-tmT.sent};
        ["accepted","first_sign","handed","first_word","first_change"].forEach(function(k){if(tmT[k])b[k]=tmT[k]-tmT.sent});
        var nav=window.navigator;
        try{if(nav&&nav.sendBeacon)nav.sendBeacon("/api/space/"+spaceId+"/ai/runs/"+encodeURIComponent(run.id)+"/timing",new Blob([JSON.stringify(b)],{type:"application/json"}))}catch(e){}
        return b;
      }
      // Steps the room said before this bubble existed (a panel opened mid-run, events
      // ahead of the 202) are this run's already.
      if(!asst.trail&&roomWorking()&&(room.st.run_id===run.id||(!room.st.run_id&&!payload)))asst.trail=trailKey(room.st);
      if(!asst.startedAt){var c0=run.created_at?Date.parse(run.created_at):NaN;asst.startedAt=isFinite(c0)?Math.min(c0,Date.now()):Date.now()}
      // The working lines change in place: no re-render, no jump to the bottom.
      function tick(){
        if(!lastBd||lastBd.__msg!==asst)return;
        var el=lastBd.querySelector(".chat-work"),h=trailHtml(asst);
        if(el){if(h)el.outerHTML=h;else el.remove();thread.size()}
        else if(h)renderLast(asst);
      }
      function settle(){if(dbg.run===run.id)dbgEnd();streamDone=true;clearInterval(quiet);setBusy(false);asst.streaming=false;asst.editingNote=false;asst.retrying=false;asst.runId=null;freezeTrail(asst);delete watchers[run.id];syncRun()}
      // fromRow: the ending was read off the run's row, not heard on the socket, so
      // what the room carried meanwhile (ops, the commit's patch) may never have
      // reached this frame — show the committed version rather than trust it.
      function finish(d,fromRow){
        if(streamDone)return;
        if(d&&d.reply&&!fromRow)tmMark("first_word");
        var tmB=sendTiming("done");
        settle();asst.retry=null;
        asst.content=d.reply||asst.content||"(no response)";
        // The page refused the change and nothing was saved: the same ask can go again.
        if(d.refused&&!asst.foreign&&payload)asst.retry={payload:payload,allowVerify:allowVerify};
        if(d.proposed_html)asst.proposed=d.proposed_html;
        if(d.sha){
          asst.committed=d.sha;asst.prevSha=d.prev_sha||null;
          // Someone else's edits already arrived here as socket patches; only a
          // reload the turn itself asks for is still ours to do.
          if(!asst.foreign&&window.__ssCommitPatches)window.__ssCommitPatches(d.sha);
          if(fromRow||(asst.foreign?d.needs_reload:(d.needs_reload||(d.unmatched&&d.unmatched.length)||window.__ssPatchMissed)))reloadContent(d.sha);
        }else if(d.ops_applied>0&&d.saved===false){asst.saveFailed=true}
        window.__ssPatchMissed=false;syncSend();render();
        // Someone else's turn ending is not my reply arriving: no chime, and it is
        // their message to count, not this reader's.
        if(!asst.foreign){
          if(queuePaused){queuePaused=false;renderQueue();pump()}
          if(!((function(m){return !m||m[1]==="off"||("."+m[1]+".").indexOf(".messages.")>=0})(/(?:^|;\s*)ss_sound=([a-z.]+)/.exec(document.cookie))))try{receiveSound.currentTime=0;receiveSound.play().catch(function(){})}catch(e){}
          if(window.mixpanel)mixpanel.track("AI Chat Message",{space_id:spaceId,edit:editMode,ops:d.ops_applied||0,source_edits:d.source_edits||0,auto_committed:!!d.sha,has_proposal:!!d.proposed_html,path:tmB?tmB.path:null,first_word_ms:tmB&&tmB.first_word!=null?tmB.first_word:null});
        }
        var sr=(d&&d.screenshot)||screenshotReq;
        if(allowVerify&&sr){setBusy(true);runVerifyTurn(sr,editMode,d.sha||null)}
      }
      function fail(message,retryable){
        if(streamDone)return;
        sendTiming("failed");
        settle();
        asst.content=(asst.content?asst.content+"\n\n":"")+"⚠️ "+message;
        asst.retry=retryable&&!retryUnsafe&&payload&&!asst.foreign?{payload:payload,allowVerify:allowVerify}:null;
        asst.others=!retryUnsafe&&payload&&!asst.foreign?{payload:payload,allowVerify:allowVerify,list:otherModels(payload,message)}:null;
        if(!asst.foreign)pauseQueue();
        if(opsSeen>0)reloadContent();
        syncSend();render();
      }
      function handle(d){
        if(streamDone)return;
        dbgEvent(run.id,d);
        heard=Date.now();asst.heardAt=heard;
        if(d.type==="delta"||d.type==="status"||d.type==="step"||d.type==="tool"||d.type==="op")tmMark("first_sign");
        if(d.type==="delta"&&d.text)tmMark("first_word");
        if(d.type==="op")tmMark("first_change");
        if(d.type==="handed"){if(tmT){tmMark("handed");tmT.path="handed"}return}
        if(d.type==="delta"){asst.content+=d.text;renderLast(asst)}
        // The runner died and the turn starts over: forget the dead attempt's words
        // and steps, or the new attempt's reply lands under them a second time.
        else if(d.type==="restart"){if(asst.trail){delete trails[asst.trail];asst.trail=null}asst.content="";asst.edits=[];asst.steps=[];asst.searchOpen={};asst.editingNote=false;asst.proposed=null;opsSeen=0;screenshotReq=null;retryUnsafe=false;asst.status=d.text||"Picked up again";renderLast(asst)}
        else if(d.type==="status"){if(d.text){asst.status=String(d.text);tick()}}
        else if(d.type==="step"){asst.status="Working — step "+d.n+(d.max?" of "+d.max:"");tick()}
        else if(d.type==="effect"){if(d.replay_safe===false)retryUnsafe=true}
        else if(d.type==="tool"){
          if(!asst.steps)asst.steps=[];
          if(d.tool==="fetch")asst.steps.push({t:"fetch",integration:d.integration,method:d.method,url:d.url,query:d.query,pending:true});
          else if(d.tool==="list_integrations")asst.steps.push({t:"list"});
          renderLast(asst);
        }
        else if(d.type==="result"){
          // Parallel calls finish in any order: a result marks the pending row with its
          // url, else the oldest pending one (it used to mark only the last row, so five
          // of six parallel searches read as still running).
          if(asst.steps&&asst.steps.length){var st=null,si;for(si=0;si<asst.steps.length&&!st;si++){var sp=asst.steps[si];if(sp.pending&&d.url&&sp.url===d.url)st=sp}for(si=0;si<asst.steps.length&&!st;si++){if(asst.steps[si].pending)st=asst.steps[si]}if(!st)st=asst.steps[asst.steps.length-1];st.pending=false;st.ok=d.ok;st.status=d.status;st.error=d.error}
          renderLast(asst);
        }
        else if(d.type==="comment"){
          if(!asst.steps)asst.steps=[];
          asst.steps.push({t:"comment",label:(d.action==="resolve"?"resolved a comment":"replied to a comment"),ok:d.ok!==false,error:d.error});
          renderLast(asst);
        }
        else if(d.type==="screenshot"){screenshotReq={anchor:d.anchor||null,selector:d.selector||null}}
        else if(d.type==="op"){
          opsSeen++;asst.editingNote=true;
          // Someone else's ops reach this page as the commit's patch broadcast; applying
          // them here too would insert them twice (insert-after and friends don't dedupe).
          // The edits are still recorded — the bubble lists them.
          if(d.matched){asst.edits.push({op:d.op,anchor:d.anchor,html:d.html,old:d.old||null});if(!asst.foreign&&window.ssPatchDoc)window.ssPatchDoc([{op:d.op,anchor:d.anchor,html:d.html,old:d.old||null}],null)}
          renderLast(asst);
        }
        else if(d.type==="done"){finish(d)}
        else if(d.type==="error"){fail(d.message||"Something went wrong.",d.retryable===true)}
      }
      // The socket was down for a while: whatever this turn did meanwhile is on
      // its row — its ending included.
      function reconcile(){
        if(streamDone)return;
        fetch("/api/space/"+spaceId+"/ai/runs/"+encodeURIComponent(run.id)).then(function(r){return r.ok?r.json():null}).then(function(d){
          if(streamDone||!d||!d.run)return;
          var r=d.run;
          if(r.status==="done"&&r.result){if(r.reply)asst.content=r.reply;finish(r.result,true)}
          else if(r.status==="failed"||r.status==="cancelled")fail(r.error||"Something went wrong.",r.status==="failed");
        }).catch(function(){});
      }
      watchers[run.id]={handle:handle,reconcile:reconcile};
      var q=early[run.id];if(q){delete early[run.id];q.forEach(handle)}
      // The socket is the fast path, not the only one: a half-open socket, or a
      // reconnect whose read beat the row's settle, drops the ending and leaves the
      // bubble working for good. Fifteen quiet seconds and the row is asked instead.
      if(!streamDone)quiet=setInterval(function(){if(streamDone){clearInterval(quiet);return}tick();if(Date.now()-heard>=15000){heard=Date.now();reconcile()}},5000);
      renderLast(asst);
    }
    // Start a chat/verify turn. allowVerify lets a screenshot request at the end of
    // this turn spawn one more verify turn (bounded by depth).
    function runStream(payload,asst,allowVerify,prePushed,sentFiles,item){
      var pushed=!!prePushed;
      var tmS=payload&&!payload.verify?{sent:Date.now(),queued:!!(item&&item.at)}:null;
      function failEarly(message,retryable){
        pauseQueue();setBusy(false);asst.streaming=false;asst.editingNote=false;asst.retrying=false;
        asst.content=(asst.content?asst.content+"\n\n":"")+"⚠️ "+message;
        asst.retry=retryable?{payload:payload,allowVerify:allowVerify}:null;
        asst.others=payload&&!asst.foreign?{payload:payload,allowVerify:allowVerify,list:otherModels(payload,message)}:null;
        if(!pushed){history.push(asst);pushed=true}
        syncSend();render();
      }
      var inFlight=true;posting++;
      function landed(){if(inFlight){inFlight=false;posting--}if(!posting)early={}}
      // Words typed on the page and not saved yet are saved first, so the turn reads
      // the page as it is on screen (window.ssEditFlush, the viewer's edit mode). On
      // 2026-10-11 a send could beat the autosave's 2 s pause and edit the version
      // before. The line under the ask says so only when the save takes a moment.
      var flush=window.ssEditFlush?window.ssEditFlush(8000,"co-shepherd"):null;
      if(!flush){post();return}
      var slowT=setTimeout(function(){savingFirst=true;render()},250);
      flush.then(function(){clearTimeout(slowT);if(savingFirst){savingFirst=false;render()}post()});
      function post(){
      if(window.ssFastOnly&&payload&&typeof payload==="object")payload.fast_only=true;
      if(window.ssNoThink&&payload&&typeof payload==="object")payload.no_think=true;
      fetch("/api/space/"+spaceId+"/ai/chat",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)})
        .then(function(r){
          return r.text().then(function(t){
            var d=null;try{d=JSON.parse(t)}catch(e){}
            if(r.status===409&&d&&d.error==="turn_held"&&item){
              // The turn was taken between our look and our send. Not a refusal: the
              // message goes back to the front of the line and waits for the holder,
              // and the bubbles it had drawn come back out of the thread.
              var hq=d.holder||null;if(hq)hq.expires_at=hq.expires_at||new Date(Date.now()+120000).toISOString();
              var kq=history.indexOf(asst);if(kq>=0)history.splice(kq,1);
              var lq=history.length-1;if(lq>=0&&history[lq].role==="user"&&!history[lq].runId&&history[lq].content===(payload.message||filesPlaceholder(sentFiles||[])))history.splice(lq,1);
              asst.streaming=false;
              item.at=item.at||Date.now();queue.unshift(item);saveQueue();
              // A refusal that names nobody can't be waited on: look again shortly.
              if(!hq)qHold=Date.now()+5000;
              landed();setTurn(hq);setBusy(false);
              if(window.mixpanel)mixpanel.track("AI Chat Turn Refused",{space_id:spaceId,surface:"viewer",holder_surface:hq?hq.surface:null,queued:true});
              if(hq)followTurn(hq);render();return;
            }
            if(r.status===409&&d&&d.error==="turn_held"){
              // Nothing was sent. Take the words back out of the thread and into the
              // box, and show who holds the turn. The reply row is only in the thread
              // on a retry (prePushed); the ask is there on every send.
              if(payload.message)textEl.value=payload.message;
              // The files were never claimed, so they go back to the composer as they were.
              if(sentFiles&&sentFiles.length&&!pending.length){pending=sentFiles.map(function(f){return{key:f.key,name:f.name,media_type:f.media_type,kind:f.kind,size:f.size,url:null}});renderPending()}
              setBusy(false);asst.streaming=false;
              var k=history.indexOf(asst);if(k>=0)history.splice(k,1);
              var shownAsk=payload.message||(sentFiles&&sentFiles.length?filesPlaceholder(sentFiles):"");
              var u=history.length-1;if(u>=0&&shownAsk&&history[u].role==="user"&&history[u].content===shownAsk)history.splice(u,1);
              var h=d.holder||null;if(h)h.expires_at=h.expires_at||new Date(Date.now()+120000).toISOString();
              // My own turn, from another tab: followTurn stays out of it (there is
              // nothing of mine to follow twice) and the strip alone would look like
              // the composer locked itself. Say it in the thread, and drop the line
              // again on the next send — it is a notice, not a message.
              if(h&&h.seed===ME)history.push({role:"assistant",content:"⚠️ Your last ask is still running. Send again when it finishes.",edits:[],transient:true});
              if(window.mixpanel)mixpanel.track("AI Chat Turn Refused",{space_id:spaceId,surface:"viewer",holder_surface:h?h.surface:null});
              landed();setTurn(h);if(h)followTurn(h);render();return;
            }
            if(d&&d.error==="no_key"&&d.no_model){
              // No model left (a plan allowance ran out since the panel loaded):
              // nothing was sent, so the words go back in the box — never the queue,
              // which sits hidden with the composer — and the composer gives way to
              // the reason. They are there to send when it frees up.
              var kn=history.indexOf(asst);if(kn>=0)history.splice(kn,1);
              var shownN=payload.message||(sentFiles&&sentFiles.length?filesPlaceholder(sentFiles):"");
              var un=history.length-1;if(un>=0&&shownN&&history[un].role==="user"&&!history[un].runId&&history[un].content===shownN)history.splice(un,1);
              asst.streaming=false;
              if(payload.message)textEl.value=textEl.value?payload.message+"\n\n"+textEl.value:payload.message;
              if(sentFiles&&sentFiles.length&&!pending.length){pending=sentFiles.map(function(f){return{key:f.key,name:f.name,media_type:f.media_type,kind:f.kind,size:f.size,url:null}});renderPending()}
              holdBox();heldRestored=true;
              if(window.mixpanel)try{mixpanel.track("AI Chat Message Held",{space_id:spaceId,timed:!!(d.no_model.when&&d.no_model.when.at),files:sentFiles?sentFiles.length:0})}catch(x){}
              if(cfg)cfg.available=false;
              landed();setBusy(false);showNoModel(d.no_model);renderQueue();render();return;
            }
            if(!r.ok||!d||!d.run){
              var msg="Something went wrong.";
              if(d&&d.message)msg=d.message;else if(d&&d.error)msg=String(d.error);else if(t&&t.trim())msg=t.trim().split("\n")[0].slice(0,200);
              landed();failEarly(msg,isTransientChatStatus(r.status));return;
            }
            if(!pushed){history.push(asst);pushed=true}
            // The held message is out: it is in the thread now, not waiting.
            var held=readHeld();
            if(held&&payload.message&&payload.message===held.text){dropHeld();if(window.mixpanel)try{mixpanel.track("AI Chat Held Message Sent",{space_id:spaceId,waited_ms:Date.now()-held.at})}catch(x){}}
            if(tmS){tmS.accepted=Date.now();asst.tm=tmS}
            watchTurn(d.run,payload,asst,allowVerify);landed();
            render();
          });
        }).catch(function(){landed();failEarly("Network error.",true)});
      }
    }
    // A turn still running from before this page loaded (the tab was closed, or
    // the reader came back): show it live, from where its row says it is.
    function resumeTurn(run){
      if(!run||run.status!=="running"||watchers[run.id])return;
      expireChatRetries();
      // The ask joined the thread when the turn was taken, so a panel that loaded
      // mid-turn already drew it from there (loadConfig) — keyed on the run, the
      // same way followTurn checks. A reader's turn holds no turn, so this is the
      // only place their ask reaches a panel that opened mid-run; without the check
      // the room showed it twice under one reply.
      var hasAsk=history.some(function(m){return m.role==="user"&&m.runId===run.id});
      // Not mine: it shows as their message and a reply addressed to them, and none
      // of the author-only follow-ups (verify, retry, patch commits) are ours to run.
      if(run.seed&&run.seed!==ME){
        if(!hasAsk&&!run.verify)history.push({role:"user",content:run.ask,seed:run.seed,name:run.name,picture:run.picture,surface:run.comment?"comment":"viewer",runId:run.id});
        var fa={role:"assistant",content:run.reply||"",edits:[],streaming:true,to:run.name,runId:run.id,foreign:true,steps:run.verify?[{t:"shot",pending:false,ok:true}]:[]};
        if(run.comment){fa.comment=true;fa.commentRoot=run.comment_root||null;markComment(run.id,run.comment_root)}
        history.push(fa);watchTurn(run,null,fa,false);
        (run.events||[]).forEach(function(ev){if(ev.type!=="done"&&ev.type!=="error")watchers[run.id]&&watchers[run.id].handle(ev)});
        render();return;
      }
      // My own ask: the same run key, and the older text match as a fallback for a
      // row the session pushed itself before it had a run id.
      var last=history[history.length-1];
      if(!run.verify&&!hasAsk&&!(last&&last.role==="user"&&last.content===run.ask))history.push({role:"user",content:run.ask,runId:run.id});
      var asst={role:"assistant",content:run.reply||"",edits:[],streaming:true,steps:run.verify?[{t:"shot",pending:false,ok:true}]:[]};
      if(run.comment){asst.comment=true;asst.commentRoot=run.comment_root||null;markComment(run.id,run.comment_root)}
      history.push(asst);setBusy(true);
      if(run.nonce){window.__ssAiNonce=run.nonce;window.__ssPatchMissed=false}
      watchTurn(run,null,asst,(window.__ssVerifyDepth||0)<2);
      (run.events||[]).forEach(function(ev){if(ev.type!=="done"&&ev.type!=="error")watchers[run.id]&&watchers[run.id].handle(ev)});
      render();
    }

    // The ask that produced this reply — it names the version in the history
    // dropdown, so "Add a pricing table" beats a generic "AI edit".
    function askFor(m){
      var i=history.indexOf(m);
      for(var j=i-1;j>=0;j--)if(history[j].role==="user")return history[j].content||"";
      return "";
    }

    function applyEdit(m,btn){
      if(!m.proposed)return;btn.disabled=true;btn.textContent="Applying…";
      fetch("/api/space/"+spaceId+"/ai/apply",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({html:m.proposed,version_name:askFor(m)})})
        .then(function(r){return r.json().then(function(d){return{ok:r.ok,d:d}})})
        .then(function(res){
          if(res.ok){m.applied=true;render();reloadContent(res.d.sha);if(window.mixpanel)mixpanel.track("AI Edit Applied",{space_id:spaceId})}
          else{btn.disabled=false;btn.textContent="Apply to document";ssAsk({title:"Couldn’t apply the change",lede:(res.d&&res.d.message)||"",cancel:false})}
        }).catch(function(){btn.disabled=false;btn.textContent="Apply to document"});
    }
  })();
  // The composer's arrival: the panel opens with the ask already in the thread and
  // the build's reply on its way (window.__ssWantChat, set where the flag is read).
  if(window.__ssWantChat&&typeof window.ssChatAsk==="function"&&!window.matchMedia("(max-width: 640px)").matches)setTimeout(function(){window.ssChatAsk()},300);
  